(function(){
'use strict';
/* --- PriceDex SEO base — Shopify App Proxy path (/apps/kaarten/...) zodat
   share-URLs en pushState-URLs op cardworld.be werken (i.p.v. /kaarten/... wat
   404 gaf op Shopify). EN/FR varianten kunnen later via aparte app-proxy
   subpaths worden toegevoegd; nu enkel NL via /apps/kaarten. --- */
var CWCR_PD_BASE='/apps/kaarten';
/* --- Cache version bust: clears all cwcr- sessionStorage keys on version change ---
   Bump dit getal bij elke wijziging die client cache moet wissen.
   v8: sets-lijst zit niet meer in sessionStorage (zie loadPokemonSets/loadOnePieceSets),
       dus nieuwe sets verschijnen voortaan altijd binnen 5 min na een server-refresh
       zonder dat dit getal hoeft te bumpen. */
var CWCR_CACHE_VER='15';
/* --- Pokemon prijs: NM Lowest first (echte koopprijs vandaag op Cardmarket).
       Fallback chain als NM ontbreekt: averageSellPrice → trendPrice → avg30/7/1 → 0.
       Reden: NM Lowest matcht wat klant écht betaalt; averageSellPrice is rolling avg
       die soms maanden achterloopt (bv. Charizard VMAX SV107: avg €0.81 vs NM €108). --- */
function cwcrCmPrice(cp){
  if(!cp) return 0;
  return cp.lowestNearMint || cp.averageSellPrice || cp.trendPrice || cp.avg30 || cp.avg7 || cp.avg1 || 0;
}
try{var _cv=sessionStorage.getItem('cwcr-cache-ver');if(_cv!==CWCR_CACHE_VER){var _td=[];for(var _ci=0;_ci<sessionStorage.length;_ci++){var _ck=sessionStorage.key(_ci);if(_ck&&_ck.startsWith('cwcr-'))_td.push(_ck);}_td.forEach(function(k){sessionStorage.removeItem(k);});sessionStorage.setItem('cwcr-cache-ver',CWCR_CACHE_VER);}}catch(e){}
var tabsEl=document.getElementById('cwcr-tabs');
var setSearch=document.getElementById('cwcr-unified-search');
var setsLoading=document.getElementById('cwcr-sets-loading');
var chipsOuter=document.getElementById('cwcr-set-chips-outer');
var chipsEl=document.getElementById('cwcr-set-chips');
var soonEl=document.getElementById('cwcr-soon-placeholder');
var filtersEl=document.getElementById('cwcr-filters');
var filterMin5=document.getElementById('cwcr-filter-min5');
var filterAllRar=document.getElementById('cwcr-filter-all-rarities');
var shopStripEl=document.getElementById('cwcr-shop-strip');
var shopScrollEl=document.getElementById('cwcr-shop-scroll');
var shopAllLink=document.getElementById('cwcr-shop-strip-all');
var shopTitleEl=document.getElementById('cwcr-shop-strip-title-text');
var stickyBarEl=document.getElementById('cwcr-sticky-bar');
var stickySetEl=document.getElementById('cwcr-sticky-set-name');
var stickyBtn=document.getElementById('cwcr-sticky-btn');
var stickyCloseBtn=document.getElementById('cwcr-sticky-close');
var stickyDismissed=false;
var gridSection=document.getElementById('cwcr-grid-section');
var popupOverlay=document.getElementById('cwcr-popup-overlay');
var popupEl=document.getElementById('cwcr-popup');
var popupGrid=document.getElementById('cwcr-popup-grid');
var popupTitleEl=document.getElementById('cwcr-popup-title-text');
var popupSubEl=document.getElementById('cwcr-popup-sub');
var popupClose=document.getElementById('cwcr-popup-close');
var popupAvailRadios=document.querySelectorAll('input[name="cwcr-popup-avail"]');
var popupSortList=document.getElementById('cwcr-popup-sort-list');
var popupPriceMinEl=document.getElementById('cwcr-popup-price-min');
var popupPriceMaxEl=document.getElementById('cwcr-popup-price-max');
var popupTypeGroup=document.getElementById('cwcr-popup-type-group');
var popupTypeListEl=document.getElementById('cwcr-popup-type-list');
var popupAllProducts=[];
var popupCurrentSetLabel='';
var popupCurrentSort='match';
var popupSelectedTypes=[];
var popupSearchQuery='';
var unifiedSearch=document.getElementById('cwcr-unified-search');
var unifiedTyping=document.getElementById('cwcr-unified-typing');
var unifiedBtn=document.getElementById('cwcr-unified-search-btn');
var grid=document.getElementById('cwcr-chase-img-grid');
var chaseLoading=document.getElementById('cwcr-chase-loading');
var emptyStateEl=document.getElementById('cwcr-empty-state');
var countEl=document.getElementById('cwcr-chase-count');
var rarityCountsWrap=document.getElementById('cwcr-rarity-counts-wrap');
var rarityCountsEl=document.getElementById('cwcr-rarity-counts');
var sidebarEl=document.getElementById('cwcr-sidebar');
var sidebarInnerEl=document.getElementById('cwcr-sidebar-inner');
var sidebarToggleEl=document.getElementById('cwcr-sidebar-toggle');
var sidebarResetEl=document.getElementById('cwcr-sidebar-reset');
var sidebarCountEl=document.getElementById('cwcr-sidebar-active-count');
var sidebarCountDesktop=document.getElementById('cwcr-sidebar-active-count-desktop');
var rarPkEl=document.getElementById('cwcr-rar-pk');
var rarOpEl=document.getElementById('cwcr-rar-op');
var colorsGroupEl=document.getElementById('cwcr-sidebar-colors');
var typesGroupEl=document.getElementById('cwcr-sidebar-cardtypes');
if(typeof franchiseConfig==='undefined')var franchiseConfig={pokemon:{},onepiece:{}};
var activeFranchise=null;
var activeSetId=null;
var activeSetName='';
/* Bijwerktijd van de prijsdata: standaard voor iedereen zichtbaar. ?data=0 verbergt hem in deze browser,
   ?data=1 zet hem weer aan. De server stuurt per set de cachetijd mee als header X-Cw-Updated. */
var cwcrToonUpdate=(function(){try{var p=new URLSearchParams(window.location.search);var v=p.get('data');if(v==='0'){localStorage.setItem('cwcr-toon-update','0');return false;}if(v==='1'){localStorage.removeItem('cwcr-toon-update');return true;}return localStorage.getItem('cwcr-toon-update')!=='0';}catch(e){return true;}})();
function cwcrZetUpdate(iso){
  var el=document.getElementById('cwcr-data-update');
  if(!cwcrToonUpdate||!iso){ if(el) el.hidden=true; return; }
  var d=new Date(iso); if(isNaN(d.getTime())){ if(el) el.hidden=true; return; }
  // In de gele set-kop (rechts, buiten de knop), anders als terugval in de hero
  var kop=document.querySelector('#cwcr-grid-section .cwcr-section-toggle-wrap');
  var hero=kop||document.querySelector('.cwcr-hero'); if(!hero) return;
  if(el&&el.parentNode!==hero){ el.parentNode.removeChild(el); el=null; }
  if(!el){ el=document.createElement('div'); el.id='cwcr-data-update'; el.className='cwcr-data-update'+(kop?' cwcr-data-update--kop':''); el.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span class="cwcr-data-update-lbl"></span><b></b>'; hero.appendChild(el); }
  var loc=window.CWPD_LOC||'nl';
  var lbl={nl:'Prijzen bijgewerkt',en:'Prices updated',fr:'Prix mis \u00e0 jour'}[loc]||'Prijzen bijgewerkt';
  var tag={nl:'nl-BE',en:'en-GB',fr:'fr-BE'}[loc]||'nl-BE';
  var txt=d.toLocaleDateString(tag,{weekday:'short',day:'numeric',month:'short',timeZone:'Europe/Brussels'})+', '+d.toLocaleTimeString(tag,{hour:'2-digit',minute:'2-digit',timeZone:'Europe/Brussels'});
  el.querySelector('.cwcr-data-update-lbl').textContent=lbl; el.querySelector('b').textContent=txt; el.title=d.toISOString(); el.hidden=false;
}
/* Tijd ontbreekt (kaartdata uit een oude sessie- of browser-cache zonder header): apart ophalen met een
   lichte HEAD die de cache omzeilt, en in de sessie-cache bijschrijven zodat het daarna niet meer hoeft. */
function cwcrHaalUpdate(url, ck, obj, setId){
  if(!cwcrToonUpdate) return;
  fetch(url,{method:'HEAD',cache:'no-store'}).then(function(r){
    var u=null; try{ u=r.headers.get('X-Cw-Updated'); }catch(e){}
    if(!u) return;
    /* Enkel de pil bijwerken als deze set nog open staat (snel wisselen van set). */
    if(setId==null || activeSetId===setId) cwcrZetUpdate(u);
    if(ck&&obj){ try{ obj.updatedAt=u; sessionStorage.setItem(ck,JSON.stringify(obj)); }catch(e){} }
  }).catch(function(){});
}
var allSets=[];
var cwcrSetsCache={ pokemon: [],onepiece: [] };
var allCards=[];
var cwcrLastFilteredCount=0;
var cwcrCardRegistry={};
var allBulkCards=[];
var bulkSortByPrice=false;

/* ──────────────────────────────────────────────────────────────
   Chunked card grid renderer
   Op zwakke devices was 'grid.innerHTML = html' met 200-400 kaarten
   een 800ms-2s main-thread freeze. Render eerste 60 direct (above
   the fold dekkend), rest in requestIdleCallback chunks van 60.
   ────────────────────────────────────────────────────────────── */
var CWCR_CHUNK_SIZE = 60;
var _cwcrChunkToken = 0;
function cwcrRenderChunked(targetGrid, items, buildHTML){
  if(!targetGrid) return;
  _cwcrChunkToken++;
  var token = _cwcrChunkToken;
  targetGrid.style.display = '';
  if(!items.length){ targetGrid.innerHTML = ''; return; }
  // Eerste batch synchroon zodat boven-de-fold ogenblikkelijk zichtbaar is
  var firstN = Math.min(CWCR_CHUNK_SIZE, items.length);
  var html = '';
  for(var i=0; i<firstN; i++) html += buildHTML(items[i], i);
  targetGrid.innerHTML = html;
  if(items.length <= CWCR_CHUNK_SIZE) return;
  // Rest in idle-callback chunks
  var idx = firstN;
  var schedule = (typeof requestIdleCallback === 'function')
    ? function(fn){ return requestIdleCallback(fn, { timeout: 250 }); }
    : function(fn){ return setTimeout(fn, 16); };
  function step(){
    if(token !== _cwcrChunkToken) return; // nieuwere render heeft over genomen
    var end = Math.min(idx + CWCR_CHUNK_SIZE, items.length);
    var chunk = '';
    for(var j=idx; j<end; j++) chunk += buildHTML(items[j], j);
    targetGrid.insertAdjacentHTML('beforeend', chunk);
    idx = end;
    if(idx < items.length) schedule(step);
  }
  schedule(step);
}
var currentCounts=null;
var sidebarSort='price-desc';
var sidebarPriceMin=0;
var sidebarRarities={};
var sidebarColors={};
var sidebarCardTypes= {};
function esc(s){
return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}
// ─── Gedeelde kaart-image resolver + render (audit: 22% kaarten miste image) ──────
// Eén bron voor ALLE grids (chase/bulk/cross-search) + detail-modal, zodat:
//  - kaarten zonder cache-image toch een ECHTE afbeelding krijgen via een
//    deterministische fallback-URL (PK: pokemontcg.io uit card.id; OP: limitlesstcg)
//  - elke <img> een onerror-cascade heeft (geen broken-image glyph meer)
//  - kaarten zonder enkele bron een nette placeholder tonen i.p.v. eeuwig shimmeren
// Geeft { src, fallbacks:[...] } terug; fallbacks worden in volgorde geprobeerd.
function cwcrResolveCardImg(c, fr){
  var isOp = (fr === 'onepiece' || fr === 'onepiece-bulk');
  if(isOp){
    var apiImg = c.image_url || c.image || c.card_image || c.img || c.picture ||
      (c.images && (c.images.en || c.images.ja || c.images.url)) || '';
    var cardId = c.card_id || c.id || '';
    if(!cardId && apiImg){ var m=apiImg.match(/\/([A-Z]{2,4}\d+-\d+)(?:_|\.)/i); if(m) cardId=m[1].toUpperCase(); }
    var ltUrl = '';
    if(cardId){
      var setFolder = cardId.split('-')[0].replace(/^([A-Za-z]+)(\d+)$/, function(_,l,n){ return l.toLowerCase()+'-'+n; });
      ltUrl = 'https://limitlesstcg.nyc3.cdn.digitaloceanspaces.com/op/' + setFolder + '/' + cardId + '_EN.webp';
    }
    var fbLt = cardId ? 'https://limitlesstcg.nyc3.cdn.digitaloceanspaces.com/op/' + cardId.split('-')[0].toLowerCase() + '/' + cardId + '_EN.webp' : '';
    var primary = apiImg || ltUrl || '';
    var fbs = [ltUrl, fbLt, apiImg].filter(function(u){ return u && u !== primary; });
    return { src: primary, fallbacks: fbs };
  }
  // Pokemon: cache-image eerst, daarna deterministische pokemontcg.io fallback uit id.
  // card.id bv "sm7-1" -> https://images.pokemontcg.io/sm7/1.png (live geverifieerd).
  var pkImg = (c.images && (c.images.small || c.images.large)) || c.image_url || c.image || '';
  var ptcg = '';
  var pid = c.id || '';
  if(pid && pid.indexOf('-') > -1){
    var i = pid.lastIndexOf('-');
    var prefix = pid.slice(0, i), num = pid.slice(i+1);
    if(prefix && num) ptcg = 'https://images.pokemontcg.io/' + prefix + '/' + num + '.png';
  }
  var pkPrimary = pkImg || ptcg || '';
  var pkFbs = [ptcg].filter(function(u){ return u && u !== pkPrimary; });
  return { src: pkPrimary, fallbacks: pkFbs };
}
// Bouwt de volledige image-HTML voor een grid-cel: <img> met onload/onerror-cascade,
// of een placeholder als er geen enkele bron is. De onerror loopt de fallbacks af en
// stopt altijd de shimmer (cwcr-img-loaded) zodat niks eeuwig blijft laden.
function cwcrCardImgHtml(c, fr, altName){
  var r = cwcrResolveCardImg(c, fr);
  var alt = esc(altName || '');
  if(!r.src){
    // Geen enkele bron -> placeholder, GEEN shimmer (markeer wrap direct als loaded).
    return '<div class="cwcr-img-fallback" aria-hidden="true"><span class="cwcr-img-fallback-name">' + alt + '</span></div>';
  }
  var fbJson = esc(JSON.stringify(r.fallbacks || []));
  return '<img src="' + esc(r.src) + '" alt="' + alt + '" loading="lazy" decoding="async"' +
    ' data-fb="' + fbJson + '"' +
    ' onload="this.closest(\'.cwcr-img-loading\').classList.replace(\'cwcr-img-loading\',\'cwcr-img-loaded\')"' +
    ' onerror="cwcrImgError(this)">';
}
// onerror-handler: probeer de volgende fallback-URL; bij uitputting -> placeholder + stop shimmer.
window.cwcrImgError = function(img){
  try{
    var fbs = []; try{ fbs = JSON.parse(img.getAttribute('data-fb') || '[]'); }catch(e){}
    var i = parseInt(img.dataset.fbi || '0', 10);
    if(i < fbs.length){ img.dataset.fbi = String(i+1); img.src = fbs[i]; return; }
    var wrap = img.closest('.cwcr-img-loading') || img.parentNode;
    if(wrap){ wrap.classList && wrap.classList.replace('cwcr-img-loading','cwcr-img-loaded'); }
    img.style.display = 'none';
    if(img.parentNode && !img.parentNode.querySelector('.cwcr-img-fallback')){
      var ph = document.createElement('div'); ph.className = 'cwcr-img-fallback'; ph.setAttribute('aria-hidden','true');
      var sp = document.createElement('span'); sp.className = 'cwcr-img-fallback-name'; sp.textContent = img.alt || '';
      ph.appendChild(sp); img.parentNode.appendChild(ph);
    }
  }catch(e){}
};
// Detail-modal hero image zetten met dezelfde resolver + fallback-cascade als de grids.
function cwcrSetModalImg(imgEl, card, fr, altName){
  if(!imgEl) return;
  var r = cwcrResolveCardImg(card, fr);
  imgEl.alt = altName || '';
  imgEl.style.display = '';
  var queue = r.fallbacks ? r.fallbacks.slice() : [];
  imgEl.onerror = function(){
    if(queue.length){ imgEl.src = queue.shift(); return; }
    imgEl.onerror = null; imgEl.removeAttribute('src'); imgEl.style.display = 'none';
  };
  if(r.src){ imgEl.style.display = ''; imgEl.src = r.src; }
  else { imgEl.onerror = null; imgEl.removeAttribute('src'); imgEl.style.display = 'none'; }
}
var CWCR_BASE_URL=(typeof cwcrApiUrl!=='undefined'&&cwcrApiUrl)?cwcrApiUrl:'https://admin.cardworld.be';
var CWCR_TRACK_URL=CWCR_BASE_URL+'/api/track';
function cwcrTrack(type,data){
try {
var payload=Object.assign({ type: type },data || {});
if(typeof cwcrCustomer!=='undefined'&&cwcrCustomer) payload.customer=cwcrCustomer;
fetch(CWCR_TRACK_URL,{
method: 'POST',headers: { 'Content-Type': 'application/json' },body: JSON.stringify(payload),keepalive: true,}).catch(function(){});
} catch(e){}
}
// Fallback: hydrateer cwcrCustomer via Shopify globals als Liquid geen klant heeft gezet
// (bv. bij pagina-cache of inlog na page load)
setTimeout(function(){
try{
if(typeof cwcrCustomer!=='undefined'&&cwcrCustomer)return;
var sa=window.ShopifyAnalytics;
if(sa&&sa.meta&&sa.meta.customer){var c=sa.meta.customer;cwcrCustomer={id:String(c.id||''),email:c.email||'',name:((c.firstName||'')+' '+(c.lastName||'')).trim()};return;}
var sh=window.Shopify;
if(sh&&sh.customerId){cwcrCustomer={id:String(sh.customerId),email:'',name:''};return;}
// Probeer /account.json (Shopify AJAX API)
fetch('/account.json',{credentials:'include'}).then(function(r){return r.ok?r.json():null;}).then(function(d){if(d&&d.customer){cwcrCustomer={id:String(d.customer.id||''),email:d.customer.email||'',name:((d.customer.first_name||'')+' '+(d.customer.last_name||'')).trim()};}}).catch(function(){});
}catch(e){}
},400);
function formatPkSetId(id){
var m=(id || '').match(/^([a-z]+?)(\d+(?:\.\d+)?[a-z]?)$/i);
if(!m) return (id || '').toUpperCase();
return m[1].toUpperCase() + '-' + m[2];
}
var pkRarity={
'Special Illustration Rare': { label: 'Special Illustration Rare',cls: 'cwcr-badge-sir',pri: 1,abbr:'SIR' },'Special illustration rare': { label: 'Special Illustration Rare',cls: 'cwcr-badge-sir',pri: 1,abbr:'SIR' },'Hyper Rare':                { label: 'Hyper Rare',cls: 'cwcr-badge-hr',pri: 2,abbr:'HR' },'Hyper rare':                { label: 'Hyper Rare',cls: 'cwcr-badge-hr',pri: 2,abbr:'HR' },'ACE SPEC Rare':             { label: 'ACE SPEC',cls: 'cwcr-badge-hr',pri: 2,abbr:'ACE' },'Illustration Rare':         { label: 'Illustration Rare',cls: 'cwcr-badge-ir',pri: 3,abbr:'IR' },'Illustration rare':         { label: 'Illustration Rare',cls: 'cwcr-badge-ir',pri: 3,abbr:'IR' },'Ultra Rare':                { label: 'Ultra Rare',cls: 'cwcr-badge-ur',pri: 4,abbr:'UR' },'Ultra rare':                { label: 'Ultra Rare',cls: 'cwcr-badge-ur',pri: 4,abbr:'UR' },'Double Rare':               { label: 'Double Rare',cls: 'cwcr-badge-ur',pri: 5,abbr:'RR' },'Double rare':               { label: 'Double Rare',cls: 'cwcr-badge-ur',pri: 5,abbr:'RR' },'Black White Rare':          { label: 'Black White Rare',cls: 'cwcr-badge-ur',pri: 4,abbr:'BWR' },'Rare Holo':              { label: 'Rare Holo',cls: 'cwcr-badge-ir',pri: 6,abbr:'Holo' },'Rare Holo EX':           { label: 'Rare Holo EX',cls: 'cwcr-badge-ur',pri: 5,abbr:'EX' },'Rare Holo GX':           { label: 'Rare Holo GX',cls: 'cwcr-badge-ur',pri: 5,abbr:'GX' },'Rare Holo V':            { label: 'Rare Holo V',cls: 'cwcr-badge-ur',pri: 5,abbr:'V' },'Rare VMAX':              { label: 'Rare VMAX',cls: 'cwcr-badge-ur',pri: 4,abbr:'VMAX' },'Rare VSTAR':             { label: 'Rare VSTAR',cls: 'cwcr-badge-ur',pri: 4,abbr:'VSTAR' },'Amazing Rare':           { label: 'Amazing Rare',cls: 'cwcr-badge-ir',pri: 4,abbr:'AR' },'Radiant Rare':           { label: 'Radiant Rare',cls: 'cwcr-badge-ir',pri: 4,abbr:'RAD' },'Rare Rainbow':           { label: 'Rainbow Rare',cls: 'cwcr-badge-sir',pri: 2,abbr:'RBW' },'Rare Secret':            { label: 'Secret Rare',cls: 'cwcr-badge-sec',pri: 1,abbr:'SEC' },'Rare Ultra':             { label: 'Ultra Rare',cls: 'cwcr-badge-ur',pri: 4,abbr:'UR' },'Rare Prism Star':        { label: 'Prism Star Rare',cls: 'cwcr-badge-ir',pri: 3,abbr:'PRZ' },'Rare Shiny V':           { label: 'Shiny V Rare',cls: 'cwcr-badge-sar',pri: 2,abbr:'ShV' },'Rare Shiny Holo':        { label: 'Shiny Holo Rare',cls: 'cwcr-badge-ir',pri: 3,abbr:'Shiny' },'Rare BREAK':             { label: 'Rare BREAK',cls: 'cwcr-badge-ir',pri: 5,abbr:'BRK' },'Rare Prime':             { label: 'Rare Prime',cls: 'cwcr-badge-ur',pri: 5,abbr:'PRM' },'Rare Holo Star':         { label: 'Rare Holo Star',cls: 'cwcr-badge-hr',pri: 2,abbr:'Star' },'LEGEND':                 { label: 'LEGEND',cls: 'cwcr-badge-sec',pri: 1,abbr:'LGD' },'Rare Holo LV.X':         { label: 'Rare LV.X',cls: 'cwcr-badge-hr',pri: 2,abbr:'LV.X' },'Trainer Gallery Rare Holo': { label: 'Trainer Gallery Holo',cls: 'cwcr-badge-ir',pri: 3,abbr:'TG' },'Common':{ label:'Common',cls:'cwcr-badge-other',pri:9,abbr:'C' },'Uncommon':{ label:'Uncommon',cls:'cwcr-badge-other',pri:8,abbr:'UC' },'Rare':{ label:'Rare',cls:'cwcr-badge-ir',pri:7,abbr:'R' },'Promo':{ label:'Promo',cls:'cwcr-badge-sp',pri:3,abbr:'P' }
};
var opRarity={
'SEC': { label: 'Secret Rare',    cls: 'cwcr-badge-sec',   pri: 1, tier: 'top',   abbr: 'SEC' },
'SAR': { label: 'Special Art',    cls: 'cwcr-badge-sar',   pri: 2, tier: 'top',   abbr: 'SAR' },
'SP':  { label: 'SP',             cls: 'cwcr-badge-sp',    pri: 3, tier: 'chase', abbr: 'SP' },
'P':   { label: 'Promo',          cls: 'cwcr-badge-sp',    pri: 3, tier: 'chase', abbr: 'P' },
'SR':  { label: 'Super Rare',     cls: 'cwcr-badge-ur',    pri: 4, tier: 'sr',    abbr: 'SR' },
'L':   { label: 'Leader',         cls: 'cwcr-badge-ur',    pri: 5, tier: 'sr',    abbr: 'L' },
'R':   { label: 'Rare',           cls: 'cwcr-badge-ir',    pri: 6, tier: '',      abbr: 'R' },
'UC':  { label: 'Uncommon',       cls: 'cwcr-badge-other', pri: 8, tier: '',      abbr: 'UC' },
'C':   { label: 'Common',         cls: 'cwcr-badge-other', pri: 9, tier: '',      abbr: 'C' },
'DON': { label: 'DON!!',          cls: 'cwcr-badge-other', pri: 10, tier: '',     abbr: 'DON' },
/* Aliassen: de One Piece API geeft volledige rarity-namen i.p.v. de korte codes hierboven.
   Zonder deze aliassen vallen alle OP-kaarten terug op 'cwcr-badge-other' -> toonde overal OTH. */
'SECRET RARE':   { label: 'Secret Rare',   cls: 'cwcr-badge-sec', pri: 1,  tier: 'top', abbr: 'SEC' },
'Special Rare':  { label: 'Special Rare',  cls: 'cwcr-badge-sar', pri: 2,  tier: 'top', abbr: 'SPR' },
'Alternate Art': { label: 'Alternate Art', cls: 'cwcr-badge-sar', pri: 2,  tier: 'top', abbr: 'AA' },
'Treasure Rare': { label: 'Treasure Rare', cls: 'cwcr-badge-sar', pri: 2,  tier: 'top', abbr: 'TR' },
'Manga Rare':    { label: 'Manga Rare',    cls: 'cwcr-badge-sir', pri: 2,  tier: 'manga', abbr: 'MR' },
'SUPER RARE':    { label: 'Super Rare',    cls: 'cwcr-badge-ur',  pri: 4,  tier: 'sr',  abbr: 'SR' },
'LEADER':        { label: 'Leader',        cls: 'cwcr-badge-ur',  pri: 5,  tier: 'sr',  abbr: 'L' },
'rare':          { label: 'Rare',          cls: 'cwcr-badge-ir',  pri: 6,  tier: '',    abbr: 'R' },
'Rare':          { label: 'Rare',          cls: 'cwcr-badge-ir',  pri: 6,  tier: '',    abbr: 'R' },
'Uncommon':      { label: 'Uncommon',      cls: 'cwcr-badge-other', pri: 8,  tier: '',  abbr: 'UC' },
'Common':        { label: 'Common',        cls: 'cwcr-badge-other', pri: 9,  tier: '',  abbr: 'C' },
'DON!!':         { label: 'DON!!',         cls: 'cwcr-badge-other', pri: 10, tier: '',  abbr: 'DON' },
};
/* Badge-tekst: volledige naam (desktop) + korte afkorting (mobiel, via CSS).
   Beide staan in de DOM; CSS toont de juiste op basis van schermbreedte. De
   afkorting valt terug op het volledige label als er geen abbr is. */
function cwcrBadgeInner(info){
var full=info&&info.label?info.label:'';
var abbr=info&&info.abbr?info.abbr:cwcrAutoAbbr(full);
return '<span class="cwcr-badge-full">'+esc(full)+'</span><span class="cwcr-badge-abbr">'+esc(abbr)+'</span>';
}
/* Fallback-afkorting voor rarities die geen vaste abbr hebben: bij meerdere woorden
   de beginletters (max 4), anders de eerste 4 tekens. Voorkomt afkappen op mobiel. */
function cwcrAutoAbbr(label){
var s=String(label||'').trim();
if(!s)return '';
if(s.length<=4)return s;
var words=s.split(/\s+/);
if(words.length>1)return words.map(function(w){return w.charAt(0);}).join('').slice(0,4).toUpperCase();
return s.slice(0,4);
}
var opCmSets={
'OP-01': 'Romance-Dawn','OP-02': 'Paramount-War','OP-03': 'Pillars-of-Strength','OP-04': 'Kingdoms-of-Intrigue','OP-05': 'Awakening-of-the-New-Era','OP-06': 'Wings-of-the-Captain','OP-07': '500-Years-in-the-Future','OP-08': 'Two-Legends','OP-09': 'The-Four-Emperors','OP-10': 'Royal-Blood','OP-11': 'Sword-of-the-Sea','OP-12': 'Across-the-Seas','OP-13': 'Carrying-on-his-Will',};
function hideChaseLoading(){
if(chaseLoading) chaseLoading.style.display='none';
if(emptyStateEl) emptyStateEl.style.display='none';
}
function showEmptyState(){
if(emptyStateEl) emptyStateEl.style.display='';
if(gridSection) gridSection.style.display='none';
if(chaseLoading) chaseLoading.style.display='none';
}
function showChaseLoading(msg){
if(emptyStateEl) emptyStateEl.style.display='none';
if(gridSection){ gridSection.style.display=''; gridSection.classList.add('cwcr-visible'); }
if(!chaseLoading) return;
chaseLoading.style.display='';
var span=chaseLoading.querySelector('span');
if(span) span.textContent = msg || ((window.CWPD_I18N&&window.CWPD_I18N.chaseLoading)||'Chase cards ophalen...');
}
function initReveal(){
var els=document.querySelectorAll('.cwcr-reveal');
if(!els.length) return;
if('IntersectionObserver' in window){
var obs=new IntersectionObserver(function(entries){
entries.forEach(function(e){
if(e.isIntersecting){ e.target.classList.add('cwcr-visible'); obs.unobserve(e.target); }
});
},{ threshold: 0.08 });
els.forEach(function(el){ obs.observe(el); });
}else{
els.forEach(function(el){ el.classList.add('cwcr-visible'); });
}
}
initReveal();
// Force-unstick van nav ancestors gebeurt nu via CSS in cw-pricedex.liquid
// (was eerst JS met scroll listener + MutationObserver — veroorzaakte scroll-jank
// op trage devices door per-tick querySelectorAll + style writes).
// Eén keer toepassen voor edge case waar style attribute al door theme is gezet.
(function(){
  var NAV_SEL='.shopify-section-group-header-group,[class*="shopify-section-group"],#shopify-section-header,.shopify-section-header,.shopify-section--header,#cwh-wrap,.cwh-wrap,#cwh-header,.cwh-header,sticky-header,.sticky-header,[data-sticky],[data-sticky-nav],[id*="section-group-header"]';
  // Eénmalige run on DOMContentLoaded zodat inline style attributes overschreven worden
  // (CSS !important kan inline style verliezen op specifieke ancestors zonder dit).
  function unstickNavOnce(){
    document.querySelectorAll(NAV_SEL).forEach(function(el){
      el.style.setProperty('position','relative','important');
      el.style.setProperty('top','auto','important');
      el.style.setProperty('transform','none','important');
      el.style.setProperty('z-index','900','important');
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',unstickNavOnce,{once:true});
  }else{
    unstickNavOnce();
  }
})();
if(tabsEl){
tabsEl.addEventListener('click',function(e){
var btn=e.target.closest('.cwcr-tab');
if(!btn || btn.classList.contains('cwcr-tab-soon')) return;
var setRow=document.getElementById('cwcr-set-row');
var franchise=btn.dataset.franchise;
if(franchise===activeFranchise){
if(setRow) setRow.classList.toggle('cwcr-set-row-visible');
var nowVisible=setRow&&setRow.classList.contains('cwcr-set-row-visible');
if(!nowVisible){ btn.classList.remove('cwcr-tab-active'); btn.setAttribute('aria-selected','false'); activeFranchise=null; }
return;
}
if(setRow)setRow.classList.add('cwcr-set-row-visible');
cwcrTrack('franchise_switch',{ franchise: franchise });
tabsEl.querySelectorAll('.cwcr-tab').forEach(function(t){
t.classList.remove('cwcr-tab-active');
t.setAttribute('aria-selected','false');
});
btn.classList.add('cwcr-tab-active');
btn.setAttribute('aria-selected','true');
activeFranchise = franchise;
activeSetId=null;
activeSetName = '';
cwcrZetUpdate(null);
// Sync de search-dropdown met de gekozen franchise (tenzij user expliciet "alles" gekozen heeft)
if(typeof window.cwcrSyncFrDdToFranchise==='function')window.cwcrSyncFrDdToFranchise(franchise);
cwcrUpdateDdLabel();
if(cwcrDdMenu&&cwcrDdMenu.classList.contains('open'))cwcrBuildDdMenu();
allCards=[];
currentCounts=null;
updateSidebarCounts();
updateSidebarRarities();
var isOp=(franchise==='onepiece');
if(rarPkEl)    rarPkEl.style.display=isOp ? 'none' : '';
if(rarOpEl)    rarOpEl.style.display=isOp ? '' : 'none';
document.querySelectorAll('.cwcr-op-only').forEach(function(el){ el.style.display=isOp ? '' : 'none'; });
sidebarRarities={}; sidebarColors={}; sidebarCardTypes={};
sidebarPriceMin=0; sidebarPriceMax=0;
document.querySelectorAll('.cwcr-rar-filter,.cwcr-color-filter,.cwcr-type-filter').forEach(function(cb){ cb.checked=false; });
if(filterAllRar) filterAllRar.checked=true;
var sliderEl=document.getElementById('cwcr-price-slider');
if(sliderEl) sliderEl.value=0;
var sliderMaxEl=document.getElementById('cwcr-price-slider-max');
if(sliderMaxEl) sliderMaxEl.value=100;
var rwEl=document.getElementById('cwcr-range-wrap');
if(rwEl){rwEl.style.setProperty('--min-pct','0%');rwEl.style.setProperty('--max-pct','100%');}
if(priceMinInput) priceMinInput.value=0;
if(priceMaxInput) priceMaxInput.value = '';
sidebarSort = 'price-desc';
document.querySelectorAll('.cwcr-sort-btn').forEach(function(b){
b.classList.toggle('cwcr-sort-active',b.dataset.sort==='price-desc');
});
resetCardGrid();
resetShopHighlight();
renderActiveFilters();
loadSets(franchise);
loadFranchiseProducts(franchise);
var activeQ=unifiedSearch ? unifiedSearch.value.trim() : '';
if(activeQ.length>=2){
clearTimeout(unifiedTimer);
doCardSearch(activeQ);
}
});
}
function resetCardGrid(){
cwcrZetUpdate(null); // geen set meer in beeld: bijwerktijd weg tot de volgende set geladen is
if(grid){ grid.innerHTML = ''; grid.style.display='none'; }
if(countEl){ countEl.textContent = ''; countEl.style.display='none'; }
showEmptyState();
allBulkCards=[];
var bulkSection=document.getElementById('cwcr-bulk-section');
var bulkGrid=document.getElementById('cwcr-bulk-grid');
var bulkSubTog=document.getElementById('cwcr-bulk-sub-toggle');
if(bulkSection) bulkSection.style.display='none';
if(bulkSubTog) bulkSubTog.style.display='none';
if(bulkGrid) { bulkGrid.innerHTML=''; bulkGrid.style.display='none'; }
if(rarityCountsWrap) rarityCountsWrap.style.display='none';
if(rarityCountsEl) rarityCountsEl.innerHTML = '';
}
function resetShopHighlight(){
if(shopScrollEl){
shopScrollEl.querySelectorAll('.cwcr-shop-card').forEach(function(c){
c.classList.remove('cwcr-shop-match');
});
}
if(stickyBarEl) stickyBarEl.classList.remove('cwcr-show');
}
function resetFilters(){
if(filtersEl) filtersEl.classList.remove('cwcr-show');
if(filterMin5) filterMin5.checked=false;
if(filterAllRar) filterAllRar.checked=false;
}
function loadSets(franchise){
if(soonEl) soonEl.classList.remove('cwcr-show');
if(chipsEl) chipsEl.innerHTML = '';
if(chipsOuter) chipsOuter.style.display='none';
if(setsLoading) setsLoading.style.display='';
if(setSearch) setSearch.value = '';
sidebarRarities={}; sidebarColors={}; sidebarCardTypes={}; sidebarPriceMin=0;
document.querySelectorAll('.cwcr-rar-filter,.cwcr-color-filter,.cwcr-type-filter').forEach(function(cb){ cb.checked=false; });
var sliderReset=document.getElementById('cwcr-price-slider');
var priceValReset=document.getElementById('cwcr-price-val');
if(sliderReset){ sliderReset.value=0; sliderReset.style.setProperty('--pct','0%'); }
if(priceValReset) priceValReset.textContent = '\u20ac0';
allSets=[];
if(franchise==='pokemon'){
loadPokemonSets();
}else if(franchise==='onepiece'){
loadOnePieceSets();
}else{
if(setsLoading) setsLoading.style.display='none';
if(soonEl) soonEl.classList.add('cwcr-show');
}
}
function loadPokemonSets(){
/* Sets-lijst NIET in sessionStorage cachen: nieuwe sets moeten meteen
   verschijnen voor elke user zonder cache-bump. Server-cache (24u SWR)
   + HTTP cache (5 min) vangen de load op. */
fetch(CWCR_BASE_URL+'/api/tcg/pk-sets?v=2')
.then(function(r){return r.json();})
.then(function(data){
var sets=(data.data || []).map(function(s){
var label=(s.code ? s.code + ' - ' : '') + (s.name || s.id);
return{id:s.id,label:label,count:typeof s.card_count==='number'?s.card_count:-1};
});
allSets = sets;
renderSetChips(sets);
})
.catch(function(){
if(setsLoading){ setsLoading.style.display='none'; }
});
}
function loadOnePieceSets(){
/* Sets-lijst NIET in sessionStorage cachen: nieuwe sets moeten meteen
   verschijnen voor elke user zonder cache-bump. */
fetch(CWCR_BASE_URL+'/api/tcg/op-sets?v=2')
.then(function(r){return r.json();})
.then(function(data){
var sets=(Array.isArray(data) ? data : (data.sets || []))
.sort(function(a,b){
var ia=(a.set_id || a.id || ''),ib = (b.set_id || b.id || '');
return ib.localeCompare(ia);
})
.map(function(s){
var id=s.set_id || s.id || '';
var name=s.set_name || s.name || id;
return{id:id,label:id + ' - ' + name,count:typeof s.card_count==='number'?s.card_count:-1};
});
allSets = sets;
renderSetChips(sets);
})
.catch(function(){
if(setsLoading) setsLoading.style.display='none';
});
}
function renderSetChips(sets){
if(setsLoading) setsLoading.style.display='none';
if(!sets.length) return;
cwcrSetsCache[activeFranchise] = sets;
buildChips(sets);
renderSidebarSets(sets);
cwcrShowSetDd();
}
var cwcrDdEl=document.getElementById('cwcr-set-dd'),cwcrDdTrigger=document.getElementById('cwcr-set-dd-trigger'),cwcrDdMenu=document.getElementById('cwcr-set-dd-menu'),cwcrDdLabel=document.getElementById('cwcr-set-dd-label'),cwcrDdSearch=document.getElementById('cwcr-set-dd-search'),cwcrDdClear=document.getElementById('cwcr-set-dd-clear');
function cwcrShowSetDd(){if(cwcrDdEl)cwcrDdEl.style.display='';cwcrBuildDdMenu();}
function cwcrDdMakeItem(it){var item=document.createElement('div');var nocode=!it.code;var isEmpty=it.s.count===0;item.className='cwcr-set-dd-item'+(nocode?' cwcr-set-dd-item--nocode':'')+(it.s.id===activeSetId?' cwcr-dd-active':'')+(isEmpty?' cwcr-set-dd-item--empty':'');item.innerHTML=(nocode?'':'<span class="cwcr-set-dd-icode">'+esc(it.code)+'</span>')+'<span class="cwcr-set-dd-iname">'+esc(it.name)+'</span>';if(!isEmpty)item.addEventListener('click',function(){cwcrSelectFromDd(activeFranchise,it.s.id,it.s.label);});return item;}
function cwcrBuildDdMenu(){
if(!cwcrDdMenu)return;
var se=cwcrDdMenu.querySelector('.cwcr-set-dd-search');
Array.from(cwcrDdMenu.children).forEach(function(c){if(c!==se)cwcrDdMenu.removeChild(c);});
var q=((se&&se.value)||'').toLowerCase().trim();
var sets=cwcrSetsCache[activeFranchise]||[];
var filtered=q?sets.filter(function(s){return(s.label||'').toLowerCase().includes(q);}):sets;
if(!filtered.length){var _Tdd=window.CWPD_I18N||{};var e2=document.createElement('div');e2.className='cwcr-set-dd-empty';e2.textContent=sets.length?(_Tdd.noSets||'Geen sets gevonden'):(_Tdd.setsLoading||'Sets laden...');cwcrDdMenu.appendChild(e2);return;}
var items=filtered.map(function(s){var code='',name=s.label,di=s.label.indexOf(' - ');if(di>0){code=s.label.substring(0,di).trim();name=s.label.substring(di+3).trim();}
// Weergave-code zonder streepje (TCGGO is inconsistent: OP-16 vs OP15). De echte set-id
// (s.id) blijft ongemoeid voor de data-call; dit is puur cosmetisch zodat OP-16 als
// "OP16" toont en onder de juiste "OP"-groep valt i.p.v. een aparte "OP-" groep.
var dispCode=code.replace(/-/g,'');
return{s:s,code:dispCode,name:name,pfx:dispCode.replace(/\d+$/,'')};});
// Pokemon: tagged sets (with code) first, untagged (no code) below
var tagged=items.filter(function(it){return!!it.code;}).sort(function(a,b){return a.code.localeCompare(b.code);});
var untagged=items.filter(function(it){return!it.code;}).sort(function(a,b){return a.name.localeCompare(b.name);});
if(q){tagged.concat(untagged).forEach(function(it){cwcrDdMenu.appendChild(cwcrDdMakeItem(it));});return;}
// Lege sets (count===0) naar het einde sorteren binnen elke groep
var taggedFull=tagged.filter(function(it){return it.s.count!==0;});
var taggedEmpty=tagged.filter(function(it){return it.s.count===0;});
var untaggedFull=untagged.filter(function(it){return it.s.count!==0;});
var untaggedEmpty=untagged.filter(function(it){return it.s.count===0;});
function cwcrRenderGroup(list){var pfxCount={};list.forEach(function(it){pfxCount[it.pfx]=(pfxCount[it.pfx]||0)+1;});var lastPfx=null,grpEl=null,bodyEl=null;list.forEach(function(it){var useGroup=it.pfx!==it.code&&pfxCount[it.pfx]>=2;if(useGroup){if(it.pfx!==lastPfx){grpEl=document.createElement('div');grpEl.className='cwcr-set-dd-group';var gh=document.createElement('div');gh.className='cwcr-set-dd-gh';gh.innerHTML='<span>'+esc(it.pfx)+'</span><span class="cwcr-set-dd-ghc">&#x25BE;</span>';bodyEl=document.createElement('div');bodyEl.className='cwcr-set-dd-gbody';(function(g){gh.addEventListener('click',function(){g.classList.toggle('cwcr-dd-collapsed');});})(grpEl);grpEl.appendChild(gh);grpEl.appendChild(bodyEl);cwcrDdMenu.appendChild(grpEl);lastPfx=it.pfx;}bodyEl.appendChild(cwcrDdMakeItem(it));}else{lastPfx=null;grpEl=null;bodyEl=null;cwcrDdMenu.appendChild(cwcrDdMakeItem(it));}});}
cwcrRenderGroup(taggedFull);
if(untaggedFull.length&&taggedFull.length){var div=document.createElement('div');div.className='cwcr-set-dd-divider';cwcrDdMenu.appendChild(div);}
if(untaggedFull.length)cwcrRenderGroup(untaggedFull);
var allEmpty=taggedEmpty.concat(untaggedEmpty);
if(allEmpty.length){var divE=document.createElement('div');divE.className='cwcr-set-dd-divider';cwcrDdMenu.appendChild(divE);allEmpty.forEach(function(it){cwcrDdMenu.appendChild(cwcrDdMakeItem(it));});}
}
function cwcrUpdateDdLabel(){if(!cwcrDdLabel)return;if(activeSetId){var sets=cwcrSetsCache[activeFranchise]||[],found=null;for(var i=0;i<sets.length;i++){if(sets[i].id===activeSetId){found=sets[i];break;}}if(found){var di=found.label.indexOf(' - ');cwcrDdLabel.textContent=di>0?found.label.substring(di+3).trim():found.label;}else cwcrDdLabel.textContent=activeSetId;}else{var prefix=(typeof CWCR_I18N!=='undefined'&&CWCR_I18N.setChooseFor)||'Set kiezen voor';var fname=franchiseConfig[activeFranchise]?franchiseConfig[activeFranchise].name:'';cwcrDdLabel.textContent=activeFranchise&&fname?prefix+' '+fname:((typeof CWCR_I18N!=='undefined'&&CWCR_I18N.setChoose)||'Set kiezen...');}if(cwcrDdClear)cwcrDdClear.style.display=(activeSetId&&activeSetId!=='__all__')?'flex':'none';}
/* Wis de gekozen set en keer terug naar het franchise-overzicht (geen set actief). */
function cwcrClearSet(){
activeSetId=null;activeSetName='';allCards=[];allBulkCards=[];currentCounts=null;cwcrZetUpdate(null);
sidebarRarities={};sidebarColors={};sidebarCardTypes={};
cwcrCloseSetDd();
resetCardGrid();resetShopHighlight();resetFilters();
if(chipsEl)chipsEl.querySelectorAll('.cwcr-set-chip').forEach(function(c){c.classList.remove('cwcr-chip-active');});
var sbl=document.getElementById('cwcr-sidebar-set-list');if(sbl)sbl.querySelectorAll('.cwcr-sidebar-set-btn').forEach(function(b){b.classList.remove('cwcr-set-active');});
updateSidebarCounts();updateSidebarRarities();
cwcrUpdateDdLabel();cwcrBuildDdMenu();
renderSidebarSets(allSets);
renderActiveFilters();
cwcrTrack('set_clear',{franchise:activeFranchise||''});
}
if(cwcrDdClear){
cwcrDdClear.addEventListener('click',function(e){e.stopPropagation();e.preventDefault();cwcrClearSet();});
cwcrDdClear.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.stopPropagation();e.preventDefault();cwcrClearSet();}});
}
function cwcrOpenSetDd(){if(!cwcrDdMenu||!cwcrDdTrigger)return;cwcrDdMenu.classList.add('open');cwcrDdTrigger.classList.add('open');if(!(cwcrSetsCache[activeFranchise]||[]).length)cwcrLoadSetsLazy(activeFranchise);cwcrBuildDdMenu();if(cwcrDdSearch)setTimeout(function(){cwcrDdSearch.focus();},40);}
function cwcrCloseSetDd(){if(cwcrDdMenu)cwcrDdMenu.classList.remove('open');if(cwcrDdTrigger)cwcrDdTrigger.classList.remove('open');}
var _cwcrSetsInFlight={};
function cwcrLoadSetsLazy(fr){
if((cwcrSetsCache[fr]||[]).length) return Promise.resolve(cwcrSetsCache[fr]);
if(_cwcrSetsInFlight[fr]) return _cwcrSetsInFlight[fr];
var base=CWCR_BASE_URL+'/api/tcg/';
_cwcrSetsInFlight[fr]=fetch(fr==='pokemon'?base+'pk-sets?v=2':base+'op-sets?v=2').then(function(r){return r.json();}).then(function(data){var sets;if(fr==='pokemon'){sets=(data.data||[]).map(function(s){return{id:s.id,label:(s.code?s.code+' - ':'')+( s.name||s.id),count:typeof s.card_count==='number'?s.card_count:-1};});}else{sets=(Array.isArray(data)?data:(data.sets||[])).sort(function(a,b){return(b.set_id||b.id||'').localeCompare(a.set_id||a.id||'');}).map(function(s){var id=s.set_id||s.id||'';return{id:id,label:id+' - '+(s.set_name||s.name||id),count:typeof s.card_count==='number'?s.card_count:-1};});}cwcrSetsCache[fr]=sets;_cwcrSetsInFlight[fr]=null;cwcrBuildDdMenu();return sets;}).catch(function(){_cwcrSetsInFlight[fr]=null;return[];});
return _cwcrSetsInFlight[fr];
}
function cwcrSelectFromDd(fr,setId,setLabel){cwcrCloseSetDd();if(fr!==activeFranchise){if(tabsEl)tabsEl.querySelectorAll('.cwcr-tab').forEach(function(t){var isSame=t.dataset.franchise===fr;t.classList.toggle('cwcr-tab-active',isSame);t.setAttribute('aria-selected',String(isSame));});activeFranchise=fr;if(typeof window.cwcrSyncFrDdToFranchise==='function')window.cwcrSyncFrDdToFranchise(fr);var isOp=(fr==='onepiece');if(rarPkEl)rarPkEl.style.display=isOp?'none':'';if(rarOpEl)rarOpEl.style.display=isOp?'':'none';document.querySelectorAll('.cwcr-op-only').forEach(function(el){el.style.display=isOp?'':'none';});sidebarRarities={};sidebarColors={};sidebarCardTypes={};var ns=cwcrSetsCache[fr]||[];allSets=ns;buildChips(ns);renderSidebarSets(ns);loadFranchiseProducts(fr);}activeSetId=setId;activeSetName=setLabel;cwcrTrack('set_select',{set:setId,setName:setLabel,franchise:fr||''});allCards=[];currentCounts=null;updateSidebarCounts();updateSidebarRarities();resetCardGrid();filtersEl&&filtersEl.classList.add('cwcr-show');showChaseLoading(((window.CWPD_I18N&&window.CWPD_I18N.chaseLoading)||'Chase cards ophalen...'));renderSkeletons(24);highlightSetProducts(setLabel);showStickyBar(setLabel);if(chipsEl){chipsEl.querySelectorAll('.cwcr-set-chip').forEach(function(c){c.classList.remove('cwcr-chip-active');});var mc=chipsEl.querySelector('[data-set-id="'+setId+'"]');if(mc)mc.classList.add('cwcr-chip-active');}var sbl=document.getElementById('cwcr-sidebar-set-list');if(sbl){sbl.querySelectorAll('.cwcr-sidebar-set-btn').forEach(function(b){b.classList.remove('cwcr-set-active');});var mb=sbl.querySelector('[data-set-id="'+setId+'"]');if(mb){mb.classList.add('cwcr-set-active');mb.scrollIntoView({block:'nearest'});}}cwcrUpdateDdLabel();cwcrBuildDdMenu();if(fr==='pokemon')fetchPokemon(setId);else if(fr==='onepiece')fetchOnePiece(setId);renderActiveFilters();}
if(cwcrDdTrigger)cwcrDdTrigger.addEventListener('click',function(){if(cwcrDdMenu&&cwcrDdMenu.classList.contains('open'))cwcrCloseSetDd();else cwcrOpenSetDd();});
if(cwcrDdSearch){
  cwcrDdSearch.addEventListener('input',function(){cwcrBuildDdMenu();});
  /* Stop globale Shopify/Ambaze key-handlers van focus te stelen terwijl user typt */
  cwcrDdSearch.addEventListener('keydown',function(e){e.stopPropagation();});
  cwcrDdSearch.addEventListener('keyup',function(e){e.stopPropagation();});
  /* Hergeef focus als het menu nog open is en focus naar buiten de dropdown ging */
  cwcrDdSearch.addEventListener('blur',function(){
    setTimeout(function(){
      if(cwcrDdMenu&&cwcrDdMenu.classList.contains('open')&&document.activeElement!==cwcrDdSearch){
        if(!cwcrDdEl||!cwcrDdEl.contains(document.activeElement)){cwcrDdSearch.focus();}
      }
    },80);
  });
}
document.addEventListener('click',function(e){if(cwcrDdEl&&!cwcrDdEl.contains(e.target))cwcrCloseSetDd();});
function buildChips(sets){
if(!chipsEl) return;
var html='';
sets.forEach(function(s){
var active=s.id===activeSetId ? ' cwcr-chip-active' : '';
html += '<button class="cwcr-set-chip' + active + '" data-set-id="' + esc(s.id) + '" data-set-label="' + esc(s.label) + '">' + esc(s.label) + '</button>';
});
chipsEl.innerHTML = html;
}
if(chipsEl){
chipsEl.addEventListener('click',function(e){
var chip=e.target.closest('.cwcr-set-chip');
if(!chip) return;
var scrollY=window.scrollY;
requestAnimationFrame(function(){ window.scrollTo(0,scrollY); });
var setId=chip.dataset.setId;
var setLabel=chip.dataset.setLabel || setId;
if(setId===activeSetId){
chipsEl.querySelectorAll('.cwcr-set-chip').forEach(function(c){ c.classList.remove('cwcr-chip-active'); });
activeSetId=null; activeSetName = ''; allCards=[]; currentCounts=null;
sidebarRarities={}; sidebarColors={}; sidebarCardTypes={};
resetCardGrid(); resetShopHighlight(); resetFilters();
updateSidebarCounts(); updateSidebarRarities();
renderActiveFilters();
renderSidebarSets(allSets);
if(typeof cwcrUpdateDdLabel==='function') cwcrUpdateDdLabel();
return;
}
chipsEl.querySelectorAll('.cwcr-set-chip').forEach(function(c){ c.classList.remove('cwcr-chip-active'); });
chip.classList.add('cwcr-chip-active');
if(setId==='__all__'){
activeSetId = '__all__'; activeSetName = 'Alles'; allCards=[]; currentCounts=null;
sidebarRarities={}; sidebarColors={}; sidebarCardTypes={};
resetCardGrid();
showChaseLoading(((window.CWPD_I18N&&window.CWPD_I18N.allLoading)||'Alle kaarten ophalen...'));
renderSkeletons(24);
var allBase=CWCR_BASE_URL+'/api/tcg/';
if(activeFranchise==='onepiece'){
fetch(allBase + 'op-all')
.then(function(r){return r.json();})
.then(function(cards){
if(!Array.isArray(cards)){ hideChaseLoading(); return; }
cards.forEach(function(c){ c._price = parseFloat(c.price || c.market_price || c.value || 0) || 0; });
var sorted=cards.slice();
sorted.sort(opSortFn);
allCards = sorted;
allBulkCards=[];
updateSidebarCounts(); updateSidebarRarities();
renderOnePiece(sorted,null,false);
})
.catch(function(){ hideChaseLoading(); });
}else{
hideChaseLoading();
if(grid){ grid.innerHTML = '<div class="cwcr-chase-empty">Kies een specifieke set voor Pokémon.</div>'; grid.style.display=''; }
}
updateSidebarCounts(); updateSidebarRarities();
renderActiveFilters();
return;
}
var sidebarListEl=document.getElementById('cwcr-sidebar-set-list');
if(sidebarListEl){
sidebarListEl.querySelectorAll('.cwcr-sidebar-set-btn').forEach(function(b){ b.classList.remove('cwcr-set-active'); });
var matchBtn=sidebarListEl.querySelector('[data-set-id="' + setId + '"]');
if(matchBtn){ matchBtn.classList.add('cwcr-set-active'); matchBtn.scrollIntoView({block: 'nearest' }); }
}
activeSetId = setId;
activeSetName = setLabel;
cwcrTrack('set_select', { set: setId, setName: setLabel, franchise: activeFranchise || '' });
allCards=[];
currentCounts=null;
updateSidebarCounts();
updateSidebarRarities();
resetCardGrid();
filtersEl && filtersEl.classList.add('cwcr-show');
showChaseLoading(((window.CWPD_I18N&&window.CWPD_I18N.chaseLoading)||'Chase cards ophalen...'));
renderSkeletons(24);
highlightSetProducts(setLabel);
showStickyBar(setLabel);
if(activeFranchise==='pokemon'){
fetchPokemon(setId);
}else if(activeFranchise==='onepiece'){
fetchOnePiece(setId);
}
renderActiveFilters();
});
}
function applyFilters(){
if(!allCards.length) return;
var cards=allCards.slice();
if(sidebarPriceMin>0){
cards = cards.filter(function(c){ return (c._price || 0)>=sidebarPriceMin; });
}
if(sidebarPriceMax>0){
cards = cards.filter(function(c){ return (c._price || 0)<=sidebarPriceMax; });
}
var rarKeys=Object.keys(sidebarRarities).filter(function(k){ return sidebarRarities[k]; });
if(rarKeys.length>0){
cards = cards.filter(function(c){ return rarKeys.indexOf(c.rarity)>-1; });
}
var colKeys=Object.keys(sidebarColors).filter(function(k){ return sidebarColors[k]; });
if(colKeys.length>0){
cards = cards.filter(function(c){ return colKeys.indexOf(c.color)>-1; });
}
var typeKeys=Object.keys(sidebarCardTypes).filter(function(k){ return sidebarCardTypes[k]; });
if(typeKeys.length>0){
cards = cards.filter(function(c){ return typeKeys.indexOf(c.card_type)>-1; });
}
cards.sort(function(a,b){
if(sidebarSort==='price-asc')  return (a._price || 0) - (b._price || 0);
if(sidebarSort==='name-asc')   return (a.name || a.card_name || '').localeCompare(b.name || b.card_name || '');
return (b._price || 0) - (a._price || 0);
});
var activeCount=rarKeys.length + colKeys.length + typeKeys.length + (sidebarPriceMin>0 ? 1 : 0);
if(sidebarCountEl){
if(activeCount>0){ sidebarCountEl.textContent = activeCount; sidebarCountEl.style.display=''; }
else sidebarCountEl.style.display='none';
}
if(sidebarCountDesktop){
if(activeCount>0){ sidebarCountDesktop.textContent = activeCount; sidebarCountDesktop.style.display=''; }
else sidebarCountDesktop.style.display='none';
}
cwcrLastFilteredCount=cards.length;
var isCrossSearch=!activeFranchise && cwcrCardRegistry['pokemon-orig'] && cwcrCardRegistry['onepiece-orig'];
if(isCrossSearch){
var hasAnyFilter=rarKeys.length>0||colKeys.length>0||typeKeys.length>0||sidebarPriceMin>0||sidebarPriceMax>0;
function _crossFilter(arr){
var f=arr.slice();
if(rarKeys.length>0) f=f.filter(function(c){return rarKeys.indexOf(c.rarity)>-1;});
if(colKeys.length>0) f=f.filter(function(c){return colKeys.indexOf(c.color)>-1;});
if(typeKeys.length>0) f=f.filter(function(c){return typeKeys.indexOf(c.card_type)>-1;});
if(sidebarPriceMin>0) f=f.filter(function(c){return (c._price||0)>=sidebarPriceMin;});
if(sidebarPriceMax>0) f=f.filter(function(c){return (c._price||0)<=sidebarPriceMax;});
return f;
}
cwcrCardRegistry['pokemon']=hasAnyFilter?_crossFilter(cwcrCardRegistry['pokemon-orig']):cwcrCardRegistry['pokemon-orig'].slice();
cwcrCardRegistry['onepiece']=hasAnyFilter?_crossFilter(cwcrCardRegistry['onepiece-orig']):cwcrCardRegistry['onepiece-orig'].slice();
_rerenderCrossGrid();
}
else if(activeFranchise==='pokemon')   renderPokemon(cards,currentCounts,true);
else if(activeFranchise==='onepiece') renderOnePiece(cards,currentCounts,true);
var filteredBulk=allBulkCards.slice();
if(rarKeys.length>0){
filteredBulk = filteredBulk.filter(function(c){ return rarKeys.indexOf(c.rarity)>-1; });
}
if(sidebarPriceMin>0) filteredBulk = filteredBulk.filter(function(c){ return (c._price || 0)>=sidebarPriceMin; });
if(sidebarPriceMax>0) filteredBulk = filteredBulk.filter(function(c){ return (c._price || 0)<=sidebarPriceMax; });
updateBulkGrid(filteredBulk,activeFranchise);
}
document.querySelectorAll('.cwcr-sort-btn').forEach(function(btn){
btn.addEventListener('click',function(){
document.querySelectorAll('.cwcr-sort-btn').forEach(function(b){ b.classList.remove('cwcr-sort-active'); });
btn.classList.add('cwcr-sort-active');
sidebarSort = btn.dataset.sort;
applyFilters();
});
});
var priceSliderEl=document.getElementById('cwcr-price-slider');
var priceSliderMaxEl=document.getElementById('cwcr-price-slider-max');
var priceRangeWrap=document.getElementById('cwcr-range-wrap');
var priceMinInput=document.getElementById('cwcr-price-min-input');
var priceMaxInput=document.getElementById('cwcr-price-max-input');
var sidebarPriceMax=0;
function updatePriceSliderUI(val){
  var pct=Math.min(val,100);
  if(priceSliderEl) priceSliderEl.value=pct;
  if(priceRangeWrap) priceRangeWrap.style.setProperty('--min-pct',pct+'%');
}
function updatePriceSliderMaxUI(val){
  var pct=val>=100?100:Math.max(val,0);
  if(priceSliderMaxEl) priceSliderMaxEl.value=pct;
  if(priceRangeWrap) priceRangeWrap.style.setProperty('--max-pct',pct+'%');
}
if(priceSliderEl){
priceSliderEl.addEventListener('input',function(){
sidebarPriceMin = parseFloat(priceSliderEl.value) || 0;
if(priceRangeWrap) priceRangeWrap.style.setProperty('--min-pct',Math.min(sidebarPriceMin,100)+'%');
if(priceMinInput) priceMinInput.value = sidebarPriceMin;
applyFilters(); renderActiveFilters();
});
}
if(priceSliderMaxEl){
priceSliderMaxEl.addEventListener('input',function(){
var v=parseFloat(priceSliderMaxEl.value)||0;
sidebarPriceMax = v>=100 ? 0 : v;
if(priceRangeWrap) priceRangeWrap.style.setProperty('--max-pct',v+'%');
if(priceMaxInput) priceMaxInput.value = sidebarPriceMax>0 ? sidebarPriceMax : '';
applyFilters(); renderActiveFilters();
});
}
if(priceMinInput){
priceMinInput.addEventListener('input',function(){
sidebarPriceMin = parseFloat(priceMinInput.value) || 0;
updatePriceSliderUI(sidebarPriceMin);
applyFilters(); renderActiveFilters();
});
}
if(priceMaxInput){
priceMaxInput.addEventListener('input',function(){
sidebarPriceMax = parseFloat(priceMaxInput.value) || 0;
var pct=sidebarPriceMax>0?Math.min(sidebarPriceMax,100):100;
updatePriceSliderMaxUI(pct);
applyFilters(); renderActiveFilters();
});
}
function setRarityFilter(rarity){
var alreadyActive=!!sidebarRarities[rarity];
sidebarRarities={};
document.querySelectorAll('.cwcr-rar-filter').forEach(function(cb){ cb.checked=false; });
document.querySelectorAll('.cwcr-rarity-count-pill').forEach(function(p){ p.classList.remove('cwcr-pill-active'); });
if(!alreadyActive){
sidebarRarities[rarity]=true;
document.querySelectorAll('.cwcr-rar-filter[data-rarity="' + rarity + '"]').forEach(function(cb){ cb.checked=true; });
var pill=document.querySelector('.cwcr-rarity-count-pill[data-rarity="' + rarity + '"]');
if(pill) pill.classList.add('cwcr-pill-active');
}
applyFilters();
renderActiveFilters();
}
document.querySelectorAll('.cwcr-rar-filter').forEach(function(cb){
cb.addEventListener('change',function(){
setRarityFilter(cb.dataset.rarity);
});
});
document.querySelectorAll('.cwcr-color-filter').forEach(function(cb){
cb.addEventListener('change',function(){
sidebarColors[cb.dataset.color] = cb.checked;
applyFilters();
renderActiveFilters();
});
});
document.querySelectorAll('.cwcr-type-filter').forEach(function(cb){
cb.addEventListener('change',function(){
sidebarCardTypes[cb.dataset.cardtype] = cb.checked;
applyFilters();
renderActiveFilters();
});
});
function doResetFilters(){
sidebarSort = 'price-desc'; sidebarPriceMin=0; sidebarPriceMax=0;
sidebarRarities={}; sidebarColors={}; sidebarCardTypes={};
document.querySelectorAll('.cwcr-sort-btn').forEach(function(b){ b.classList.remove('cwcr-sort-active'); });
var defSort=document.querySelector('[data-sort="price-desc"]');
if(defSort) defSort.classList.add('cwcr-sort-active');
var sliderEl=document.getElementById('cwcr-price-slider');
if(sliderEl) sliderEl.value=0;
var sliderMaxEl=document.getElementById('cwcr-price-slider-max');
if(sliderMaxEl) sliderMaxEl.value=100;
var rwEl=document.getElementById('cwcr-range-wrap');
if(rwEl){rwEl.style.setProperty('--min-pct','0%');rwEl.style.setProperty('--max-pct','100%');}
if(priceMinInput) priceMinInput.value = '';
if(priceMaxInput) priceMaxInput.value = '';
document.querySelectorAll('.cwcr-rar-filter,.cwcr-color-filter,.cwcr-type-filter').forEach(function(cb){ cb.checked=false; });
document.querySelectorAll('.cwcr-rarity-count-pill').forEach(function(p){ p.classList.remove('cwcr-pill-active'); });
var rarAllR=document.getElementById('cwcr-rar-all');
if(rarAllR) rarAllR.checked=true;
if(sidebarCountEl) sidebarCountEl.style.display='none';
if(sidebarCountDesktop) sidebarCountDesktop.style.display='none';
// Ook actieve set clearen (set chip, sidebar set, dropdown label, card grid)
if(activeSetId){
  activeSetId=null; activeSetName=''; allCards=[]; currentCounts=null; cwcrZetUpdate(null);
  if(chipsEl) chipsEl.querySelectorAll('.cwcr-set-chip').forEach(function(c){ c.classList.remove('cwcr-chip-active'); });
  var sbl2=document.getElementById('cwcr-sidebar-set-list');
  if(sbl2) sbl2.querySelectorAll('.cwcr-sidebar-set-btn').forEach(function(b){ b.classList.remove('cwcr-set-active'); });
  if(typeof resetCardGrid==='function') resetCardGrid();
  if(typeof resetShopHighlight==='function') resetShopHighlight();
  if(typeof cwcrUpdateDdLabel==='function') cwcrUpdateDdLabel();
  if(typeof cwcrBuildDdMenu==='function') cwcrBuildDdMenu();
  if(typeof updateSidebarCounts==='function') updateSidebarCounts();
  if(typeof updateSidebarRarities==='function') updateSidebarRarities();
  if(typeof renderSidebarSets==='function' && Array.isArray(allSets)) renderSidebarSets(allSets);
  if(filtersEl) filtersEl.classList.remove('cwcr-show');
  // Sticky bar verbergen
  var stickyBar=document.getElementById('cwcr-sticky-bar');
  if(stickyBar) stickyBar.classList.remove('cwcr-sticky-show');
}
applyFilters();
renderActiveFilters();
}
if(sidebarResetEl){
sidebarResetEl.addEventListener('click',doResetFilters);
}
if(sidebarToggleEl && sidebarInnerEl){
sidebarToggleEl.addEventListener('click',function(){
sidebarInnerEl.classList.toggle('cwcr-open');
});
}
function updateSidebarCounts(){
var rarCount={};
allCards.forEach(function(c){ if(c.rarity) rarCount[c.rarity] = (rarCount[c.rarity] || 0) + 1; });
document.querySelectorAll('.cwcr-rar-filter').forEach(function(cb){
var label=cb.closest('.cwcr-sidebar-check');
if(!label) return;
var rar=cb.dataset.rarity;
var n=rarCount[rar] || 0;
var span=label.querySelector('.cwcr-sidebar-check-count');
if(!span){ span = document.createElement('span'); span.className = 'cwcr-sidebar-check-count'; label.appendChild(span); }
span.textContent = n>0 ? '(' + n + ')' : '';
});
var typeCount={};
allCards.forEach(function(c){ if(c.card_type) typeCount[c.card_type] = (typeCount[c.card_type] || 0) + 1; });
document.querySelectorAll('.cwcr-type-filter').forEach(function(cb){
var label=cb.closest('.cwcr-sidebar-check');
if(!label) return;
var t=cb.dataset.cardtype;
var n=typeCount[t] || 0;
var span=label.querySelector('.cwcr-sidebar-check-count');
if(!span){ span = document.createElement('span'); span.className = 'cwcr-sidebar-check-count'; label.appendChild(span); }
span.textContent = n>0 ? '(' + n + ')' : '';
});
}
function cwcrTitleCase(s){
if(!s) return s;
return String(s).toLowerCase().replace(/(^|[\s\-\/])([a-z])/g,function(m,sep,ch){ return sep + ch.toUpperCase(); });
}
function updateSidebarRarities(){
var pkContainer=document.getElementById('cwcr-rar-pk');
var opContainer=document.getElementById('cwcr-rar-op');
var isOp=activeFranchise==='onepiece';
var isCross=!activeFranchise && cwcrCardRegistry['pokemon'] && cwcrCardRegistry['onepiece'];
if(!activeSetId && !isCross){
var placeholder='<div class="cwcr-dd-placeholder" style="font-size:12px;padding:6px 10px">'+((window.CWPD_I18N && window.CWPD_I18N.chooseSetFirst) || 'Kies eerst een set...')+'</div>';
if(pkContainer) pkContainer.innerHTML=placeholder;
if(opContainer) opContainer.innerHTML=placeholder;
return;
}
// For cross-search, use whichever container has more results, combine both rarity maps
var container=isCross ? (opContainer || pkContainer) : (isOp ? opContainer : pkContainer);
if(!container) return;
var rarityMap;
if(isCross){
rarityMap={};
for(var k in pkRarity) rarityMap[k]=pkRarity[k];
for(var k2 in opRarity) if(!rarityMap[k2]) rarityMap[k2]=opRarity[k2];
// Hide other container
if(pkContainer && opContainer){pkContainer.style.display=container===pkContainer?'':'none';opContainer.style.display=container===opContainer?'':'none';}
}else{
rarityMap=isOp ? opRarity : pkRarity;
}
var rarCount={};
var rarValue={};
allCards.concat(allBulkCards).forEach(function(c){
if(!c.rarity) return;
rarCount[c.rarity] = (rarCount[c.rarity] || 0) + 1;
var p=parseFloat(c._price || c.price || c.market_price || c.value || 0) || 0;
if(p > (rarValue[c.rarity] || 0)) rarValue[c.rarity] = p;
});
var presentRarities=Object.keys(rarCount).filter(function(r){ return rarCount[r]>0; });
presentRarities.sort(function(a,b){
var va=rarValue[a] || 0;
var vb=rarValue[b] || 0;
if(vb!==va) return vb - va;
return a.localeCompare(b);
});
var html='';
presentRarities.forEach(function(r){
var info=rarityMap[r] || { label: r };
var n=rarCount[r] || 0;
var checkedAttr=sidebarRarities[r] ? ' checked' : '';
html += '<label class="cwcr-sidebar-check"><span class="cwcr-sidebar-check-inner"><input type="checkbox" class="cwcr-rar-filter" data-rarity="' + esc(r) + '"' + checkedAttr + '> ' + esc(cwcrTitleCase(info.label)) + '</span><span class="cwcr-sidebar-check-count">(' + n + ')</span></label>';
});
if(!html) html = '<div style="color:rgba(255,255,255,0.3);font-size:12px;padding:6px 10px">Geen rariteiten gevonden</div>';
container.innerHTML = html;
container.querySelectorAll('.cwcr-rar-filter').forEach(function(cb){
cb.addEventListener('change',function(){
setRarityFilter(cb.dataset.rarity);
});
});
}
function renderSidebarSets(sets){
var listEl=document.getElementById('cwcr-sidebar-set-list');
if(!listEl || !sets || !sets.length) return;
var html='';
/* Zelfde sortering + code-pill als de set-dropdown bovenaan (cwcrBuildDdMenu):
   label splitsen op ' - ' in code/naam, getagde sets eerst op code (localeCompare),
   ongetagde op naam, lege sets (count===0) achteraan. Code-pill = .cwcr-set-dd-icode
   (global class, vaste 48px-kolom in CSS = verticaal uitgelijnd). */
var items=sets.map(function(s){var code='',name=s.label,di=(s.label||'').indexOf(' - ');if(di>0){code=s.label.substring(0,di).trim();name=s.label.substring(di+3).trim();}return{s:s,code:code,name:name};});
var tagged=items.filter(function(it){return!!it.code;}).sort(function(a,b){return a.code.localeCompare(b.code);});
var untagged=items.filter(function(it){return!it.code;}).sort(function(a,b){return a.name.localeCompare(b.name);});
var ordered=tagged.concat(untagged);
var full=ordered.filter(function(it){return it.s.count!==0;});
var empty=ordered.filter(function(it){return it.s.count===0;});
full.concat(empty).forEach(function(it){
var s=it.s;
var active=s.id===activeSetId ? ' cwcr-set-active' : '';
var isEmpty=s.count===0;
var emptyAttr=isEmpty?' disabled aria-disabled="true"':'';
var emptyClass=isEmpty?' cwcr-sidebar-set-empty':'';
var nocodeClass=it.code?'':' cwcr-sidebar-set-btn--nocode';
html += '<button class="cwcr-sidebar-set-btn' + active + emptyClass + nocodeClass + '" data-set-id="' + esc(s.id) + '" data-set-label="' + esc(s.label) + '"' + emptyAttr + '>'
  + (it.code ? '<span class="cwcr-set-dd-icode">' + esc(it.code) + '</span>' : '')
  + '<span class="cwcr-set-dd-iname">' + esc(it.name) + '</span>'
  + '</button>';
});
listEl.innerHTML = html;
listEl.querySelectorAll('.cwcr-sidebar-set-btn').forEach(function(btn){
btn.addEventListener('click',function(){
var setId=btn.dataset.setId;
var setLabel=btn.dataset.setLabel || setId;
if(setId===activeSetId){
activeSetId=null; activeSetName = ''; allCards=[]; currentCounts=null;
listEl.querySelectorAll('.cwcr-sidebar-set-btn').forEach(function(b){ b.classList.remove('cwcr-set-active'); });
if(chipsEl) chipsEl.querySelectorAll('.cwcr-set-chip').forEach(function(c){ c.classList.remove('cwcr-chip-active'); });
sidebarRarities={}; sidebarColors={}; sidebarCardTypes={};
resetCardGrid();
resetShopHighlight();
resetFilters();
updateSidebarCounts();
updateSidebarRarities();
renderActiveFilters();
if(typeof cwcrUpdateDdLabel==='function') cwcrUpdateDdLabel();
return;
}
listEl.querySelectorAll('.cwcr-sidebar-set-btn').forEach(function(b){ b.classList.remove('cwcr-set-active'); });
btn.classList.add('cwcr-set-active');
if(chipsEl){
chipsEl.querySelectorAll('.cwcr-set-chip').forEach(function(c){ c.classList.remove('cwcr-chip-active'); });
var matchChip=chipsEl.querySelector('[data-set-id="' + setId + '"]');
if(matchChip) matchChip.classList.add('cwcr-chip-active');
}
activeSetId = setId;
activeSetName = setLabel;
cwcrTrack('set_select', { set: setId, setName: setLabel, franchise: activeFranchise || '' });
allCards=[]; currentCounts=null;
updateSidebarCounts(); updateSidebarRarities();
resetCardGrid();
filtersEl && filtersEl.classList.add('cwcr-show');
showChaseLoading(((window.CWPD_I18N&&window.CWPD_I18N.chaseLoading)||'Chase cards ophalen...'));
renderSkeletons(24);
highlightSetProducts(setLabel);
showStickyBar(setLabel);
if(activeFranchise==='pokemon'){
fetchPokemon(setId);
}else if(activeFranchise==='onepiece'){
fetchOnePiece(setId);
}
renderActiveFilters();
});
});
}
function renderActiveFilters(){
var container=document.getElementById('cwcr-active-filters');
if(!container) return;
var tags=[];
if(activeSetId && activeSetName){
var sid=activeSetId,sname = activeSetName;
tags.push({ key: 'set-' + sid,label: sname,isSet: true,remove: function(){
activeSetId=null; activeSetName = ''; allCards=[]; allBulkCards=[]; currentCounts=null;
if(chipsEl) chipsEl.querySelectorAll('.cwcr-set-chip').forEach(function(c){ c.classList.remove('cwcr-chip-active'); });
var listEl2=document.getElementById('cwcr-sidebar-set-list');
if(listEl2) listEl2.querySelectorAll('.cwcr-sidebar-set-btn').forEach(function(b){ b.classList.remove('cwcr-set-active'); });
resetCardGrid(); resetShopHighlight();
sidebarRarities={}; sidebarColors={}; sidebarCardTypes={};
if(stickyBarEl) stickyBarEl.classList.remove('cwcr-show');
updateSidebarCounts(); updateSidebarRarities();
renderActiveFilters();
if(typeof cwcrUpdateDdLabel==='function') cwcrUpdateDdLabel();
}});
}
Object.keys(sidebarColors).forEach(function(c){
if(!sidebarColors[c]) return;
tags.push({ key: 'col-' + c,label: c,remove: function(){ sidebarColors[c]=false; var cb=document.querySelector('.cwcr-color-filter[data-color="' + c + '"]'); if(cb) cb.checked=false; applyFilters(); renderActiveFilters(); } });
});
Object.keys(sidebarCardTypes).forEach(function(t){
if(!sidebarCardTypes[t]) return;
tags.push({ key: 'type-' + t,label: t,remove: function(){ sidebarCardTypes[t]=false; var cb=document.querySelector('.cwcr-type-filter[data-cardtype="' + t + '"]'); if(cb) cb.checked=false; applyFilters(); renderActiveFilters(); } });
});
if(sidebarPriceMin>0){
var pm=sidebarPriceMin;
tags.push({ key: 'price',label: 'Min \u20ac' + pm,remove: function(){
sidebarPriceMin=0;
var slider=document.getElementById('cwcr-price-slider');
if(slider) slider.value=0;
var rwEl2=document.getElementById('cwcr-range-wrap');
if(rwEl2) rwEl2.style.setProperty('--min-pct','0%');
var valEl=document.getElementById('cwcr-price-val');
if(valEl) valEl.textContent = '\u20ac0';
applyFilters(); renderActiveFilters();
}});
}
if(sidebarPriceMax>0){
var pmax=sidebarPriceMax;
tags.push({ key: 'price-max',label: 'Max \u20ac' + pmax,remove: function(){
sidebarPriceMax=0;
if(priceMaxInput) priceMaxInput.value = '';
var sliderMx=document.getElementById('cwcr-price-slider-max');
if(sliderMx) sliderMx.value=100;
var rwEl3=document.getElementById('cwcr-range-wrap');
if(rwEl3) rwEl3.style.setProperty('--max-pct','100%');
applyFilters(); renderActiveFilters();
}});
}
if(!tags.length){ container.style.display='none'; container.innerHTML = ''; return; }
var html='<button class="cwcr-active-filters-clear" id="cwcr-filters-clear-all">Alles verwijderen</button>';
tags.forEach(function(tag){
var extraStyle=tag.isSet ? ' style="background:rgba(232,200,64,0.12);border-color:rgba(232,200,64,0.3);color:#E8C840;"' : '';
html += '<span class="cwcr-active-filter-tag" data-key="' + esc(tag.key) + '"' + extraStyle + '>' + esc(tag.label) + '<button class="cwcr-active-filter-remove" aria-label="'+((window.CWPD_I18N&&window.CWPD_I18N.removeFilter)||'Verwijder filter')+'">&#215;</button></span>';
});
container.innerHTML = html;
container.style.display='flex';
var clearAll=container.querySelector('#cwcr-filters-clear-all');
if(clearAll){
clearAll.addEventListener('click',function(){
activeSetId=null; activeSetName = ''; allCards=[]; allBulkCards=[]; currentCounts=null;
if(chipsEl) chipsEl.querySelectorAll('.cwcr-set-chip').forEach(function(c){ c.classList.remove('cwcr-chip-active'); });
var listEl2=document.getElementById('cwcr-sidebar-set-list');
if(listEl2) listEl2.querySelectorAll('.cwcr-sidebar-set-btn').forEach(function(b){ b.classList.remove('cwcr-set-active'); });
resetCardGrid(); resetShopHighlight();
if(stickyBarEl) stickyBarEl.classList.remove('cwcr-show');
if(typeof doResetFilters==='function') doResetFilters();
if(typeof cwcrUpdateDdLabel==='function') cwcrUpdateDdLabel();
container.style.display='none'; container.innerHTML = '';
});
}
tags.forEach(function(tag){
var tagEl=container.querySelector('[data-key="' + tag.key + '"]');
if(!tagEl) return;
var btn=tagEl.querySelector('.cwcr-active-filter-remove');
if(btn) btn.addEventListener('click',function(){ tag.remove(); });
});
}
var chaseToggleBtn=document.getElementById('cwcr-chase-toggle');
if(chaseToggleBtn){
chaseToggleBtn.addEventListener('click',function(){
var body=document.getElementById('cwcr-chase-body');
var expanded=chaseToggleBtn.getAttribute('aria-expanded')==='true';
chaseToggleBtn.setAttribute('aria-expanded',String(!expanded));
if(body) body.style.display=expanded ? 'none' : '';
});
}
function initSubToggle(btnId,targetId){
var btn=document.getElementById(btnId);
if(!btn) return;
btn.addEventListener('click',function(){
var target=document.getElementById(targetId);
var expanded=btn.getAttribute('aria-expanded')==='true';
var plus=btn.querySelector('.cwcr-sub-toggle-plus');
btn.setAttribute('aria-expanded',String(!expanded));
if(target) target.style.display=expanded ? 'none' : '';
if(plus) plus.innerHTML = expanded ? '+' : '&minus;';
});
}
initSubToggle('cwcr-chase-sub-toggle','cwcr-chase-img-grid');
initSubToggle('cwcr-bulk-sub-toggle','cwcr-bulk-grid');
var chaseSortByPrice=true;
function sortCardArray(arr,sortKey,franchise){
var fr=franchise||activeFranchise;
if(sortKey==='price-desc') arr.sort(function(a,b){return (b._price||0)-(a._price||0);});
else if(sortKey==='price-asc') arr.sort(function(a,b){return (a._price||0)-(b._price||0);});
else if(sortKey==='name') arr.sort(function(a,b){return (a.name||a.card_name||'').localeCompare(b.name||b.card_name||'');});
else if(sortKey==='name-desc') arr.sort(function(a,b){return (b.name||b.card_name||'').localeCompare(a.name||a.card_name||'');});
else if(sortKey==='number'){
if(fr==='onepiece') arr.sort(function(a,b){return (a.card_id||a.id||'').localeCompare(b.card_id||b.id||'',undefined,{numeric:true});});
else arr.sort(function(a,b){return (a.number||'').localeCompare(b.number||'',undefined,{numeric:true});});
}else if(sortKey==='number-desc'){
if(fr==='onepiece') arr.sort(function(a,b){return (b.card_id||b.id||'').localeCompare(a.card_id||a.id||'',undefined,{numeric:true});});
else arr.sort(function(a,b){return (b.number||'').localeCompare(a.number||'',undefined,{numeric:true});});
}
return arr;
}
// Het pill-label = de volledige tekst van het gekozen menu-item (elke richting is een eigen regel).
function _ddSyncPill(opt,curEl){
if(!curEl) return;
curEl.textContent=(opt.textContent||'').replace(/\s+/g,' ').trim();
}
// Generieke init voor een sorteer-dropdown. applyFn(sortKey) doet de echte sort+render.
function cwcrInitSortDropdown(rootId,applyFn){
var root=document.getElementById(rootId);
if(!root) return;
var pill=root.querySelector('.cwcr-sortdd-pill');
var curEl=root.querySelector('.cwcr-sortdd-cur');
var opts=root.querySelectorAll('.cwcr-sortdd-opt');
function closeMenu(){ root.classList.remove('cwcr-open'); if(pill) pill.setAttribute('aria-expanded','false'); }
function openMenu(){ root.classList.add('cwcr-open'); if(pill) pill.setAttribute('aria-expanded','true'); }
if(pill) pill.addEventListener('click',function(e){
e.stopPropagation();
if(root.classList.contains('cwcr-open')) closeMenu(); else openMenu();
});
opts.forEach(function(opt){
opt.addEventListener('click',function(e){
e.stopPropagation();
opts.forEach(function(o){o.classList.remove('cwcr-active');});
opt.classList.add('cwcr-active');
var sk=opt.dataset.sort;
root.dataset.sort=sk;
_ddSyncPill(opt,curEl);
closeMenu();
applyFn(sk);
});
});
// Sluit bij klik buiten
document.addEventListener('click',function(e){ if(!root.contains(e.target)) closeMenu(); });
}
cwcrInitSortDropdown('cwcr-chase-sort-row',function(sk){
chaseSortByPrice=sk==='price-desc'||sk==='price-asc';
// Cross-search mode: re-sort each franchise registry and re-render cross grid
if(grid && grid.querySelector('.cwcr-cross-section')){
sortCardArray(cwcrCardRegistry['pokemon'],sk,'pokemon');
sortCardArray(cwcrCardRegistry['onepiece'],sk,'onepiece');
allCards=cwcrCardRegistry['pokemon'].concat(cwcrCardRegistry['onepiece']);
_rerenderCrossGrid();
return;
}
// De chase-sectie is ALTIJD de 10 duurste kaarten; de sortering verandert enkel de
// volgorde BINNEN die 10 (anders haalt bv. 'prijs laag->hoog' de 10 goedkoopste binnen).
var topChase=allCards.slice().sort(function(a,b){return (b._price||0)-(a._price||0);}).slice(0,10);
sortCardArray(topChase,sk);
if(activeFranchise==='onepiece') renderOnePiece(topChase,currentCounts);
else renderPokemon(topChase,currentCounts);
});
cwcrInitSortDropdown('cwcr-bulk-sort-row',function(sk){
bulkSortByPrice=sk==='price-desc'||sk==='price-asc';
sortCardArray(allBulkCards,sk);
updateBulkGrid(allBulkCards,activeFranchise);
});
document.querySelectorAll('.cwcr-sidebar-group-btn').forEach(function(btn){
btn.addEventListener('click',function(){
var group=btn.closest('.cwcr-sidebar-group');
if(!group) return;
var isCollapsed=group.classList.contains('cwcr-collapsed');
group.classList.toggle('cwcr-collapsed',!isCollapsed);
btn.setAttribute('aria-expanded',isCollapsed ? 'true' : 'false');
});
});
(function(){
var footer=document.querySelector('footer,.cw-footer,[class*="cw-footer"],.site-footer,#MainFooter,[id*="footer"]:not([id*="cwcr"])');
if(!footer || !stickyBarEl) return;
var _adjustQueued=false;
function adjustStickyBar(){
if(!stickyBarEl.classList.contains('cwcr-show')){ stickyBarEl.style.bottom = ''; stickyBarEl.style.opacity = ''; return; }
var footerTop=footer.getBoundingClientRect().top;
var windowH=window.innerHeight;
var overlap=windowH - footerTop;
if(overlap>0){
stickyBarEl.style.bottom = overlap + 'px';
var fade=Math.max(0,Math.min(1,1 - (overlap - 10) / 60));
stickyBarEl.style.opacity = String(fade);
}else{
stickyBarEl.style.bottom = '';
stickyBarEl.style.opacity = '';
}
}
function scheduleAdjust(){
if(_adjustQueued) return;
_adjustQueued=true;
requestAnimationFrame(function(){ _adjustQueued=false; adjustStickyBar(); });
}
window.addEventListener('scroll',scheduleAdjust,{ passive: true });
window.addEventListener('resize',scheduleAdjust,{ passive: true });
})();
function loadFranchiseProducts(franchise){
var cfg=franchiseConfig[franchise];
if(!cfg || !cfg.collection) return;
var _stripVisible=shopStripEl&&shopStripEl.classList.contains('cwcr-show');
if(shopTitleEl){ if(_stripVisible)shopTitleEl.style.opacity='0'; setTimeout(function(){ var _Tss=window.CWPD_I18N||{}; var _tmpl=(_Tss.shopBrand||'Shop {brand} bij CARDWORLD'); shopTitleEl.textContent=_tmpl.replace('{brand}',cfg.label); if(_stripVisible)shopTitleEl.style.opacity='1'; },180); }
if(shopAllLink){ if(_stripVisible)shopAllLink.style.opacity='0'; setTimeout(function(){ shopAllLink.href=cfg.url; if(_stripVisible)shopAllLink.style.opacity='1'; },180); }
var ck='cwcr-products-' + franchise;
var cached=sessionStorage.getItem(ck);
if(cached){
try { return renderShopStrip(JSON.parse(cached),''); }
catch(e){}
}
if(shopStripEl) shopStripEl.classList.remove('cwcr-show');
fetch('/collections/' + cfg.collection + '/products.json?limit=20')
.then(function(r){return r.json();})
.then(function(data){
var raw=data.products || [];
if(!raw.length){ if(shopStripEl) shopStripEl.classList.remove('cwcr-show'); return; }
var products=raw.map(function(p){
var v=p.variants && p.variants[0] ? p.variants[0] : null;
return{
id: p.id,title: p.title,handle: p.handle,variantId: v ? v.id : null,price: v ? parseFloat(v.price) : null,available: p.variants ? p.variants.some(function(vv){ return vv.available; }) : false,img: p.images && p.images[0] ? p.images[0].src : ''
};
});
sessionStorage.setItem(ck,JSON.stringify(products));
renderShopStrip(products,activeSetName);
})
.catch(function(){ if(shopStripEl) shopStripEl.classList.remove('cwcr-show'); });
}
function renderShopStrip(products,setLabel){
if(!shopScrollEl) return;
var keywords=setLabel
? setLabel.replace(/^[A-Z]{2,4}-\d+\s*[-–]\s*/i,'').split(/[\s\-]+/).filter(function(k){ return k.length>2; })
: [];
function isMatch(title){
if(!keywords.length) return false;
var t=title.toLowerCase();
return keywords.some(function(k){ return t.indexOf(k.toLowerCase())>-1; });
}
var sorted=products.slice().sort(function(a,b){
var am=isMatch(a.title) ? 0 : 1,bm = isMatch(b.title) ? 0 : 1;
if(am!==bm) return am - bm;
return (a.available ? 0 : 1) - (b.available ? 0 : 1);
});
var html='';
sorted.forEach(function(p){
var match=isMatch(p.title);
var price=p.price ? p.price.toFixed(2) : null;
html += '<div class="cwcr-shop-card' + (match ? ' cwcr-shop-match' : '') + '">';
html += '<div class="cwcr-shop-match-badge">Set match</div>';
if(p.img){
html += '<div class="cwcr-shop-img-wrap"><a href="/products/' + esc(p.handle) + '">';
html += '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">';
html += '</a></div>';
}
html += '<div class="cwcr-shop-body">';
html += '<a href="/products/' + esc(p.handle) + '" class="cwcr-shop-name">' + esc(p.title) + '</a>';
if(price) html += '<div class="cwcr-shop-price">\u20ac' + price + '</div>';
if(p.available && p.variantId){
html += '<button class="cwcr-shop-atc" data-variant="' + p.variantId + '">🛒 Toevoegen</button>';
}else{
html += '<div class="cwcr-shop-sold">Uitverkocht</div>';
}
html += '</div></div>';
});
shopScrollEl.innerHTML = html;
if(shopStripEl) shopStripEl.classList.add('cwcr-show');
}
function highlightSetProducts(setLabel){
var ck='cwcr-products-' + activeFranchise;
var cached=sessionStorage.getItem(ck);
if(!cached) return;
try { renderShopStrip(JSON.parse(cached),setLabel); }
catch(e){}
}
function cwcrCleanSetName(setLabel){
var di=(setLabel||'').indexOf(' - ');
return di>0?setLabel.substring(di+3).trim():(setLabel||'');
}
function setSectionTitle(setLabel){
var el=document.getElementById('cwcr-section-title');
if(el && setLabel) el.textContent = cwcrCleanSetName(setLabel);
}
function showStickyBar(setLabel){
setSectionTitle(setLabel);
if(!stickyBarEl||stickyDismissed) return;
if(stickySetEl) stickySetEl.textContent = cwcrCleanSetName(setLabel);
stickyBarEl.classList.add('cwcr-show');
}
var franchiseTags={ pokemon: 'Pokemon',onepiece: 'One Piece' };
function cwcrPopupUpdateFrBtns(fr){document.querySelectorAll('.cwcr-popup-fr-btn').forEach(function(b){b.classList.toggle('cwcr-popup-fr-active',b.dataset.fr===fr);});}
function cwcrPopupSwitchFr(fr){
activeFranchise=fr;
var cfg=franchiseConfig[fr];var tag=franchiseTags[fr]||'';
if(popupSubEl)popupSubEl.textContent=cfg&&cfg.name?cfg.name:'';
cwcrPopupUpdateFrBtns(fr);
popupSelectedTypes=[];popupSearchQuery='';
if(popupSearchEl)popupSearchEl.value='';
if(popupPriceMinEl)popupPriceMinEl.value='';
if(popupPriceMaxEl)popupPriceMaxEl.value='';
popupAvailRadios.forEach(function(r){r.checked=r.value==='all';});
popupCurrentSort='match';
if(popupSortList)popupSortList.querySelectorAll('.cwcr-popup-sort-opt').forEach(function(b){b.classList.toggle('cwcr-active',b.dataset.sort==='match');});
if(typeof syncPopupTopSort==='function')syncPopupTopSort();
if(popupTypeGroup)popupTypeGroup.style.display='none';
var ck='cwcr-popup-'+fr;var cached=sessionStorage.getItem(ck);
if(cached){try{return renderPopupGrid(JSON.parse(cached),null);}catch(e){}}
if(popupGrid)popupGrid.innerHTML='<div class="cwcr-popup-loading">Producten laden...</div>';
fetch(CWCR_BASE_URL+'/api/tcg/shop-products?tag='+encodeURIComponent(tag)).then(function(r){return r.json();}).then(function(products){sessionStorage.setItem(ck,JSON.stringify(products));renderPopupGrid(products,null);}).catch(function(){if(popupGrid)popupGrid.innerHTML='<div class="cwcr-popup-empty">Kon producten niet laden.</div>';});
}
document.querySelectorAll('.cwcr-popup-fr-btn').forEach(function(btn){btn.addEventListener('click',function(){cwcrPopupSwitchFr(btn.dataset.fr);});});
function openPopup(){
if(!activeFranchise)activeFranchise='pokemon';
var cfg=franchiseConfig[activeFranchise];
var tag=franchiseTags[activeFranchise] || '';
cwcrPopupUpdateFrBtns(activeFranchise);
if(popupSubEl){ var _Tps=window.CWPD_I18N||{}; var _pstmpl=(_Tps.popupSub||'Bekijk ons assortiment {brand} producten'); popupSubEl.textContent=_pstmpl.replace('{brand}',(cfg&&cfg.name?cfg.name:'')); }
popupSelectedTypes=[];
if(popupPriceMinEl) popupPriceMinEl.value = '';
if(popupPriceMaxEl) popupPriceMaxEl.value = '';
popupAvailRadios.forEach(function(r){ r.checked = r.value==='all'; });
popupCurrentSort = 'match';
if(popupSortList) popupSortList.querySelectorAll('.cwcr-popup-sort-opt').forEach(function(b){ b.classList.toggle('cwcr-active',b.dataset.sort==='match'); });
if(typeof syncPopupTopSort==='function') syncPopupTopSort();
if(popupTypeGroup) popupTypeGroup.style.display='none';
if(popupEl) popupEl.classList.add('cwcr-show');
fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
var badge=document.getElementById('cwcr-popup-cart-count');
if(badge) badge.textContent = cart.item_count;
}).catch(function(){});
document.body.style.overflow = 'hidden';
document.querySelectorAll('header,.header-wrapper,.shopify-section-header,#shopify-section-header,.announcement-bar,sticky-header,.cwh-nav,#cwh-nav').forEach(function(el){ el.style.display='none'; });
var ck='cwcr-popup-' + activeFranchise;
var cached=sessionStorage.getItem(ck);
if(cached){
try { return renderPopupGrid(JSON.parse(cached),activeSetName); }
catch(e){}
}
if(popupGrid) popupGrid.innerHTML = '<div class="cwcr-popup-loading">Producten laden...</div>';
fetch(CWCR_BASE_URL+'/api/tcg/shop-products?tag=' + encodeURIComponent(tag))
.then(function(r){return r.json();})
.then(function(products){
sessionStorage.setItem(ck,JSON.stringify(products));
renderPopupGrid(products,activeSetName);
})
.catch(function(){
if(popupGrid) popupGrid.innerHTML = '<div class="cwcr-popup-empty">Kon producten niet laden. Probeer opnieuw.</div>';
});
}
function closePopup(){
if(popupEl) popupEl.classList.remove('cwcr-show');
document.body.style.overflow = '';
document.querySelectorAll('header,.header-wrapper,.shopify-section-header,#shopify-section-header,.announcement-bar,sticky-header,.cwh-nav,#cwh-nav').forEach(function(el){ el.style.display=''; });
var iframe=document.getElementById('cwcr-popup-iframe');
if(iframe) iframe.src = '';
}
function renderPopupGrid(products,setLabel){
if(!popupGrid) return;
if(products && products.length){
popupAllProducts = products;
var typeKeywords=['Booster Box','Elite Trainer Box','ETB','Tin','Collection Box','Collection','Blister','Pre-Order','Bundle','Starter Deck','Collector Chest','Promo','Display'];
var typeCounts={};
var matchedProductIds={};
popupAllProducts.forEach(function(p,i){
var matched=false;
typeKeywords.forEach(function(kw){
if(p.title && p.title.toLowerCase().indexOf(kw.toLowerCase())>-1){
typeCounts[kw] = (typeCounts[kw] || 0) + 1;
matched=true;
}
});
if(!matched){
typeCounts['Overig'] = (typeCounts['Overig'] || 0) + 1;
}
});
var foundTypes=typeKeywords.filter(function(kw){ return typeCounts[kw]>0; });
if(typeCounts['Overig']) foundTypes.push('Overig');
if(popupTypeListEl && popupTypeGroup){
if(foundTypes.length){
popupTypeGroup.style.display='';
var allCount=popupAllProducts.length;
var html='<label class="cwcr-popup-filter-check"><input type="checkbox" class="cwcr-popup-type-check cwcr-popup-type-all" data-type="__all"><span>Alle <span style="opacity:.5;font-size:11px">(' + allCount + ')</span></span></label>';
html += foundTypes.map(function(kw){
return '<label class="cwcr-popup-filter-check"><input type="checkbox" class="cwcr-popup-type-check" data-type="' + kw + '"><span>' + kw + ' <span style="opacity:.5;font-size:11px">(' + (typeCounts[kw] || 0) + ')</span></span></label>';
}).join('');
popupTypeListEl.innerHTML = html;
popupTypeListEl.querySelectorAll('.cwcr-popup-type-check').forEach(function(cb){
cb.addEventListener('change',function(){
if(cb.dataset.type==='__all'){
popupTypeListEl.querySelectorAll('.cwcr-popup-type-check').forEach(function(c){ if(c!==cb) c.checked=false; });
popupSelectedTypes=[];
}else{
var allCb=popupTypeListEl.querySelector('.cwcr-popup-type-all');
if(allCb) allCb.checked=false;
popupSelectedTypes = Array.from(popupTypeListEl.querySelectorAll('.cwcr-popup-type-check:checked')).filter(function(c){ return c.dataset.type!=='__all'; }).map(function(c){ return c.dataset.type; });
}
renderPopupGrid(null,undefined);
});
});
}else{
popupTypeGroup.style.display='none';
}
}
}
if(setLabel!==undefined) popupCurrentSetLabel = setLabel || '';
var keywords=popupCurrentSetLabel
? popupCurrentSetLabel.replace(/^[A-Z]{2,4}-\d+\s*[-–]\s*/i,'').split(/[\s\-]+/).filter(function(k){ return k.length>2; })
: [];
function isMatch(title){
if(!keywords.length) return false;
var t=title.toLowerCase();
return keywords.some(function(k){ return t.indexOf(k.toLowerCase())>-1; });
}
var availVal='all';
popupAvailRadios.forEach(function(r){ if(r.checked) availVal = r.value; });
var base=availVal==='yes' ? popupAllProducts.filter(function(p){ return p.available; })
 : availVal==='no'  ? popupAllProducts.filter(function(p){ return !p.available; })
 : popupAllProducts.slice();
if(popupSearchQuery){var sq=popupSearchQuery.toLowerCase();base=base.filter(function(p){return p.title&&p.title.toLowerCase().indexOf(sq)>-1;});}
if(popupSelectedTypes.length){
var knownKws=['Booster Box','Elite Trainer Box','ETB','Tin','Collection Box','Collection','Blister','Pre-Order','Bundle','Starter Deck','Collector Chest','Promo','Display'];
base = base.filter(function(p){
return popupSelectedTypes.some(function(kw){
if(kw==='Overig'){
return !knownKws.some(function(k){ return p.title && p.title.toLowerCase().indexOf(k.toLowerCase())>-1; });
}
return p.title && p.title.toLowerCase().indexOf(kw.toLowerCase())>-1;
});
});
}
var pMin=popupPriceMinEl ? parseFloat(popupPriceMinEl.value) || 0 : 0;
var pMax=popupPriceMaxEl ? parseFloat(popupPriceMaxEl.value) || 0 : 0;
if(pMin>0) base = base.filter(function(p){ return (p.price || 0)>=pMin; });
if(pMax>0) base = base.filter(function(p){ return (p.price || 0)<=pMax; });
var sorted=base.sort(function(a,b){
var avA=a.available ? 0 : 1,avB = b.available ? 0 : 1;
if(avA!==avB) return avA - avB;
if(popupCurrentSort==='price-asc') return (a.price || 0) - (b.price || 0);
if(popupCurrentSort==='price-desc') return (b.price || 0) - (a.price || 0);
if(popupCurrentSort==='name') return (a.title || '').localeCompare(b.title || '');
if(popupCurrentSort==='name-desc') return (b.title || '').localeCompare(a.title || '');
var am=isMatch(a.title) ? 0 : 1,bm = isMatch(b.title) ? 0 : 1;
if(am!==bm) return am - bm;
return 0;
});
var rcEl=document.getElementById('cwcr-popup-result-count');
if(rcEl) rcEl.textContent = sorted.length + (sorted.length===1?' product':' producten');
var acEl=document.getElementById('cwcr-popup-filter-apply-count');
if(acEl) acEl.textContent = ' (' + sorted.length + ')';
var clearBtn=document.getElementById('cwcr-popup-clear-filters');
if(clearBtn){
  var availVal2='all';popupAvailRadios.forEach(function(r){if(r.checked)availVal2=r.value;});
  var hasFilter=popupSearchQuery||(availVal2!=='all')||popupSelectedTypes.length||(popupPriceMinEl&&popupPriceMinEl.value)||(popupPriceMaxEl&&popupPriceMaxEl.value);
  clearBtn.style.display=hasFilter?'':'none';
}
if(!sorted.length){
popupGrid.innerHTML = '<div class="cwcr-popup-empty">Geen producten gevonden.</div>';
return;
}
var html='';
sorted.forEach(function(p){
var match=isMatch(p.title);
var price=p.price ? p.price.toFixed(2) : null;
html += '<div class="cwcr-popup-card' + (match ? ' cwcr-shop-match' : '') + '">';
if(p.img){
html += '<div class="cwcr-popup-img"><a href="/products/' + esc(p.handle) + '" target="_blank">';
html += '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">';
html += '</a></div>';
}
html += '<div class="cwcr-popup-info">';
html += '<a href="/products/' + esc(p.handle) + '" class="cwcr-popup-name" target="_blank">' + esc(p.title) + '</a>';
if(price){
html += '<div class="cwcr-popup-price-line">';
html += '<span class="cwcr-popup-price">\u20ac' + price + '</span>';
if(CWCR_RIPS_PER_EURO>0){
var rips=Math.round(p.price * CWCR_RIPS_PER_EURO);
if(rips>0) html += '<span class="cwcr-popup-rips">+' + rips + ' RIPS</span>';
}
html += '</div>';
}
if(p.available && p.variantId){
html += '<button class="cwcr-popup-atc" data-variant="' + p.variantId + '">🛒 Toevoegen</button>';
}else{
html += '<div class="cwcr-popup-sold">Uitverkocht</div>';
}
html += '</div></div>';
});
popupGrid.innerHTML = html;
}
if(stickyBtn) stickyBtn.addEventListener('click',function(){ window.open('/collections/all','_blank'); });
if(stickyCloseBtn) stickyCloseBtn.addEventListener('click',function(){ stickyDismissed=true; if(stickyBarEl) stickyBarEl.classList.remove('cwcr-show'); });
// Light-thema: actieve-filters balk net onder de "Filteren" kop in de sidebar plaatsen
if(document.documentElement.classList.contains('cwcr-theme-light')){
  var _af=document.getElementById('cwcr-active-filters');
  var _sbInner=document.getElementById('cwcr-sidebar-inner');
  var _sbHeader=_sbInner?_sbInner.querySelector('.cwcr-sidebar-header'):null;
  if(_af&&_sbInner&&_sbHeader){ _sbHeader.insertAdjacentElement('afterend',_af); _af.classList.add('cwcr-active-filters-sidebar'); }
}
if(popupClose) popupClose.addEventListener('click',closePopup);
// Mobile filter: inline accordion — geen overlay, geen DOM movement
(function(){
  var toggleBtn=document.getElementById('cwcr-popup-filter-toggle');
  var filterPanel=document.getElementById('cwcr-popup-filter-panel');
  var applyBtn=document.getElementById('cwcr-popup-filter-apply');
  if(!toggleBtn||!filterPanel) return;
  function closeFilters(){
    filterPanel.classList.remove('is-open');
    toggleBtn.classList.remove('is-open');
  }
  toggleBtn.addEventListener('click',function(){
    var open=filterPanel.classList.toggle('is-open');
    toggleBtn.classList.toggle('is-open',open);
  });
  if(applyBtn) applyBtn.addEventListener('click',closeFilters);
})();
var cwcrClearFiltersBtn=document.getElementById('cwcr-popup-clear-filters');
if(cwcrClearFiltersBtn){cwcrClearFiltersBtn.addEventListener('click',function(){
  popupSearchQuery='';popupSelectedTypes=[];
  if(popupSearchEl)popupSearchEl.value='';
  if(popupPriceMinEl)popupPriceMinEl.value='';
  if(popupPriceMaxEl)popupPriceMaxEl.value='';
  popupAvailRadios.forEach(function(r){r.checked=r.value==='all';});
  if(popupTypeListEl)popupTypeListEl.querySelectorAll('.cwcr-popup-type-check').forEach(function(c){c.checked=false;});
  renderPopupGrid(null,undefined);
});}
if(popupPriceMinEl) popupPriceMinEl.addEventListener('input',function(){ renderPopupGrid(null,undefined); });
if(popupPriceMaxEl) popupPriceMaxEl.addEventListener('input',function(){ renderPopupGrid(null,undefined); });
popupAvailRadios.forEach(function(r){ r.addEventListener('change',function(){ renderPopupGrid(null,undefined); }); });
var popupSearchEl=document.getElementById('cwcr-popup-search');
if(popupSearchEl){popupSearchEl.addEventListener('input',function(){popupSearchQuery=popupSearchEl.value.trim();renderPopupGrid(null,undefined);});}
if(popupSortList){
popupSortList.addEventListener('click',function(e){
var btn=e.target.closest('.cwcr-popup-sort-opt');
if(!btn) return;
popupCurrentSort = btn.dataset.sort;
popupSortList.querySelectorAll('.cwcr-popup-sort-opt').forEach(function(b){ b.classList.remove('cwcr-active'); });
btn.classList.add('cwcr-active');
syncPopupTopSort();
renderPopupGrid(null,undefined);
});
}
// Top sort dropdown in cwcr-popup-main
var popupSortDD=document.getElementById('cwcr-popup-sortdd');
cwcrInitSortDropdown('cwcr-popup-sortdd',function(sk){
popupCurrentSort=sk;
if(popupSortList) popupSortList.querySelectorAll('.cwcr-popup-sort-opt').forEach(function(b){ b.classList.toggle('cwcr-active',b.dataset.sort===popupCurrentSort); });
renderPopupGrid(null,undefined);
});
// Zet de popup-dropdown terug naar de huidige popupCurrentSort (bv. 'match' na reset)
function syncPopupTopSort(){
if(!popupSortDD) return;
var opts=popupSortDD.querySelectorAll('.cwcr-sortdd-opt');
var match=null;
opts.forEach(function(o){
var ok=o.dataset.sort===popupCurrentSort;
o.classList.toggle('cwcr-active',ok);
if(ok) match=o;
});
if(match){
popupSortDD.dataset.sort=popupCurrentSort;
_ddSyncPill(match,popupSortDD.querySelector('.cwcr-sortdd-cur'));
}
}
document.addEventListener('keydown',function(e){
if(e.key==='Escape' && popupEl && popupEl.classList.contains('cwcr-show')) closePopup();
});
var popupMainEl=document.querySelector('.cwcr-popup-main');
function renderPopupDetail(product){
if(!popupMainEl) return;
var price=product.price ? product.price.toFixed(2) : null;
var html='<div class="cwcr-popup-detail">';
html += '<button class="cwcr-popup-detail-back" id="cwcr-popup-detail-back">&#8592; Terug</button>';
if(product.img){
html += '<div class="cwcr-popup-detail-img"><img src="' + esc(product.img) + '" alt="' + esc(product.title) + '"></div>';
}
html += '<div class="cwcr-popup-detail-title">' + esc(product.title) + '</div>';
if(price){
html += '<div class="cwcr-popup-detail-price">\u20ac' + price + '</div>';
if(CWCR_RIPS_PER_EURO>0){
var drips=Math.round(product.price * CWCR_RIPS_PER_EURO);
if(drips>0) html += '<div class="cwcr-popup-rips" style="margin-bottom:16px;">+' + drips + ' RIPS</div>';
}
}
if(product.available && product.variantId){
html += '<button class="cwcr-popup-detail-atc" data-variant="' + product.variantId + '">Toevoegen</button>';
}else{
html += '<div class="cwcr-popup-detail-sold">Uitverkocht</div>';
}
html += '<a href="/products/' + esc(product.handle) + '" class="cwcr-popup-detail-link" target="_blank">Bekijk op website &#8594;</a>';
html += '</div>';
popupMainEl.innerHTML = html;
var backBtn=document.getElementById('cwcr-popup-detail-back');
if(backBtn){
backBtn.addEventListener('click',function(){
popupMainEl.innerHTML = '<div class="cwcr-popup-grid" id="cwcr-popup-grid"></div>';
popupGrid = document.getElementById('cwcr-popup-grid');
renderPopupGrid(null,undefined);
bindPopupGridEvents();
});
}
var detailAtcBtn=popupMainEl.querySelector('.cwcr-popup-detail-atc');
if(detailAtcBtn){
detailAtcBtn.addEventListener('click',function(){
var variantId=detailAtcBtn.dataset.variant;
if(!variantId) return;
detailAtcBtn.disabled=true; detailAtcBtn.textContent = '...';
var cartEl=document.querySelector('cart-notification') || document.querySelector('cart-drawer');
var fd=new FormData();
fd.append('id',variantId);
fd.append('quantity','1');
if(cartEl && typeof cartEl.getSectionsToRender==='function'){
var ids=cartEl.getSectionsToRender().map(function(s){ return s.id; });
fd.append('sections',ids.join(','));
fd.append('sections_url',window.location.pathname);
}
fetch('/cart/add.js',{
method: 'POST',headers: { 'X-Requested-With': 'XMLHttpRequest' },body: fd
})
.then(function(r){ if(!r.ok) throw new Error('fail'); return r.json(); })
.then(function(){
detailAtcBtn.disabled=false; detailAtcBtn.textContent = 'Toegevoegd!';
fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
var popBadge=document.getElementById('cwcr-popup-cart-count');
if(popBadge) popBadge.textContent = cart.item_count;
}).catch(function(){});
setTimeout(function(){ detailAtcBtn.textContent = 'Toevoegen'; },2000);
})
.catch(function(){ detailAtcBtn.disabled=false; detailAtcBtn.textContent = 'Toevoegen'; });
});
}
}
function bindPopupGridEvents(){
if(!popupGrid) return;
popupGrid.addEventListener('click',function(e){
var atcBtn=e.target.closest('.cwcr-popup-atc');
if(atcBtn) return;
var card=e.target.closest('.cwcr-popup-card');
if(!card) return;
e.preventDefault();
var link=card.querySelector('a[href]');
if(!link) return;
var href=link.getAttribute('href') || '';
var handleMatch=href.match(/\/products\/([^?#"]+)/);
if(!handleMatch) return;
var handle=handleMatch[1];
var product=null;
for(var i=0; i<popupAllProducts.length; i++){
if(popupAllProducts[i].handle===handle){ product = popupAllProducts[i]; break; }
}
if(product) renderPopupDetail(product);
});
popupGrid.addEventListener('click',function(e){
var btn=e.target.closest('.cwcr-popup-atc');
if(!btn) return;
var variantId=btn.dataset.variant;
if(!variantId) return;
btn.disabled=true; btn.textContent = '...';
var cartEl=document.querySelector('cart-notification') || document.querySelector('cart-drawer');
var fd=new FormData();
fd.append('id',variantId);
fd.append('quantity','1');
if(cartEl && typeof cartEl.getSectionsToRender==='function'){
var ids=cartEl.getSectionsToRender().map(function(s){ return s.id; });
fd.append('sections',ids.join(','));
fd.append('sections_url',window.location.pathname);
}
fetch('/cart/add.js',{
method: 'POST',headers: { 'X-Requested-With': 'XMLHttpRequest' },body: fd
})
.then(function(r){ if(!r.ok) throw new Error('fail'); return r.json(); })
.then(function(resp){
btn.disabled=false; btn.innerHTML = '&#10003; Toegevoegd!';
fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
var popBadge=document.getElementById('cwcr-popup-cart-count');
if(popBadge) popBadge.textContent = cart.item_count;
document.querySelectorAll('.cart-count-bubble span,.cart-count,[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
document.querySelectorAll('.cart-count-bubble').forEach(function(el){ if(cart.item_count>0) el.classList.remove('hidden'); });
}).catch(function(){});
setTimeout(function(){ btn.innerHTML = '&#128722; Toevoegen'; },2000);
})
.catch(function(){ btn.disabled=false; btn.innerHTML = '&#128722; Toevoegen'; });
});
}
bindPopupGridEvents();
var typingPhrases=(window.CWPD_I18N && window.CWPD_I18N.typingPhrases) || [
'Zoek kaart, character, set of franchise...','bv. "Charizard" - zoekt in alle franchises','bv. "Luffy" - One Piece + meer','bv. "Prismatic Evolutions"','bv. "OP09-119"','bv. "Surging Sparks"','bv. "Goku" - Dragon Ball Super (binnenkort)'
];
var typingIdx=0,typingCharIdx=0,typingDeleting=false,typingPause=0;
function typingTick(){
if(!unifiedTyping) return;
if(unifiedSearch && unifiedSearch.value.length>0){
unifiedTyping.textContent = '';
requestAnimationFrame(function(){ setTimeout(typingTick,100); });
return;
}
var phrase=typingPhrases[typingIdx];
if(typingPause>0){ typingPause--; requestAnimationFrame(function(){ setTimeout(typingTick,60); }); return; }
if(!typingDeleting){
typingCharIdx++;
if(typingCharIdx>phrase.length){ typingPause = 30; typingDeleting=true; }
}else{
typingCharIdx--;
if(typingCharIdx<=0){ typingDeleting=false; typingIdx = (typingIdx + 1) % typingPhrases.length; }
}
unifiedTyping.textContent = phrase.substring(0,typingCharIdx);
requestAnimationFrame(function(){ setTimeout(typingTick,typingDeleting ? 30 : 70); });
}
typingTick();
var unifiedTimer=null;
function isCardNumber(q){
return /^#?\d+$/.test(q) || /^[a-zA-Z0-9]+-\d+$/i.test(q);
}
if(unifiedSearch){
unifiedSearch.addEventListener('input',function(){
clearTimeout(unifiedTimer);
var q=unifiedSearch.value.trim();
if(!q){
buildChips(allSets);
resetCardGrid();
showEmptyState();
}else{
/* Live set-match: filter chips lokaal op contains(query, label).
   <1ms, 100% client-side, geen API calls. Fallback op alle sets bij
   0 matches zodat de chips-rij nooit volledig leeg lijkt. */
var ql=q.toLowerCase();
var matchingSets=allSets.filter(function(s){
return (s.label||'').toLowerCase().indexOf(ql)!==-1;
});
buildChips(matchingSets.length>0?matchingSets:allSets);
}
});
}
if(unifiedBtn){
unifiedBtn.addEventListener('click',function(){
if(!unifiedSearch) return;
var q=unifiedSearch.value.trim();
if(q.length>=2){ clearTimeout(unifiedTimer); doCardSearch(q); }
});
}
if(unifiedSearch){
unifiedSearch.addEventListener('keydown',function(e){
if(e.key==='Enter'){
e.preventDefault();
var q=unifiedSearch.value.trim();
if(q.length>=2){ clearTimeout(unifiedTimer); doCardSearch(q); }
}
});
}
(function(){
  var hdr=document.querySelector('#shopify-section-header .header,.shopify-section--header .header,header[role="banner"]');
  var headerH=(hdr ? hdr.offsetHeight : 68);
  document.documentElement.style.setProperty('--cwcr-header-h',headerH+'px');

  var wrap=document.querySelector('.cwcr-unified-search-wrap');
  if(!wrap) return;

  // Placeholder die de hoogte vasthoudt als wrap fixed wordt
  var ph=document.createElement('div');
  ph.style.cssText='display:none;height:0;pointer-events:none;';
  wrap.parentNode.insertBefore(ph,wrap);

  var origTop=null;
  var isFixed=false;

  function calcOrigTop(){
    var rect=wrap.getBoundingClientRect();
    origTop=rect.top+window.scrollY-headerH;
  }

  function onScroll(){
    if(origTop===null) calcOrigTop();
    var shouldFix=window.scrollY>origTop;
    if(shouldFix && !isFixed){
      isFixed=true;
      ph.style.display='block';
      ph.style.height=wrap.offsetHeight+'px';
      wrap.style.position='fixed';
      wrap.style.top='20px';
      wrap.style.left='0';
      wrap.style.right='0';
      wrap.style.margin='0 auto';
      wrap.style.zIndex='500';
      wrap.style.maxWidth='820px';
      wrap.style.width='calc(100% - 32px)';
      wrap.classList.remove('cwcr-search-snap-in');
      void wrap.offsetWidth;
      wrap.classList.add('cwcr-search-snap-in');
    } else if(!shouldFix && isFixed){
      isFixed=false;
      wrap.classList.remove('cwcr-search-snap-in');
      ph.style.display='none';
      wrap.style.position='';
      wrap.style.top='';
      wrap.style.left='';
      wrap.style.right='';
      wrap.style.margin='';
      wrap.style.zIndex='';
      wrap.style.maxWidth='';
      wrap.style.width='';
    }
  }

  setTimeout(calcOrigTop,600);
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){origTop=null;onScroll();},{passive:true});
})();
var searchAbortController=null;
var searchFranchiseFilter=null;
var frDdBtn=document.getElementById('cwcr-fr-dd-btn'),frDdMenu=document.getElementById('cwcr-fr-dd-menu'),frDdLabel=document.getElementById('cwcr-fr-dd-label'),frDdLabelShort=document.getElementById('cwcr-fr-dd-label-short'),frDdIcon=document.getElementById('cwcr-fr-dd-icon');
function cwcrFrDdSelect(val,label,icon){
  searchFranchiseFilter=val||null;
  if(frDdLabel)frDdLabel.textContent=label;
  // Kort mobiel-label: voor een gekozen franchise volstaat het volledige label,
  // enkel de lange standaard ("Zoek in alles") wordt "Alles".
  if(frDdLabelShort)frDdLabelShort.textContent=val?label:frDdLabelShort.dataset.all||frDdLabelShort.textContent;
  if(frDdIcon)frDdIcon.textContent=icon;
  if(frDdMenu){frDdMenu.querySelectorAll('.cwcr-fr-dd-item').forEach(function(el){el.classList.toggle('cwcr-fr-dd-active',el.dataset.value===val);});}
  if(frDdBtn)frDdBtn.setAttribute('aria-expanded','false');
  if(frDdMenu)frDdMenu.classList.remove('open');
  var aq=unifiedSearch?unifiedSearch.value.trim():'';
  if(aq.length>=2){clearTimeout(unifiedTimer);doCardSearch(aq);}
}
if(frDdBtn){frDdBtn.addEventListener('click',function(e){e.stopPropagation();var open=frDdBtn.getAttribute('aria-expanded')==='true';frDdBtn.setAttribute('aria-expanded',open?'false':'true');if(frDdMenu)frDdMenu.classList.toggle('open',!open);});}
// Tracker: heeft user expliciet "alles"/"all" gekozen in de dropdown?
// Zo ja, dan respecteren we die keuze en syncen we NIET meer met franchise-pill clicks.
var userPickedAllInSearchDd=false;
if(frDdMenu){frDdMenu.querySelectorAll('.cwcr-fr-dd-item:not(.cwcr-fr-dd-disabled)').forEach(function(el){el.addEventListener('click',function(){var icon=el.querySelector('.cwcr-fr-dd-item-icon');var val=el.dataset.value;userPickedAllInSearchDd=(val==='');cwcrFrDdSelect(val,el.querySelector('span:last-child').textContent,icon?icon.textContent:'');});});}
// Sync search-dropdown met franchise-pill keuze (tenzij user expliciet "alles" koos)
window.cwcrSyncFrDdToFranchise=function(franchise){
  if(userPickedAllInSearchDd) return;
  if(!frDdMenu) return;
  var item=frDdMenu.querySelector('.cwcr-fr-dd-item[data-value="'+franchise+'"]');
  if(!item) return;
  var icon=item.querySelector('.cwcr-fr-dd-item-icon');
  cwcrFrDdSelect(franchise,item.querySelector('span:last-child').textContent,icon?icon.textContent:'');
};
document.addEventListener('click',function(e){if(frDdMenu&&!e.target.closest('#cwcr-fr-dd')){frDdBtn&&frDdBtn.setAttribute('aria-expanded','false');frDdMenu.classList.remove('open');}});
function doCardSearch(q){
cwcrTrack('search',{ q: q,franchise: searchFranchiseFilter || '' });
if(searchAbortController){try{searchAbortController.abort();}catch(e){}}
searchAbortController=(typeof AbortController!=='undefined')?new AbortController():null;
var signal=searchAbortController?searchAbortController.signal:undefined;
var fr=searchFranchiseFilter||null;
if(!fr){doCrossSearch(q,signal);return;}
var cacheKey='cwcr-search-tcggo3-'+fr+'-'+q.toLowerCase();
try {
var cached=sessionStorage.getItem(cacheKey);
if(cached){
var parsed=JSON.parse(cached);
resetCardGrid();
if(fr==='pokemon'){
var all=parsed||[];all.sort(pkSortFn);allCards=all;
updateSidebarCounts();updateSidebarRarities();
renderPokemonSearch(all,q);
}else if(fr==='onepiece'){
var cards=parsed||[];cards.sort(opSortFn);allCards=cards;allBulkCards=[];
var bS=document.getElementById('cwcr-bulk-sub-toggle'),bG=document.getElementById('cwcr-bulk-grid');
if(bS)bS.style.display='none';if(bG){bG.innerHTML='';bG.style.display='none';}
updateSidebarCounts();updateSidebarRarities();
if(countEl){countEl.textContent=cards.length+' resultaten voor "'+q+'"';countEl.style.display='';}
_renderSetMatches(q);
renderOnePiece(cards,null,true);
}
return;
}
} catch(e){}
resetCardGrid();showChaseLoading((((window.CWPD_I18N&&window.CWPD_I18N.searchingFor)||'Zoeken naar')+' "'+q+'"...'));renderSkeletons(24);
var base=CWCR_BASE_URL+'/api/tcg/';
if(fr==='pokemon'){
var pkSearchPromise=fetch(base+'pk-search?q='+encodeURIComponent(q)+'&v=2',signal?{signal:signal}:{})
.then(function(r){return r.json();})
.then(function(data){
var all=data.data||[];
all.forEach(function(c){
var cp=c.cardmarket&&c.cardmarket.prices?c.cardmarket.prices:null;
var cmPrice=cwcrCmPrice(cp);
var tp=c.tcgplayer&&c.tcgplayer.prices?c.tcgplayer.prices:null;
var tcgPrice=tp?((tp.holofoil&&(tp.holofoil.market||tp.holofoil.mid))||(tp.normal&&(tp.normal.market||tp.normal.mid))||0)*0.92:0;
c._price=cmPrice||tcgPrice||0;
});
if(all.length>0){try{sessionStorage.setItem(cacheKey,JSON.stringify(all));}catch(e){}}
return all;
});
if(!(cwcrSetsCache.pokemon||[]).length) cwcrLoadSetsLazy('pokemon');
var pkSetPromise=_fetchSetCardsForQuery(q,signal).then(function(r){return r.pk||[];}).catch(function(){return[];});
Promise.all([pkSearchPromise,pkSetPromise]).then(function(res){
var all=_mergeCards(res[0]||[],res[1],function(c){return c.id||c.card_id||c.number||'';});
all.sort(pkSortFn);allCards=all;
updateSidebarCounts();updateSidebarRarities();
renderPokemonSearch(all,q);
}).catch(function(err){if(err&&err.name==='AbortError')return;hideChaseLoading();});
}else if(fr==='onepiece'){
var opSearchPromise=fetch(base+'op-search?q='+encodeURIComponent(q)+'&v=2',signal?{signal:signal}:{})
.then(function(r){return r.json();})
.then(function(cards){
if(!Array.isArray(cards))return[];
cards.forEach(function(c){c._price=parseFloat(c.price||c.market_price||0)||0;});
if(cards.length>0){try{sessionStorage.setItem(cacheKey,JSON.stringify(cards));}catch(e){}}
return cards;
});
if(!(cwcrSetsCache.onepiece||[]).length) cwcrLoadSetsLazy('onepiece');
var opSetPromise=_fetchSetCardsForQuery(q,signal).then(function(r){return r.op||[];}).catch(function(){return[];});
Promise.all([opSearchPromise,opSetPromise]).then(function(res){
var cards=_mergeCards(res[0]||[],res[1],function(c){return c.id||c.card_id||c.card_number||'';});
cards.sort(opSortFn);allCards=cards;allBulkCards=[];
var bS3=document.getElementById('cwcr-bulk-sub-toggle'),bG3=document.getElementById('cwcr-bulk-grid');
if(bS3)bS3.style.display='none';if(bG3){bG3.innerHTML='';bG3.style.display='none';}
updateSidebarCounts();updateSidebarRarities();
if(!cards.length){
if(grid){grid.innerHTML='<div class="cwcr-chase-empty">0 resultaten voor "'+esc(q)+'" in One Piece.</div>';grid.style.display='';}
if(countEl)countEl.style.display='none';
hideChaseLoading();return;
}
if(countEl){countEl.textContent=cards.length+' resultaten voor "'+q+'"';countEl.style.display='';}
renderOnePiece(cards,null,true);
}).catch(function(err){if(err&&err.name==='AbortError')return;hideChaseLoading();});
}
}
function _buildCrossCards(cards,fr){
var isOp=fr==='onepiece',h='';
cards.forEach(function(c,idx){
var price=c._price||0;
var name=isOp?(c.name||c.card_name||''):(c.name||'');
var num=isOp?(c.card_number||c.number||c.card_id||''):(c.number||'');
var set2=isOp?((c.episode&&c.episode.name)||c.set_name||''):(c.set?c.set.name:'');
var link=isOp?(c.cardmarket_url||''):((c.cardmarket&&c.cardmarket.url)||'');
var rar=c.rarity||'';
var ri=isOp?(opRarity[rar]||{label:rar,cls:'cwcr-badge-other'}):(pkRarity[rar]||{label:rar,cls:'cwcr-badge-other'});
h+='<div class="cwcr-chase-img-card" data-card-idx="'+idx+'" data-franchise="'+fr+'"'+(link?' data-href="'+esc(link)+'"':'')+'>'
+'<div class="cwcr-chase-img-topbar"><span class="cwcr-chase-img-badge '+ri.cls+'" title="'+esc(ri.label)+'">'+cwcrBadgeInner(ri)+'</span>'+(num?'<span class="cwcr-chase-img-topnum">#'+esc(num)+'</span>':'')+'</div>'
+'<div class="cwcr-chase-img-wrap cwcr-img-loading">'
+cwcrCardImgHtml(c,fr,name)
+'</div><div class="cwcr-chase-img-info">'
+'<div class="cwcr-chase-img-name">'+esc(name)+'</div>'
+(set2?'<div class="cwcr-chase-img-set">'+esc(set2)+'</div>':'')
+(price>0?'<div class="cwcr-chase-img-pricerow"><div class="cwcr-chase-img-price">'+(c._currency==='USD'?'$':'\u20ac')+parseFloat(price).toFixed(2)+'</div></div>':'')
+(c._currency==='USD'?'<span class="cwcr-usd-badge" title="EU prijs niet beschikbaar \u2014 TCGplayer USD prijs">USD</span>':'')
+'<button class="cwcr-card-detail-btn" data-card-idx="'+idx+'" data-franchise="'+fr+'">'+((window.CWPD_I18N && window.CWPD_I18N.viewAnalysis) || 'Bekijk analyse')+'</button>'
+'</div></div>';
});
return h;
}
function _rerenderCrossGrid(){
var pkCards=cwcrCardRegistry['pokemon']||[];
var opCards=cwcrCardRegistry['onepiece']||[];
// Build combined rarity counts for the pills above the grid
var crossRarCounts={};
pkCards.concat(opCards).forEach(function(c){if(c.rarity)crossRarCounts[c.rarity]=(crossRarCounts[c.rarity]||0)+1;});
currentCounts=crossRarCounts;
renderRarityCounts(crossRarCounts);
var crossSections=[];
if(pkCards.length) crossSections.push({cards:pkCards,fr:'pokemon',badge:'<span class="cwcr-cross-fr-badge cwcr-cross-pk">\ud83d\udd34 Pok\u00e9mon</span>',count:pkCards.length});
if(opCards.length) crossSections.push({cards:opCards,fr:'onepiece',badge:'<span class="cwcr-cross-fr-badge cwcr-cross-op">\u2715 One Piece</span>',count:opCards.length});
crossSections.sort(function(a,b){return b.count-a.count;});
var html='';
crossSections.forEach(function(s,si){
html+='<div class="cwcr-cross-section" data-cross-fr="'+s.fr+'">'
+'<button class="cwcr-cross-section-header cwcr-cross-toggle" type="button" aria-expanded="true" data-cross-idx="'+si+'">'
+s.badge+'<span class="cwcr-cross-count">'+s.count+' resultaten</span>'
+'<span class="cwcr-cross-toggle-line"></span>'
+'<span class="cwcr-cross-toggle-icon">\u2212</span>'
+'</button>'
+'<div class="cwcr-cross-grid cwcr-cross-body" id="cwcr-cross-body-'+si+'">'+_buildCrossCards(s.cards,s.fr)+'</div>'
+'</div>';
});
if(grid){
grid.innerHTML=html;grid.style.display='';
grid.querySelectorAll('.cwcr-cross-toggle').forEach(function(btn){
btn.addEventListener('click',function(){
var idx=btn.dataset.crossIdx;
var body=document.getElementById('cwcr-cross-body-'+idx);
var expanded=btn.getAttribute('aria-expanded')==='true';
btn.setAttribute('aria-expanded',String(!expanded));
if(body) body.style.display=expanded?'none':'';
var icon=btn.querySelector('.cwcr-cross-toggle-icon');
if(icon) icon.textContent=expanded?'+':'\u2212';
});
});
}
}
/* Haal kaarten op van sets waarvan de naam de query bevat (max 2 sets per franchise).
   Retourneert { pk: [...], op: [...] } \u2014 puur data, geen render. */
function _fetchSetCardsForQuery(q,signal){
var ql=q.toLowerCase(),base=CWCR_BASE_URL+'/api/tcg/',so=signal?{signal:signal}:{};
function fetchPkSet(setId){
  var ck='cwcr-cards-pk-tcggo5-'+setId;
  try{var cached=JSON.parse(sessionStorage.getItem(ck));if(cached){var arr=cached.allCards||cached.cards||cached;return Promise.resolve(Array.isArray(arr)?arr:[]);}}catch(e){}
  return fetch(base+'pk-cards/'+encodeURIComponent(setId),so).then(function(r){return r.json();}).then(function(data){
    var cards=data.data||[];
    cards.forEach(function(c){var cp=c.cardmarket&&c.cardmarket.prices?c.cardmarket.prices:null;var tp=c.tcgplayer&&c.tcgplayer.prices?c.tcgplayer.prices:null;var tcgP=tp?((tp.holofoil&&(tp.holofoil.market||tp.holofoil.mid))||(tp.normal&&(tp.normal.market||tp.normal.mid))||0)*0.92:0;c._price=cwcrCmPrice(cp)||tcgP||0;});
    return cards;
  }).catch(function(err){if(err&&err.name==='AbortError')throw err;return[];});
}
function fetchOpSet(setId){
  var ck='cwcr-cards-op-tcggo4-'+setId;
  try{var cached=JSON.parse(sessionStorage.getItem(ck));if(cached){var arr=cached.allCards||cached.cards||cached;return Promise.resolve(Array.isArray(arr)?arr:[]);}}catch(e){}
  return fetch(base+'op-cards/'+encodeURIComponent(setId),so).then(function(r){return r.json();}).then(function(cards){
    if(!Array.isArray(cards))return[];
    cards.forEach(function(c){c._price=parseFloat(c.price||c.market_price||0)||0;});
    return cards;
  }).catch(function(err){if(err&&err.name==='AbortError')throw err;return[];});
}
/* Wacht op sets-cache voor beide franchises, dan match en fetch kaarten */
return Promise.all([cwcrLoadSetsLazy('pokemon').catch(function(){return[];}),cwcrLoadSetsLazy('onepiece').catch(function(){return[];})]).then(function(){
  var pkSets=(cwcrSetsCache.pokemon||[]).filter(function(s){return(s.label||'').toLowerCase().indexOf(ql)!==-1;}).slice(0,2);
  var opSets=(cwcrSetsCache.onepiece||[]).filter(function(s){return(s.label||'').toLowerCase().indexOf(ql)!==-1;}).slice(0,2);
  return Promise.all([Promise.all(pkSets.map(function(s){return fetchPkSet(s.id);})),Promise.all(opSets.map(function(s){return fetchOpSet(s.id);}))]);
}).then(function(res){
  var pk=[].concat.apply([],res[0]),op=[].concat.apply([],res[1]);
  return{pk:pk,op:op};
}).catch(function(err){if(err&&err.name==='AbortError')throw err;return{pk:[],op:[]};});
}
function _mergeCards(base,extra,idFn){
var seen={};base.forEach(function(c){seen[idFn(c)]=true;});
var added=extra.filter(function(c){var k=idFn(c);if(seen[k])return false;seen[k]=true;return true;});
return base.concat(added);
}
function doCrossSearch(q,signal){
var ql=q.toLowerCase(),ckPk='cwcr-search-tcggo3-pokemon-'+ql,ckOp='cwcr-search-tcggo4-onepiece-'+ql;
/* Zorg dat sets-cache voor beide franchises geladen is voor set-match suggesties */
if(typeof cwcrLoadSetsLazy==='function'){
  if(!(cwcrSetsCache.pokemon||[]).length) cwcrLoadSetsLazy('pokemon');
  if(!(cwcrSetsCache.onepiece||[]).length) cwcrLoadSetsLazy('onepiece');
}
resetCardGrid();showChaseLoading((((window.CWPD_I18N&&window.CWPD_I18N.searchingFor)||'Zoeken naar')+' "'+q+'"...'));renderSkeletons(24);
var base=CWCR_BASE_URL+'/api/tcg/';
var cachedPk=null,cachedOp=null,so=signal?{signal:signal}:{};
try{cachedPk=JSON.parse(sessionStorage.getItem(ckPk));}catch(e){}
try{cachedOp=JSON.parse(sessionStorage.getItem(ckOp));}catch(e){}
var pkPromise=cachedPk?Promise.resolve(cachedPk)
:fetch(base+'pk-search?q='+encodeURIComponent(q)+'&v=2',so).then(function(r){return r.json();}).then(function(data){
var cards=data.data||[];cards.forEach(function(c){var cp=c.cardmarket&&c.cardmarket.prices?c.cardmarket.prices:null;c._price=cwcrCmPrice(cp);});
if(cards.length){try{sessionStorage.setItem(ckPk,JSON.stringify(cards));}catch(e){}}return cards;
}).catch(function(err){if(err&&err.name==='AbortError')throw err;return[];});
var opPromise=cachedOp?Promise.resolve(cachedOp)
:fetch(base+'op-search?q='+encodeURIComponent(q)+'&v=2',so).then(function(r){return r.json();}).then(function(cards){
if(!Array.isArray(cards))return[];
cards.forEach(function(c){c._price=parseFloat(c.price||c.market_price||0)||0;});
if(cards.length){try{sessionStorage.setItem(ckOp,JSON.stringify(cards));}catch(e){}}return cards;
}).catch(function(err){if(err&&err.name==='AbortError')throw err;return[];});
var setCardsPromise=_fetchSetCardsForQuery(q,signal).catch(function(){return{pk:[],op:[]};});
Promise.all([pkPromise,opPromise,setCardsPromise]).then(function(results){
var pkCards=results[0]||[],opCards=results[1]||[],setCards=results[2]||{pk:[],op:[]};
pkCards=_mergeCards(pkCards,setCards.pk,function(c){return c.id||c.card_id||c.number||'';});
opCards=_mergeCards(opCards,setCards.op,function(c){return c.id||c.card_id||c.card_number||'';});
pkCards.sort(pkSortFn);opCards.sort(opSortFn);hideChaseLoading();
allCards=pkCards.concat(opCards);cwcrCardRegistry['pokemon']=pkCards;cwcrCardRegistry['onepiece']=opCards;cwcrCardRegistry['pokemon-orig']=pkCards.slice();cwcrCardRegistry['onepiece-orig']=opCards.slice();
var total=pkCards.length+opCards.length;
if(gridSection){gridSection.style.display='';gridSection.classList.add('cwcr-visible');}
var chaseSubToggle=document.getElementById('cwcr-chase-sub-toggle');
if(chaseSubToggle)chaseSubToggle.style.display=total?'':'none';
if(!total){if(grid){grid.innerHTML='<div class="cwcr-chase-empty">0 resultaten voor "'+esc(q)+'" in alle franchises.</div>';grid.style.display='';}if(countEl)countEl.style.display='none';_renderSetMatches(q);return;}
var countParts=[];
var frCounts=[{n:'One Piece',c:opCards.length},{n:'Pok\u00e9mon',c:pkCards.length}];
frCounts.sort(function(a,b){return b.c-a.c;});
frCounts.forEach(function(f){if(f.c) countParts.push(f.c+' in '+f.n);});
if(countEl){countEl.textContent=total+' resultaten voor "'+q+'" - '+countParts.join(', ');countEl.style.display='';}
updateSidebarCounts();updateSidebarRarities();
_rerenderCrossGrid();
_renderSetMatches(q);
}).catch(function(err){ if(err && err.name==='AbortError') return; hideChaseLoading(); });
}
function openCartDrawer(data){
var cn=document.querySelector('cart-notification');
if(cn && typeof cn.renderContents==='function'){
cn.renderContents(data);
return;
}
var drawer=document.getElementById('mini-cart-drawer');
if(drawer){ drawer.classList.add('animate','active'); document.body.classList.add('added__overlay'); }
}
if(shopScrollEl){
shopScrollEl.addEventListener('click',function(e){
var btn=e.target.closest('.cwcr-shop-atc');
if(!btn) return;
var variantId=btn.dataset.variant;
if(!variantId) return;
btn.disabled=true;
btn.textContent = '...';
fetch('/cart/add.js',{
method: 'POST',headers: { 'Content-Type': 'application/json','X-Requested-With': 'XMLHttpRequest' },body: JSON.stringify({id: parseInt(variantId,10),quantity: 1 })
})
.then(function(r){return r.json();})
.then(function(data){
btn.disabled=false;
btn.innerHTML = '✓ Toegevoegd!';
setTimeout(function(){ btn.innerHTML = '🛒 Toevoegen'; },2400);
openCartDrawer(data);
})
.catch(function(){
btn.disabled=false;
btn.innerHTML = '🛒 Toevoegen';
});
});
}
function renderSkeletons(n){
if(!grid) return;
var html='';
for(var i=0; i<n; i++){
html += '<div class="cwcr-chase-img-card">';
html += '<div class="cwcr-chase-img-wrap cwcr-img-loading"></div>';
html += '<div class="cwcr-chase-img-info">';
html += '<div class="cwcr-skel-line cwcr-skel-name"></div>';
html += '<div class="cwcr-skel-line cwcr-skel-num"></div>';
html += '<div class="cwcr-skel-line cwcr-skel-price"></div>';
html += '</div></div>';
}
grid.innerHTML = html;
grid.style.display='';
hideChaseLoading();
}
function renderRarityCounts(counts){
if(!rarityCountsEl || !counts) return;
var rarityClsMap={
'Common': 'common','Uncommon': 'common','Rare': 'rare','Rare Holo': 'rare','Rare Holo EX': 'rare','Rare Holo GX': 'rare','Rare Holo V': 'rare','Rare Holo VMAX': 'rare','Rare Holo VSTAR': 'rare','Double Rare': 'ultra','Ultra Rare': 'ultra','ACE SPEC Rare': 'ultra','Illustration Rare': 'ultra','Special Illustration Rare': 'secret','Hyper Rare': 'secret','Shiny Ultra Rare': 'secret','C': 'common','UC': 'common','R': 'rare','SR': 'ultra','SP': 'ultra','SEC': 'secret','SAR': 'secret',};
var rarityMap;
if(!activeFranchise){rarityMap={};for(var _k in pkRarity)rarityMap[_k]=pkRarity[_k];for(var _k2 in opRarity)if(!rarityMap[_k2])rarityMap[_k2]=opRarity[_k2];}
else{rarityMap=activeFranchise==='onepiece' ? opRarity : pkRarity;}
var entries=Object.keys(counts)
.filter(function(k){ return counts[k]>0; })
.sort(function(a,b){
var pa=rarityMap[a] ? rarityMap[a].pri : 99;
var pb=rarityMap[b] ? rarityMap[b].pri : 99;
if(pa!==pb) return pa - pb;
return a.localeCompare(b);
});
if(!entries.length){ rarityCountsWrap.style.display='none'; return; }
var html=entries.map(function(k){
var cls=rarityClsMap[k] || 'rare';
var isActive=sidebarRarities[k] ? ' cwcr-pill-active' : '';
var xBtn=sidebarRarities[k] ? ' <span class="cwcr-pill-x">\u00d7</span>' : '';
return '<span class="cwcr-rarity-count-pill cwcr-rarity-' + cls + isActive + '" data-rarity="' + esc(k) + '" style="cursor:pointer;">' +
esc(k) + ' <span class="cwcr-rarity-count-num">(' + counts[k] + ')</span>' + xBtn + '</span>';
}).join('');
rarityCountsEl.innerHTML = html;
if(rarityCountsWrap) rarityCountsWrap.style.display='';
}
var rarityBurstColors={
'Hyper Rare': '#ffd632','ACE SPEC Rare': '#ffd632','Special Illustration Rare': '#b060ff','Ultra Rare': '#a050ff','Illustration Rare': '#50a8ff','Double Rare': '#8860ef','Rare Holo': '#8040dd','Rare': '#5533bb','SEC': '#ffd632','SAR': '#b060ff','SR': '#50a8ff','SP': '#8860ef','R': '#5533bb'
};
function spawnRarityBurst(el){
var rarity=el.dataset.rarity || '';
var color=rarityBurstColors[rarity] || '#7b5ea7';
var rect=el.getBoundingClientRect();
var cx=rect.left + rect.width / 2;
var cy=rect.top  + rect.height / 2;
var count=14;
for(var i=0; i<count; i++){
var p=document.createElement('span');
p.className = 'cwcr-burst-particle';
var angle=(i / count) * Math.PI * 2;
var dist=35 + Math.random() * 35;
p.style.cssText = 'left:' + cx + 'px;top:' + cy + 'px;background:' + color + ';';
p.style.setProperty('--bx',(Math.cos(angle) * dist).toFixed(1) + 'px');
p.style.setProperty('--by',(Math.sin(angle) * dist).toFixed(1) + 'px');
document.body.appendChild(p);
setTimeout(function(el2){ if(el2.parentNode) el2.parentNode.removeChild(el2); },600,p);
}
}
if(rarityCountsEl){
rarityCountsEl.addEventListener('click',function(e){
var pill=e.target.closest('.cwcr-rarity-count-pill');
if(!pill || !pill.dataset.rarity) return;
spawnRarityBurst(pill);
setRarityFilter(pill.dataset.rarity);
});
}
var pkRarityExt={
'Secret Rare':       1,'Special Art Rare':  2,'Ultra Rare':        3,'Double Rare':       4,'Rare Holo EX':      5,'Rare Holo V':       5,'Rare Holo VMAX':    5,'Rare Holo VSTAR':   5,'Rare Holo ex':      5,'Rare Holo':         6,'Rare':              7,'Promo':             8,'Uncommon':          9,'Common':           10
};
function pkSortFn(a,b){
var va=a._price || 0,vb = b._price || 0;
if(vb!==va) return vb - va;
var ra=pkRarity[a.rarity] ? pkRarity[a.rarity].pri : (pkRarityExt[a.rarity] || 99);
var rb=pkRarity[b.rarity] ? pkRarity[b.rarity].pri : (pkRarityExt[b.rarity] || 99);
return ra - rb;
}
function fetchPokemon(setId){
var ck='cwcr-cards-pk-tcggo8-' + setId;
var cached=sessionStorage.getItem(ck);
if(gridSection){ gridSection.style.display=''; gridSection.classList.add('cwcr-visible'); }
if(cached){
try {
var obj=JSON.parse(cached);
var allPk=obj.allCards || obj.cards || obj;
allPk.forEach(function(c){ c._price = c._price || 0; });
var cards=allPk.slice();
var usdInCache=allPk.filter(function(c){return c._currency==='USD';}).length;
if(window.CW_DEBUG) console.log('[pricedex] fetchPokemon CACHE HIT voor',setId,': total='+allPk.length+', USD='+usdInCache+', met_prijs='+allPk.filter(function(c){return c._price>0;}).length);
cards.sort(pkSortFn);
allCards = cards;
// Setlijst uit cache. Fallback (oude cache zonder bulk): zelf splitsen op de top-10
// grens zodat chase-kaarten nooit dubbel in de setlijst komen.
if(obj.bulk){ allBulkCards = obj.bulk; }
else { var _pkChaseIdsC={}; cards.slice(0,10).forEach(function(c){ _pkChaseIdsC[(c.id||c.number||'')]=1; }); allBulkCards = allPk.filter(function(c){ return !_pkChaseIdsC[(c.id||c.number||'')]; }); }
allBulkCards.sort(function(a,b){ return (b._price||0)-(a._price||0); });
currentCounts = obj.counts || null;
/* Toon meteen wat we hebben, maar haal de bijwerktijd altijd opnieuw op: kaarten uit de
   sessie-cache bleven anders de datum van bij het eerste bezoek tonen. */
if(obj.updatedAt) cwcrZetUpdate(obj.updatedAt);
cwcrHaalUpdate(CWCR_BASE_URL+'/api/tcg/pk-cards/'+encodeURIComponent(setId), ck, obj, setId);
updateSidebarCounts();
updateSidebarRarities();
renderPokemon(cards,currentCounts);
renderBulkSection(allBulkCards,'pokemon');
return;
} catch(e){ console.warn('[pricedex] fetchPokemon cache parse fout voor',setId,e); }
}
if(window.CW_DEBUG) console.log('[pricedex] fetchPokemon FETCH van server voor',setId);
var _cwUpd=null;
fetch(CWCR_BASE_URL+'/api/tcg/pk-cards/' + encodeURIComponent(setId))
.then(function(r){try{_cwUpd=r.headers.get('X-Cw-Updated');}catch(e){} return r.json();})
.then(function(data){
var all=data.data || [];
var counts={};
all.forEach(function(c){ if(c.rarity) counts[c.rarity] = (counts[c.rarity] || 0) + 1; });
all.forEach(function(c){
var cp=c.cardmarket && c.cardmarket.prices ? c.cardmarket.prices : null;
var cmPrice=cwcrCmPrice(cp);
var tp=c.tcgplayer && c.tcgplayer.prices ? c.tcgplayer.prices : null;
var tcgPrice=tp ? (
(tp.holofoil && (tp.holofoil.market || tp.holofoil.mid)) ||
(tp.normal && (tp.normal.market || tp.normal.mid)) ||
0
) * 0.92 : 0;
c._price = cmPrice || tcgPrice || 0;
});
var usdCards=all.filter(function(c){return c._currency==='USD';}).length;
var withPrice=all.filter(function(c){return c._price>0;}).length;
if(window.CW_DEBUG) console.log('[pricedex] fetchPokemon SERVER RESPONSE voor',setId,': total='+all.length+', USD='+usdCards+', met_prijs='+withPrice);
var top10pk=all.slice();
top10pk.sort(pkSortFn);
var allWithRarity=all.filter(function(c){ return !!c.rarity; });
allWithRarity.forEach(function(c){
delete c.abilities; delete c.attacks; delete c.weaknesses; delete c.resistances;
delete c.retreatCost; delete c.convertedRetreatCost;
delete c.nationalPokedexNumbers; delete c.legalities; delete c.flavorText;
delete c.regulationMark; delete c.artist; delete c.subtypes; delete c.evolvesFrom;
delete c.evolvesTo; delete c.rules; delete c.ancientTrait; delete c.supertype;
});
// Setlijst = ALLE kaarten behalve de 10 duurste (= de top-chase). Splitsen op de
// top-10 grens, NIET op rarity — anders verschijnen dure chase-kaarten dubbel in de
// setlijst en ontbreken er andere. Identiek aan de One Piece-aanpak.
var _pkChaseIds={}; top10pk.slice(0,10).forEach(function(c){ _pkChaseIds[(c.id||c.number||'')]=1; });
var bulkPk=all.filter(function(c){ return !_pkChaseIds[(c.id||c.number||'')]; });
bulkPk.sort(function(a,b){ return (b._price||0)-(a._price||0); });
try { sessionStorage.setItem(ck,JSON.stringify({ allCards: allWithRarity,bulk: bulkPk,counts: counts,updatedAt: _cwUpd })); } catch(e){}
if(_cwUpd) cwcrZetUpdate(_cwUpd); else cwcrHaalUpdate(CWCR_BASE_URL+'/api/tcg/pk-cards/'+encodeURIComponent(setId), null, null, setId);
allCards = top10pk;
allBulkCards = bulkPk;
currentCounts = counts;
updateSidebarCounts();
updateSidebarRarities();
renderPokemon(top10pk,counts);
renderBulkSection(allBulkCards,'pokemon');
})
.catch(function(){
hideChaseLoading();
if(grid){ grid.innerHTML = '<div class="cwcr-chase-empty">Kon kaarten niet laden. Probeer opnieuw.</div>'; grid.style.display=''; }
});
}
function renderPokemon(cards,counts,skipCache){
hideChaseLoading();
if(counts) renderRarityCounts(counts);
var chaseSubToggle=document.getElementById('cwcr-chase-sub-toggle');
if(!cards.length){
if(skipCache){
if(grid){ grid.innerHTML = ''; grid.style.display='none'; }
if(countEl) countEl.style.display='none';
if(chaseSubToggle) chaseSubToggle.style.display='none';
}else{
if(grid){ grid.innerHTML = '<div class="cwcr-chase-empty">Set nog niet beschikbaar in de kaartendatabase.</div>'; grid.style.display=''; }
}
return;
}
var activeRar=Object.keys(sidebarRarities).find(function(k){ return sidebarRarities[k]; });
var rarLabel=activeRar ? ((pkRarity[activeRar] || opRarity[activeRar] || {label: activeRar}).label + ' ') : '';
// In search-mode (user heeft query getypt) tonen we ALLE matches, anders top 10
var _isSearch=(typeof unifiedSearch!=='undefined' && unifiedSearch && unifiedSearch.value && unifiedSearch.value.trim().length>=2);
var top10=_isSearch ? cards : cards.slice(0,10);
if(countEl){ countEl.textContent = ((window.CWPD_I18N && window.CWPD_I18N.topOfCards) || 'top {top} van {total} {rarLabel}kaarten').replace('{top}', top10.length).replace('{total}', cards.length).replace('{rarLabel}', rarLabel); countEl.style.display=''; }
if(chaseSubToggle && top10.length){ chaseSubToggle.style.display=''; }
else if(chaseSubToggle){ chaseSubToggle.style.display='none'; }
var html='';
top10.forEach(function(c,idx){
var info=pkRarity[c.rarity] || { label: c.rarity || '?',cls: 'cwcr-badge-other' };
var price=c._price || null;
var cur=c._currency || 'EUR';
var sym=cur==='USD' ? '$' : '\u20ac';
var link=pkCardmarkUrl(c,c.name);
var min5=filterMin5 && filterMin5.checked;
var hidden=(min5 && (!price || price<5)) ? ' cwcr-hidden' : '';
html += '<div class="cwcr-chase-img-card' + hidden + '" data-card-idx="' + idx + '" data-franchise="pokemon"' + (link ? ' data-href="' + esc(link) + '"' : '') + '>';
html += '<div class="cwcr-chase-img-topbar"><span class="cwcr-chase-img-badge ' + info.cls + '" title="' + esc(info.label) + '">' + cwcrBadgeInner(info) + '</span>' + (c.number ? '<span class="cwcr-chase-img-topnum">#' + esc(c.number) + '</span>' : '') + '</div>';
html += '<div class="cwcr-chase-img-wrap cwcr-img-loading">';
html += cwcrCardImgHtml(c, 'pokemon', c.name);
if(cur==='USD') html += '<span class="cwcr-usd-badge" title="EU prijs niet beschikbaar \u2014 TCGplayer USD prijs">USD</span>';
html += '</div><div class="cwcr-chase-img-info">';
html += '<div class="cwcr-chase-img-name">' + esc(c.name) + '</div>';
var avg7=c.cardmarket && c.cardmarket.prices ? (c.cardmarket.prices.avg7 || 0) : 0;
if(price && price>0){
html += '<div class="cwcr-chase-img-pricerow"><div class="cwcr-chase-img-price">' + sym + parseFloat(price).toFixed(2) + '</div></div>';
if(cur!=='USD' && avg7 && avg7>0 && Math.abs(price - avg7)>0.01){
var delta=price - avg7;
var cls=delta>0.01 ? 'cwcr-avg7-up' : 'cwcr-avg7-down';
var arrow=delta>0.01 ? '\u2191' : '\u2193';
var pct=Math.round(delta / avg7 * 100);
html += '<div class="cwcr-chase-img-avg7 ' + cls + '">' + arrow + ' ' + sym + Math.abs(delta).toFixed(2) + ' (' + (pct>0?'+':'') + pct + '%)</div>';
}
}
html += '<button class="cwcr-card-detail-btn" data-card-idx="' + idx + '" data-franchise="pokemon">' + ((window.CWPD_I18N && window.CWPD_I18N.viewAnalysis) || 'Bekijk analyse') + '</button>';
html += '</div></div>';
});
if(grid){ grid.innerHTML = html; grid.style.display=''; }
cwcrCardRegistry['pokemon'] = cards;
}
/* Render een blokje met sets die matchen op de query, boven het kaart-grid.
   Volledig lokaal (lees uit cwcrSetsCache). Klik op een suggestie opent die set.
   Roept terug naar bestaande cwcrSelectFromDd() die de hele flow afhandelt. */
function _renderSetMatches(q){
var host=document.getElementById('cwcr-chase-body');
var oldBlock=document.getElementById('cwcr-set-matches');
if(oldBlock) oldBlock.parentNode.removeChild(oldBlock);
/* SET_MATCHES_HIDDEN — verwijder deze return om set-chips terug te tonen */
return;
if(!host||!q) return;
var ql=q.toLowerCase();
var matches=[];
['pokemon','onepiece'].forEach(function(fr){
  var sets=(typeof cwcrSetsCache!=='undefined'&&cwcrSetsCache[fr])||[];
  sets.forEach(function(s){
    if((s.label||'').toLowerCase().indexOf(ql)!==-1){
      matches.push({fr:fr,id:s.id,label:s.label});
    }
  });
});
if(!matches.length) return;
matches=matches.slice(0,8);
var titleI18N=(window.CWPD_I18N&&window.CWPD_I18N.matchingSets)||'Matchende sets';
var html='<div id="cwcr-set-matches" class="cwcr-set-matches" style="margin:0 0 18px 0;padding:14px 16px;background:rgba(123,94,167,.08);border:1px solid rgba(123,94,167,.22);border-radius:10px"><div style="font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#9880c0;margin-bottom:10px">'+esc(titleI18N)+' · <span style="opacity:.6">"'+esc(q)+'"</span></div><div style="display:flex;flex-wrap:wrap;gap:8px">';
matches.forEach(function(m){
  var frBadge=m.fr==='pokemon'?'🔴':'✕';
  html+='<button type="button" class="cwcr-set-match-chip" data-fr="'+esc(m.fr)+'" data-set-id="'+esc(m.id)+'" data-set-label="'+esc(m.label)+'" style="padding:7px 14px;background:rgba(255,255,255,.04);border:1px solid rgba(123,94,167,.45);border-radius:100px;color:#fff;font-size:13px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;transition:background .15s">'
    +'<span style="opacity:.7">'+frBadge+'</span>'+esc(m.label)+'</button>';
});
html+='</div></div>';
host.insertAdjacentHTML('afterbegin',html);
var block=document.getElementById('cwcr-set-matches');
if(block){
  block.addEventListener('click',function(e){
    var btn=e.target.closest('.cwcr-set-match-chip');
    if(!btn) return;
    var fr=btn.getAttribute('data-fr');
    var setId=btn.getAttribute('data-set-id');
    var setLabel=btn.getAttribute('data-set-label');
    /* Wis de search-input zodat we niet stuck in search-mode blijven */
    if(typeof unifiedSearch!=='undefined'&&unifiedSearch){unifiedSearch.value='';}
    if(typeof cwcrSelectFromDd==='function') cwcrSelectFromDd(fr,setId,setLabel);
  });
}
}
function renderPokemonSearch(cards,q){
hideChaseLoading();
if(gridSection){ gridSection.style.display=''; gridSection.classList.add('cwcr-visible'); }
var bulkSub=document.getElementById('cwcr-bulk-sub-toggle');
var bulkGrid2=document.getElementById('cwcr-bulk-grid');
if(bulkSub) bulkSub.style.display='none';
if(bulkGrid2){ bulkGrid2.innerHTML = ''; bulkGrid2.style.display='none'; }
allBulkCards=[];
var chaseSubToggleS=document.getElementById('cwcr-chase-sub-toggle');
_renderSetMatches(q);
if(!cards.length){
var franchiseLabel=activeFranchise==='pokemon' ? 'Pokemon' : 'One Piece';
if(grid){ grid.innerHTML = '<div class="cwcr-chase-empty">0 resultaten voor "' + esc(q) + '" in ' + franchiseLabel + '. <span style="font-size:12px;opacity:0.5">Tip: controleer of je in de juiste franchise zoekt.</span></div>'; grid.style.display=''; }
if(countEl){ countEl.style.display='none'; }
if(chaseSubToggleS) chaseSubToggleS.style.display='none';
return;
}
if(chaseSubToggleS) chaseSubToggleS.style.display='';
if(countEl){ countEl.textContent = cards.length + ' kaarten gevonden voor "' + esc(q) + '"'; countEl.style.display=''; }
cwcrRenderChunked(grid, cards, function(c, idx){
var info=pkRarity[c.rarity] || { label: c.rarity || '?',cls: 'cwcr-badge-other' };
var price=c._price || null;
var cur=c._currency || 'EUR';
var sym=cur==='USD' ? '$' : '\u20ac';
var link=pkCardmarkUrl(c,c.name);
var setName=c.set ? c.set.name : '';
var h='';
h += '<div class="cwcr-chase-img-card" data-card-idx="' + idx + '" data-franchise="pokemon"' + (link ? ' data-href="' + esc(link) + '"' : '') + '>';
h += '<div class="cwcr-chase-img-topbar"><span class="cwcr-chase-img-badge ' + info.cls + '" title="' + esc(info.label) + '">' + cwcrBadgeInner(info) + '</span>' + (c.number ? '<span class="cwcr-chase-img-topnum">#' + esc(c.number) + '</span>' : '') + '</div>';
h += '<div class="cwcr-chase-img-wrap cwcr-img-loading">';
h += cwcrCardImgHtml(c, 'pokemon', c.name);
if(cur==='USD') h += '<span class="cwcr-usd-badge" title="EU prijs niet beschikbaar \u2014 TCGplayer USD prijs">USD</span>';
h += '</div><div class="cwcr-chase-img-info">';
h += '<div class="cwcr-chase-img-name">' + esc(c.name) + '</div>';
if(setName) h += '<div class="cwcr-chase-img-set">' + esc(setName) + '</div>';
var avg7=c.cardmarket && c.cardmarket.prices ? (c.cardmarket.prices.avg7 || 0) : 0;
if(price && price>0){
h += '<div class="cwcr-chase-img-pricerow"><div class="cwcr-chase-img-price">' + sym + parseFloat(price).toFixed(2) + '</div></div>';
if(cur!=='USD' && avg7 && avg7>0 && Math.abs(price - avg7)>0.01){
var delta=price - avg7;
var cls=delta>0.01 ? 'cwcr-avg7-up' : 'cwcr-avg7-down';
var arrow=delta>0.01 ? '\u2191' : '\u2193';
var pct=Math.round(delta / avg7 * 100);
h += '<div class="cwcr-chase-img-avg7 ' + cls + '">' + arrow + ' ' + sym + Math.abs(delta).toFixed(2) + ' (' + (pct>0?'+':'') + pct + '%)</div>';
}
}
h += '<button class="cwcr-card-detail-btn" data-card-idx="' + idx + '" data-franchise="pokemon">' + ((window.CWPD_I18N && window.CWPD_I18N.viewAnalysis) || 'Bekijk analyse') + '</button>';
h += '</div></div>';
return h;
});
cwcrCardRegistry['pokemon'] = cards;
}
function opCardmarkUrl(c,cardId,name){
var cmId=c && (c.cardmarket_id || (c.cardmarket && c.cardmarket.id));
if(cmId) return 'https://www.cardmarket.com/en/OnePiece/Products?idProduct=' + cmId;
if(c && c.cardmarket_url) return c.cardmarket_url;
var q=cardId || name || '';
if(!q) return '';
return 'https://www.cardmarket.com/en/OnePiece/Products/Search?searchString=' + encodeURIComponent(q);
}
function pkCardmarkUrl(c,name){
var cmId=c && (c.cardmarket_id || (c.cardmarket && c.cardmarket.id));
if(cmId) return 'https://www.cardmarket.com/en/Pokemon/Products?idProduct=' + cmId;
if(c && c.cardmarket && c.cardmarket.url) return c.cardmarket.url;
if(c && c.cardmarket_url) return c.cardmarket_url;
return 'https://www.cardmarket.com/en/Pokemon/Products/Search?searchString=' + encodeURIComponent(name || (c && c.name) || '');
}
var opRarityExt={
'SEC':1,'SAR':2,'SP':3,'SUPER RARE':4,'Rare':5,'SR':4,'R':6,'Uncommon':7,'UC':7,'Common':8,'C':8,'LEADER':9,'Treasure Rare':2
};
function opSortFn(a,b){
var va=parseFloat(a._price || 0) || 0;
var vb=parseFloat(b._price || 0) || 0;
if(vb!==va) return vb - va;
var ra=opRarity[a.rarity] ? opRarity[a.rarity].pri : (opRarityExt[a.rarity] || 99);
var rb=opRarity[b.rarity] ? opRarity[b.rarity].pri : (opRarityExt[b.rarity] || 99);
return ra - rb;
}
function fetchOnePiece(setId){
var ck='cwcr-cards-op-tcggo3-' + setId;
var cached=sessionStorage.getItem(ck);
if(gridSection){ gridSection.style.display=''; gridSection.classList.add('cwcr-visible'); }
if(cached){
try {
var obj=JSON.parse(cached);
var allOp=obj.allCards || obj.cards || obj;
allOp.forEach(function(c){ c._price = c._price || parseFloat(c.price || c.market_price || 0) || 0; c._setId = c._setId || setId; });
var cards=allOp.slice();
cards.sort(opSortFn);
allCards = cards;
var _opChaseIdsC={}; cards.slice(0,10).forEach(function(c){ _opChaseIdsC[(c.card_id||c.id||c.number||'')]=1; });
allBulkCards = (obj.bulk || []).filter(function(c){ return !_opChaseIdsC[(c.card_id||c.id||c.number||'')]; });
allBulkCards.sort(function(a,b){ return (b._price||0)-(a._price||0); });
currentCounts = obj.counts || null;
if(obj.updatedAt) cwcrZetUpdate(obj.updatedAt);
cwcrHaalUpdate(CWCR_BASE_URL+'/api/tcg/op-cards/'+encodeURIComponent(setId)+'?v=2', ck, obj, setId);
updateSidebarCounts();
updateSidebarRarities();
renderOnePiece(cards,currentCounts);
renderBulkSection(allBulkCards,'onepiece');
return;
} catch(e){}
}
var _cwUpd=null;
fetch(CWCR_BASE_URL+'/api/tcg/op-cards/' + encodeURIComponent(setId) + '?v=2')
.then(function(r){try{_cwUpd=r.headers.get('X-Cw-Updated');}catch(e){} return r.json();})
.then(function(cards){
if(!Array.isArray(cards)){ hideChaseLoading(); return; }
var counts={};
cards.forEach(function(c){ if(c.rarity) counts[c.rarity] = (counts[c.rarity] || 0) + 1; });
cards.forEach(function(c){
c._price = parseFloat(c.price || c.market_price || c.value || 0) || 0;
c._setId = setId;
});
var top10op=cards.slice();
top10op.sort(opSortFn);
var _opChaseIds={}; top10op.slice(0,10).forEach(function(c){ _opChaseIds[(c.card_id||c.id||c.number||'')]=1; });
var bulkOp=cards.filter(function(c){ return !_opChaseIds[(c.card_id||c.id||c.number||'')]; });
bulkOp.sort(function(a,b){ return (a.card_id||a.id||'').localeCompare(b.card_id||b.id||'',undefined,{numeric:true}); });
try { sessionStorage.setItem(ck,JSON.stringify({ allCards: cards,bulk: bulkOp,counts: counts,updatedAt: _cwUpd })); } catch(e){}
if(_cwUpd) cwcrZetUpdate(_cwUpd); else cwcrHaalUpdate(CWCR_BASE_URL+'/api/tcg/op-cards/'+encodeURIComponent(setId)+'?v=2', null, null, setId);
allCards = top10op;
allBulkCards = bulkOp.slice();
allBulkCards.sort(function(a,b){ return (b._price||0)-(a._price||0); });
currentCounts = counts;
updateSidebarCounts();
updateSidebarRarities();
renderOnePiece(top10op,counts);
renderBulkSection(allBulkCards,'onepiece');
})
.catch(function(){
hideChaseLoading();
if(grid){ grid.innerHTML = '<div class="cwcr-chase-empty">Kon kaarten niet laden. Probeer opnieuw.</div>'; grid.style.display=''; }
});
}
var detailOverlay=document.getElementById('cwcr-detail-overlay');
var detailClose=document.getElementById('cwcr-detail-close');
(function(){
var imgCol=document.getElementById('cwcr-detail-img-col');
var img=document.getElementById('cwcr-detail-img');
if(!imgCol || !img) return;
var MAX_TILT=12;
var resetTimer=null;
imgCol.addEventListener('mousemove',function(e){
var rect=imgCol.getBoundingClientRect();
var x=(e.clientX - rect.left) / rect.width  - 0.5;
var y=(e.clientY - rect.top)  / rect.height - 0.5;
var rotY= x * MAX_TILT * 2;
var rotX=-y * MAX_TILT;
img.style.transform = 'perspective(800px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) scale(1.04)';
clearTimeout(resetTimer);
});
imgCol.addEventListener('mouseleave',function(){
img.style.transition = 'transform 0.6s ease,box-shadow 0.15s ease';
img.style.transform = '';
resetTimer = setTimeout(function(){
img.style.transition = '';
},650);
});
imgCol.addEventListener('mouseenter',function(){
img.style.transition = 'transform 0.1s ease,box-shadow 0.15s ease';
});
})();
(function(){
var imgCol=document.getElementById('cwcr-detail-img-col');
var imgWrap=document.getElementById('cwcr-card-img-wrap');
if(!imgCol || !imgWrap) return;
imgCol.addEventListener('mousemove',function(e){
var rect=imgWrap.getBoundingClientRect();
if(rect.width===0) return;
var px=Math.max(0,Math.min(1,(e.clientX - rect.left) / rect.width));
var py=Math.max(0,Math.min(1,(e.clientY - rect.top)  / rect.height));
var angle=(Math.atan2(py - 0.5,px - 0.5) * (180 / Math.PI)).toFixed(1) + 'deg';
imgWrap.style.setProperty('--holo-x',(px * 100).toFixed(1) + '%');
imgWrap.style.setProperty('--holo-y',(py * 100).toFixed(1) + '%');
imgWrap.style.setProperty('--holo-angle',angle);
});
imgCol.addEventListener('mouseleave',function(){
imgWrap.style.setProperty('--holo-x','50%');
imgWrap.style.setProperty('--holo-y','50%');
imgWrap.style.setProperty('--holo-angle','135deg');
});
})();
(function(){
var zoomBtn=document.getElementById('cwcr-zoom-btn');
var imgEl=document.getElementById('cwcr-detail-img');
var imgWrap=document.getElementById('cwcr-card-img-wrap');
var imgColEl=document.getElementById('cwcr-detail-img-col');
if(!zoomBtn || !imgColEl) return;
var isZoomed=false;
function toggleZoom(){
isZoomed = !isZoomed;
imgColEl.classList.toggle('cwcr-img-zoomed',isZoomed);
zoomBtn.classList.toggle('cwcr-ctrl-active',isZoomed);
}
var clickTarget=imgWrap || imgEl;
if(clickTarget) clickTarget.addEventListener('click',function(e){ e.stopPropagation(); toggleZoom(); });
zoomBtn.addEventListener('click',function(e){ e.stopPropagation(); toggleZoom(); });
imgColEl.addEventListener('click',function(e){
if(isZoomed && !(imgWrap ? e.target.closest('#cwcr-card-img-wrap') : e.target.closest('#cwcr-detail-img'))) toggleZoom();
});
window._cwcrResetZoom = function(){
if(!isZoomed) return;
isZoomed=false;
imgColEl.classList.remove('cwcr-img-zoomed');
zoomBtn.classList.remove('cwcr-ctrl-active');
};
})();
(function(){
var flipBtn=document.getElementById('cwcr-flip-btn');
var flipper=document.getElementById('cwcr-card-flipper');
if(!flipBtn || !flipper) return;
var isFlipped=false;
flipBtn.addEventListener('click',function(){
isFlipped = !isFlipped;
flipper.style.transform = isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)';
flipper.classList.toggle('cwcr-is-flipped',isFlipped);
flipBtn.classList.toggle('cwcr-ctrl-active',isFlipped);
});
window._cwcrResetFlip = function(){
if(!isFlipped) return;
isFlipped=false;
flipper.style.transform = 'rotateY(0deg)';
flipper.classList.remove('cwcr-is-flipped');
flipBtn.classList.remove('cwcr-ctrl-active');
};
// Inject share button if not already present (liquid may be cached)
if(!document.getElementById('cwcr-share-btn') && flipBtn && flipBtn.parentNode){
var _sTshr=window.CWPD_I18N||{};
var _sb=document.createElement('button');
_sb.type='button';_sb.className='cwcr-card-ctrl-btn';_sb.id='cwcr-share-btn';_sb.title=(_sTshr.copyDeeplink||'Kopieer deeplink');
_sb.innerHTML='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg> '+(_sTshr.share||'Deel');
_sb.onclick=function(e){if(window.cwcrShareCard)window.cwcrShareCard(e);};
flipBtn.parentNode.insertBefore(_sb,flipBtn.nextSibling);
}
})();
var cwcrPaywallCardData=null;
var cwcrPaywallFranchise=null;
var cwcrPaywallCardObj=null;
function cwcrUpdateAura(tier){
var sparksEl=document.getElementById('cwcr-aura-sparks');
if(sparksEl) sparksEl.innerHTML = '';
if(tier<3 || !sparksEl) return;
var rnd=function(a,b){ return a + Math.random() * (b - a); };
var sparkCfg={
3: { count:4,colors:['rgba(70,145,255,0.9)','rgba(140,195,255,0.8)','rgba(210,230,255,0.85)'],minDist:62,maxDist:112,minLen:12,maxLen:22,minSpd:0.65,maxSpd:1.0 },4: { count:7,colors:['rgba(255,208,50,0.95)','rgba(255,235,105,0.88)','#fff','rgba(255,162,0,0.9)'],minDist:74,maxDist:132,minLen:14,maxLen:28,minSpd:0.55,maxSpd:0.95 },5: { count:11,colors:['rgba(180,100,255,0.9)','rgba(80,185,255,0.85)','#fff','rgba(255,80,175,0.88)','rgba(105,255,200,0.85)','rgba(255,235,65,0.9)'],minDist:80,maxDist:145,minLen:14,maxLen:30,minSpd:0.5,maxSpd:0.88 }
};
var sc=sparkCfg[tier] || sparkCfg[3];
for(var si=0; si<sc.count; si++){
var angle=(2 * Math.PI / sc.count) * si + (Math.random() - 0.5) * 0.5;
var dist=rnd(sc.minDist,sc.maxDist);
var cx=Math.cos(angle) * dist;
var cy=Math.sin(angle) * dist;
var sparkRot=angle * 180 / Math.PI + 90;
var color=sc.colors[Math.floor(Math.random() * sc.colors.length)];
var wrap=document.createElement('div');
wrap.className = 'cwcr-spark';
wrap.style.cssText = 'left:50%;top:50%;transform:translate(calc(-50% + '+cx.toFixed(1)+'px),calc(-50% + '+cy.toFixed(1)+'px)) rotate('+sparkRot.toFixed(1)+'deg)';
var bar=document.createElement('div');
bar.className = 'cwcr-spark-bar';
bar.style.cssText = '--sw:'+rnd(1.5,2.4).toFixed(1)+'px;--sh:'+rnd(sc.minLen,sc.maxLen).toFixed(1)+'px;--ss:'+rnd(sc.minSpd,sc.maxSpd).toFixed(2)+'s;--sdel:'+(-rnd(0,sc.maxSpd)).toFixed(2)+'s;--sc:'+color;
wrap.appendChild(bar);
sparksEl.appendChild(wrap);
}
}
function showPaywallInModal(card,franchise,cardIdx){
var modal=document.getElementById('cwcr-detail-modal');
var infoCol=document.getElementById('cwcr-detail-info-col');
var gate=document.getElementById('cwcr-paywall-gate');
var loginGate=document.getElementById('cwcr-login-gate');
cwcrPaywallCardData = cardIdx;
cwcrPaywallFranchise = franchise;
cwcrPaywallCardObj = card;
var isOp=franchise==='onepiece';
var name=isOp ? (card.name || card.card_name || '') : (card.name || '');
cwcrTrack('paywall_hit',{ name: name,franchise: franchise,set: activeSetId || '' });
var number=isOp ? (card.card_id || card.id || '') : (card.number || '');
var rarity=card.rarity || '';
var info=isOp ? (opRarity[rarity] || { label: rarity,cls: 'cwcr-badge-other' }) : (pkRarity[rarity] || { label: rarity,cls: 'cwcr-badge-other' });
var imgEl=document.getElementById('cwcr-detail-img');
var nameEl=document.getElementById('cwcr-detail-name');
var numEl=document.getElementById('cwcr-detail-number');
var badgeEl=document.getElementById('cwcr-detail-badge');
var metaEl=document.getElementById('cwcr-detail-meta');
var pricesEl=document.getElementById('cwcr-detail-prices');
var chartEl=document.getElementById('cwcr-detail-chart');
var actEl=document.getElementById('cwcr-detail-actions');
cwcrSetModalImg(imgEl, card, franchise, name);
if(nameEl) nameEl.textContent = name;
if(numEl) numEl.textContent = number ? '#' + number : '';
if(badgeEl){ badgeEl.textContent = info.label; badgeEl.className = 'cwcr-chase-img-badge ' + info.cls; badgeEl.style.cssText = 'position:static;font-size:12px;padding:3px 10px;border-radius:6px'; }
var imgColElPw=document.getElementById('cwcr-detail-img-col');
var rarPriPw=info.pri||99;
var glowTierPw;
if(isOp){var _opPw=card._price||0;glowTierPw=_opPw>=1000?5:_opPw>=100?4:_opPw>=20?3:_opPw>=4?2:_opPw>0?1:0;}
else{glowTierPw=rarPriPw<=1?5:rarPriPw<=2?4:rarPriPw<=3?3:rarPriPw<=5?2:rarPriPw<=6?1:0;}
if(imgColElPw){imgColElPw.className=imgColElPw.className.replace(/\bcwcr-glow-\d\b/g,'').trim();if(glowTierPw>0)imgColElPw.classList.add('cwcr-glow-'+glowTierPw);imgColElPw.dataset.franchise=isOp?'onepiece':'pokemon';}
if(badgeEl){badgeEl.className=badgeEl.className.replace(/\bcwcr-badge-glow-\d\b/g,'').trim();if(glowTierPw>0)badgeEl.classList.add('cwcr-badge-glow-'+glowTierPw);}
cwcrUpdateAura(glowTierPw);
if(metaEl) metaEl.innerHTML = '';
var price=card._price || 0;
var cardCur=card._currency || 'EUR';
var cardSym=cardCur==='USD' ? '$' : '\u20ac';
// Rich preview content (shown blurred behind teaser)
var heroEl=document.getElementById('cwcr-price-hero');
var heroUsdNote=cardCur==='USD' ? '<div class="cwcr-price-hero-usd">USD \u2014 EU prijs niet beschikbaar</div>' : '';
if(heroEl) heroEl.innerHTML='<div class="cwcr-price-hero-inner"><div class="cwcr-price-hero-label">NM Prijs</div><div class="cwcr-price-hero-val">'+(price>0?cardSym+'\u00a0'+price.toFixed(2):cardSym+' \u2014\u2014\u2014')+'</div>'+heroUsdNote+'</div>';
var ph='';
ph+='<div class="cwcr-detail-price-cell cwcr-detail-price-main"><div class="cwcr-detail-price-label">Huidig</div><div class="cwcr-detail-price-val">'+(price>0?cardSym+price.toFixed(2):'&#9679;&#9679;&#9679;')+'</div></div>';
ph+='<div class="cwcr-detail-price-cell"><div class="cwcr-detail-price-label">Gem. 1D</div><div class="cwcr-detail-price-val cwcr-detail-price-muted">&#9679;&#9679;&#9679;</div></div>';
ph+='<div class="cwcr-detail-price-cell"><div class="cwcr-detail-price-label">Gem. 7D</div><div class="cwcr-detail-price-val cwcr-detail-price-muted">&#9679;&#9679;&#9679;</div></div>';
ph+='<div class="cwcr-detail-price-cell"><div class="cwcr-detail-price-label">Gem. 30D</div><div class="cwcr-detail-price-val cwcr-detail-price-muted">&#9679;&#9679;&#9679;</div></div>';
ph+='<div class="cwcr-detail-price-cell"><div class="cwcr-detail-price-label">Trend</div><div class="cwcr-detail-price-val cwcr-detail-price-muted">&#9679;&#9679;&#9679;</div></div>';
if(pricesEl) pricesEl.innerHTML=ph;
var evoEl=document.getElementById('cwcr-evo-row');
/* Evo tease: toon echte data geblurd achter de paywall overlay */
var _pwCm=!isOp&&card.cardmarket&&card.cardmarket.prices?card.cardmarket.prices:null;
function _pwEvoBadge(label,ref,cur){if(!ref||!cur||cur<=0||ref<=0)return '<div class="cwcr-evo-badge cwcr-evo-neutral">&#9679;&#9679;&#9679;</div>';var pct=(cur-ref)/ref*100;var cls=pct>0?'cwcr-evo-up':pct<0?'cwcr-evo-down':'cwcr-evo-flat';return '<div class="cwcr-evo-badge '+cls+'"><span class="cwcr-evo-badge-label">'+label+'</span> '+(pct>0?'+':'')+pct.toFixed(1)+'%</div>';}
if(evoEl) evoEl.innerHTML=_pwEvoBadge('1D',_pwCm?(_pwCm.avg1||0):0,price)+_pwEvoBadge('7D',_pwCm?(_pwCm.avg7||0):0,price)+_pwEvoBadge('30D',_pwCm?(_pwCm.avg30||0):0,price);
/* Geanimeerde chart achter de paywall */
if(chartEl){chartEl.style.display='';var _pwLight=document.documentElement.classList.contains('cwcr-theme-light');var _pwStroke=_pwLight?'rgba(138,101,8,0.8)':'rgba(232,200,64,0.75)';var _pwFill0=_pwLight?'rgba(138,101,8,0.18)':'rgba(232,200,64,0.2)';var _pwFill1=_pwLight?'rgba(138,101,8,0)':'rgba(232,200,64,0)';var _pwCanvas=document.createElement('canvas');_pwCanvas.className='cwcr-price-chart';_pwCanvas.width=400;_pwCanvas.height=150;_pwCanvas.style.cssText='width:100%;opacity:0.35;display:block';chartEl.innerHTML='';chartEl.appendChild(_pwCanvas);var _pwCtx=_pwCanvas.getContext('2d');var _pwTick=0;function _pwDrawChart(){var W=_pwCanvas.width,H=_pwCanvas.height;_pwCtx.clearRect(0,0,W,H);var pts=[];for(var i=0;i<=30;i++){pts.push({x:(i/30)*W,y:H*0.72-(i/30)*H*0.28+Math.sin(i*0.6+_pwTick*0.03)*7+Math.sin(i*1.5+_pwTick*0.05)*3});}_pwCtx.beginPath();_pwCtx.moveTo(0,H);pts.forEach(function(p){_pwCtx.lineTo(p.x,p.y);});_pwCtx.lineTo(W,H);_pwCtx.closePath();var grad=_pwCtx.createLinearGradient(0,0,0,H);grad.addColorStop(0,_pwFill0);grad.addColorStop(1,_pwFill1);_pwCtx.fillStyle=grad;_pwCtx.fill();_pwCtx.beginPath();pts.forEach(function(p,i){i===0?_pwCtx.moveTo(p.x,p.y):_pwCtx.lineTo(p.x,p.y);});_pwCtx.strokeStyle=_pwStroke;_pwCtx.lineWidth=2;_pwCtx.stroke();_pwTick++;window._cwcrPaywallChartAnim=requestAnimationFrame(_pwDrawChart);}window._cwcrPaywallChartAnim=requestAnimationFrame(_pwDrawChart);}
if(actEl) actEl.innerHTML='<a class="cwcr-detail-btn cwcr-detail-btn-primary" tabindex="-1">&#128722; Bekijk op Cardmarket</a><button class="cwcr-detail-btn cwcr-detail-btn-cw" tabindex="-1" onclick="window.open(\'/collections/all\',\'_blank\')">Shop bij Cardworld</button>';
if(modal) modal.classList.add('cwcr-paywall-mode');
/* Vervang tab-labels door ●●● zodat niets leesbaar is */
document.querySelectorAll('.cwcr-tab-btn').forEach(function(btn){
if(!btn.dataset.pwOrig) btn.dataset.pwOrig=btn.textContent;
btn.textContent='\u25cf\u25cf\u25cf';
});
/* Personaliseer titel met kaartnaam */
var _pwTitleEl=document.getElementById('cwcr-paywall-teaser-title');
if(_pwTitleEl&&name){var _pwLoc=window.CWPD_LOC||'nl';var _shortName=name.length>26?name.substring(0,24)+'\u2026':name;if(_pwLoc==='en')_pwTitleEl.textContent='Unlock the analysis for '+_shortName;else if(_pwLoc==='fr')_pwTitleEl.textContent='D\u00e9bloquez l\'analyse pour '+_shortName;else _pwTitleEl.textContent='Unlock de analyse voor '+_shortName;}
/* NM-prijs hero — sociale teaser zodat link-ontvangers de prijs zien voor de paywall */
var _pwNmHero=document.getElementById('cwcr-paywall-nm-hero');
var _pwNmVal=document.getElementById('cwcr-paywall-nm-val');
if(_pwNmHero && _pwNmVal){
  var _pwNmPrice=price>0?price:(_pwCm&&_pwCm.lowestNearMint?_pwCm.lowestNearMint:0);
  if(_pwNmPrice>0){
    _pwNmVal.textContent=cardSym+' '+_pwNmPrice.toFixed(2);
    _pwNmHero.style.display='';
  } else {
    _pwNmHero.style.display='none';
  }
}
/* Koopsignaal badge */
var _pwSignalEl=document.getElementById('cwcr-paywall-signal-badge');
if(_pwSignalEl){var _pwTrend=_pwCm?(_pwCm.trendPrice||0):0;var _pwBuy=price>0&&_pwTrend>0&&price<_pwTrend*0.9;if(_pwBuy){var _pwPct=Math.round((_pwTrend-price)/_pwTrend*100);var _pwLoc2=window.CWPD_LOC||'nl';_pwSignalEl.textContent=_pwLoc2==='en'?'\ud83d\udd25 Buy signal \u2014 '+_pwPct+'% below trend':_pwLoc2==='fr'?'\ud83d\udd25 Signal d\'achat \u2014 '+_pwPct+'% sous tendance':'\ud83d\udd25 Koopsignaal \u2014 '+_pwPct+'% onder trend';_pwSignalEl.style.display='';}else{_pwSignalEl.style.display='none';}}
/* Lock animatie op CTA hover */
var _pwPrimaryBtn=document.querySelector('#cwcr-paywall-teaser .cwcr-teaser-btn-primary');
var _pwLockWrap=document.querySelector('#cwcr-paywall-teaser .cwcr-gate-lock-wrap');
if(_pwPrimaryBtn&&_pwLockWrap&&!_pwPrimaryBtn._cwcrLockBound){_pwPrimaryBtn._cwcrLockBound=true;_pwPrimaryBtn.addEventListener('mouseenter',function(){_pwLockWrap.classList.add('cwcr-lock-unlocking');});_pwPrimaryBtn.addEventListener('mouseleave',function(){_pwLockWrap.classList.remove('cwcr-lock-unlocking');}); }
if(loginGate) loginGate.classList.remove('is-active');
var teaser=document.getElementById('cwcr-paywall-teaser');
if(teaser) teaser.style.display='';
var _pwBack=document.getElementById('cwcr-card-back-content');
if(_pwBack){
var _pwTb=window.CWPD_I18N||{};
var _pwBh='<div class="cwcr-card-back-title">'+esc(name)+'</div>';
if(rarity) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(_pwTb.rarityLabel||'Rarity')+'</span><span class="cwcr-card-back-val">'+esc(info.label||rarity)+'</span></div>';
if(number) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(_pwTb.numberLabel||'Nummer')+'</span><span class="cwcr-card-back-val">'+esc(number)+'</span></div>';
if(!isOp&&card.set&&card.set.name) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(_pwTb.setLabelBack||'Set')+'</span><span class="cwcr-card-back-val">'+esc(card.set.name)+'</span></div>';
if(!isOp&&card.hp) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">HP</span><span class="cwcr-card-back-val">'+esc(String(card.hp))+'</span></div>';
var _pwTypes=(!isOp&&card.types)?(Array.isArray(card.types)?card.types:[card.types]):[];
if(_pwTypes.length) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(_pwTb.typeLabel||'Type')+'</span><span class="cwcr-card-back-val">'+_pwTypes.map(esc).join(',')+'</span></div>';
if(isOp&&card.color) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(_pwTb.colorLabel||'Kleur')+'</span><span class="cwcr-card-back-val">'+esc(card.color)+'</span></div>';
if(isOp&&card.card_type&&card.card_type!=='singles') _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(_pwTb.typeLabel||'Type')+'</span><span class="cwcr-card-back-val">'+esc(card.card_type)+'</span></div>';
if(isOp&&card.power) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">Power</span><span class="cwcr-card-back-val">'+esc(card.power)+'</span></div>';
if(isOp&&card.life) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">Life</span><span class="cwcr-card-back-val">'+esc(card.life)+'</span></div>';
if(isOp&&card.counter) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">Counter</span><span class="cwcr-card-back-val">'+esc(card.counter)+'</span></div>';
if(price>0) _pwBh+='<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(_pwTb.priceLabel||'Prijs')+'</span><span class="cwcr-card-back-val" style="color:var(--cwcr-gold)">'+cardSym+price.toFixed(2)+'</span></div>';
_pwBack.innerHTML=_pwBh;
}
if(window._cwcrResetFlip) window._cwcrResetFlip();
detailOverlay.style.display='flex';
document.body.style.overflow = 'hidden';
}
var _cwcrActiveTab='overzicht';
function cwcrInitTabs(){
var nav=document.getElementById('cwcr-tab-nav');
if(!nav) return;
nav.querySelectorAll('.cwcr-tab-btn').forEach(function(btn){
btn.onclick = function(){ cwcrSwitchTab(btn.dataset.tab); };
});
}
function cwcrSwitchTab(tabName){
_cwcrActiveTab = tabName;
document.querySelectorAll('.cwcr-tab-btn').forEach(function(b){
b.classList.toggle('is-active',b.dataset.tab===tabName);
});
document.querySelectorAll('.cwcr-tab-panel').forEach(function(p){
var id=p.id.replace('cwcr-panel-','');
if(id===tabName){
  /* Safari fix: bij modal re-open blijft het panel op opacity:0/height:0
     hangen ondanks is-active. CSS animation:forwards re-trigger werkt niet
     betrouwbaar in Safari. Daarom forceren we de eindstate inline. */
  p.classList.add('is-active');
  p.style.animation='none';
  p.style.opacity='1';
  p.style.transform='none';
}
else {
  p.classList.remove('is-active');
  p.style.animation='';
  p.style.opacity='';
  p.style.transform='';
}
});
}
/* RAF tracking: bij re-open van modal moeten oude RAF loops gecanceld worden,
   anders schrijven ze in Safari (waar RAF pauzeert bij display:none en weer opstart)
   stale 0-waardes over de nieuwe content. */
var _cwcrCountUpRAFs=[];
function cwcrCancelAllCountUps(){
_cwcrCountUpRAFs.forEach(function(id){ try{ cancelAnimationFrame(id); }catch(e){} });
_cwcrCountUpRAFs=[];
}
function cwcrCountUp(el,target,duration,sym){
if(!el || !target || target<=0) return;
sym=sym||'\u20ac';
duration = duration || 600;
/* Cancel pending RAF op dit specifieke element (idempotent re-fill) */
if(el._cwcrRafId){ try{ cancelAnimationFrame(el._cwcrRafId); }catch(e){} el._cwcrRafId=null; }
var start=0,startTime=null;
function step(ts){
if(!startTime) startTime = ts;
var progress=Math.min((ts - startTime) / duration,1);
var ease=1 - Math.pow(1 - progress,3);
var current=start + (target - start) * ease;
el.textContent = sym + current.toFixed(2);
if(progress<1){
el._cwcrRafId = requestAnimationFrame(step);
_cwcrCountUpRAFs.push(el._cwcrRafId);
} else {
el._cwcrRafId = null;
}
}
el._cwcrRafId = requestAnimationFrame(step);
_cwcrCountUpRAFs.push(el._cwcrRafId);
}
function cwcrFillOverzicht(d,skipAnim){
var T=window.CWPD_I18N||{};
var heroEl=document.getElementById('cwcr-price-hero');
var pricesEl=document.getElementById('cwcr-detail-prices');
var evoRowEl=document.getElementById('cwcr-evo-row');
if(!heroEl || !pricesEl || !evoRowEl) return;
var sym=d.sym||'\u20ac';
var isUsd=d.currency==='USD';
var hasNmWorld=d.nmPrice>0;
var hasNmEU=d.nmEU>0;
var countryMap=d.nmByCountry || {};
var countryCodes=Object.keys(countryMap).filter(function(k){ return countryMap[k]>0; }).sort();
/* Flag emoji per ISO-2 code (regional indicator symbols) */
function cwcrFlag(code){
if(!code || code.length!==2) return '';
var A=0x1F1E6, ASCII_A=65;
return String.fromCodePoint(A + (code.charCodeAt(0) - ASCII_A)) + String.fromCodePoint(A + (code.charCodeAt(1) - ASCII_A));
}
var countryNames={ DE: 'Duitsland',FR: 'Frankrijk',ES: 'Spanje',IT: 'Italië',NL: 'Nederland',BE: 'België',AT: 'Oostenrijk',PL: 'Polen',PT: 'Portugal',GB: 'UK',IE: 'Ierland',DK: 'Denemarken',SE: 'Zweden',FI: 'Finland',NO: 'Noorwegen',CZ: 'Tsjechië',GR: 'Griekenland',HU: 'Hongarije',RO: 'Roemenië' };
var rawScope=window._cwcrNmScope || 'world';
var scope=rawScope;
if(scope==='world' && !hasNmWorld) scope=hasNmEU ? 'eu' : (countryCodes[0] ? 'c:'+countryCodes[0] : 'none');
else if(scope==='eu' && !hasNmEU) scope=hasNmWorld ? 'world' : (countryCodes[0] ? 'c:'+countryCodes[0] : 'none');
else if(scope.indexOf('c:')===0){
var cc=scope.slice(2);
if(!(countryMap[cc]>0)) scope=hasNmWorld ? 'world' : (hasNmEU ? 'eu' : 'none');
}
var heroPrice=d.price,heroLabel=(T.currentPrice||'Huidige prijs');
if(scope==='world'){ heroPrice=d.nmPrice; heroLabel=isUsd?(T.tcgMarketPrice||'TCGplayer Marktprijs'):(T.nmWorldwide||'Near Mint (Wereldwijd)'); }
else if(scope==='eu'){ heroPrice=d.nmEU; heroLabel=(T.nmEU||'Near Mint (EU)'); }
else if(scope.indexOf('c:')===0){
var code=scope.slice(2);
heroPrice=countryMap[code];
heroLabel='Near Mint ' + cwcrFlag(code) + ' ' + (countryNames[code] || code);
}
var toggleHtml='';
var toggleBtns=[];
if(hasNmWorld) toggleBtns.push({ scope: 'world',label: '&#127758; '+(T.world||'Wereld'),title: (T.allSellers||'Alle Cardmarket sellers wereldwijd') });
if(hasNmEU)    toggleBtns.push({ scope: 'eu',label: '&#127466;&#127482; '+(T.euBtn||'EU'),title: (T.onlyEuSellers||'Alleen EU sellers') });
countryCodes.forEach(function(cc){
toggleBtns.push({ scope: 'c:'+cc,label: cwcrFlag(cc) + ' ' + cc,title: (countryNames[cc] || cc) + ' '+(T.sellers||'sellers') });
});
if(toggleBtns.length>1){
toggleHtml = '<div class="cwcr-nm-scope-toggle" role="tablist" aria-label="'+(T.nmRegion||'Near Mint regio')+'">';
toggleBtns.forEach(function(b){
toggleHtml += '<button type="button" class="cwcr-nm-scope-btn' + (scope===b.scope ? ' is-active' : '') + '" title="' + esc(b.title) + '" onclick="cwcrSetNmScope(\'' + b.scope + '\')">' + b.label + '</button>';
});
toggleHtml += '</div>';
}
heroEl.innerHTML = toggleHtml +
(isUsd ? '<div class="cwcr-price-hero-usd" title="'+(T.usdMarketNotAvailable||'USD via TCGplayer - EU marktdata niet beschikbaar')+'">'+(T.usdViaTcg||'USD via TCGplayer')+'</div>' : '') +
'<div class="cwcr-price-hero-label">' + heroLabel + '</div>' +
'<div class="cwcr-price-hero-value" id="cwcr-hero-val">'+sym+'0.00</div>' +
(scope!=='none' && d.low>0 ? '<div class="cwcr-price-hero-sub">'+(T.lowest||'Laagste')+': '+sym+'' + d.low.toFixed(2) + '</div>' : '');
var heroValEl=document.getElementById('cwcr-hero-val');
if(heroValEl && heroPrice>0){
  if(skipAnim){ heroValEl.textContent = sym + heroPrice.toFixed(2); }
  else { cwcrCountUp(heroValEl,heroPrice,700,sym); }
}
window._cwcrLastDetailData=d;
var cells=[];
if(d.avg1>0)  cells.push({ label: (T.avg1d||'Gem. 1D'),val: d.avg1 });
if(d.avg7>0)  cells.push({ label: (T.avg7d||'Gem. 7D'),val: d.avg7 });
if(d.avg30>0) cells.push({ label: (T.avg30d||'Gem. 30D'),val: d.avg30 });
if(d.trend>0) cells.push({ label: (T.trend||'Trend'),val: d.trend });
if(d.low>0)   cells.push({ label: (T.lowest||'Laagste'),val: d.low });
if(d.avgSell>0 && d.avgSell!==d.trend) cells.push({ label: (T.avgSale||'Gem. Verkoop'),val: d.avgSell });
if(cells.length>0){
var ph='';
cells.forEach(function(c,i){
ph += '<div class="cwcr-detail-price-cell"><div class="cwcr-detail-price-label">' + c.label + '</div>' +
'<div class="cwcr-detail-price-val cwcr-detail-price-muted" id="cwcr-price-cell-' + i + '">'+sym+'0.00</div></div>';
});
pricesEl.innerHTML = ph;
cells.forEach(function(c,i){
var el=document.getElementById('cwcr-price-cell-' + i);
if(!el) return;
if(skipAnim){ el.textContent=sym + c.val.toFixed(2); }
else cwcrCountUp(el,c.val,500 + i * 80,sym);
});
}else{
pricesEl.innerHTML = '<div style="color:rgba(255,255,255,0.25);font-size:12px;grid-column:1/-1">'+(T.noPriceData||'Geen prijsdata beschikbaar')+'</div>';
}
var evoHtml='';
function evoBadge(label,val){
if(val == null) return '';
var cls=val>0 ? 'cwcr-evo-up' : val<0 ? 'cwcr-evo-down' : 'cwcr-evo-flat';
var sign=val>0 ? '+' : '';
return '<div class="cwcr-evo-badge ' + cls + '"><span class="cwcr-evo-badge-label">' + label + '</span> ' + sign + val.toFixed(1) + '%</div>';
}
if(d.evo){
// Verse set: huidige prijs zonder historische referentie geeft -100% op alle termijnen.
// Toon dan "nog niet genoeg data" i.p.v. misleidende rode -100% badges.
var _ev=[d.evo.rawEvo1,d.evo.rawEvo7,d.evo.rawEvo30].filter(function(v){return v!=null;});
var _allM100=_ev.length>0 && _ev.every(function(v){return v<=-99.9;});
if(_allM100){
evoHtml='<div class="cwcr-evo-nodata" style="grid-column:1/-1;padding:9px 13px;border-radius:11px;background:rgba(123,94,167,0.07);border:1px solid rgba(123,94,167,0.15);color:#6b5a8a;font-size:12.5px;line-height:1.4;display:flex;align-items:center;gap:7px;"><span style="font-size:14px;">&#8987;</span><span>'+((typeof T!=="undefined"&&T.evoNoData)||(window.CWPD_I18N&&window.CWPD_I18N.evoNoData)||'Nog niet genoeg prijsdata voor deze nieuwe set')+'</span></div>';
}else{
evoHtml += evoBadge('1D',d.evo.rawEvo1);
evoHtml += evoBadge('7D',d.evo.rawEvo7);
evoHtml += evoBadge('30D',d.evo.rawEvo30);
}
}
evoRowEl.innerHTML = evoHtml;
var nmEvoRowEl=document.getElementById('cwcr-nm-evo-row');
if(nmEvoRowEl){
var nmEvo=d.evo || {};
var d1=nmEvo.calculatedDay1Pct!=null ? nmEvo.calculatedDay1Pct : null;
var d7=nmEvo.calculatedDay7Pct!=null ? nmEvo.calculatedDay7Pct : null;
var d30=nmEvo.calculatedDay30Pct!=null ? nmEvo.calculatedDay30Pct : null;
var nmTitleEl=nmEvoRowEl.previousElementSibling;
var allNull=d1==null && d7==null && d30==null;
var allZero=!allNull && d1===0 && d7===0 && d30===0;
if(allNull || allZero){
nmEvoRowEl.innerHTML='';
if(nmTitleEl) nmTitleEl.style.display='none';
}else{
if(nmTitleEl) nmTitleEl.style.display='';
var nmEvoHtml='';
nmEvoHtml+=evoBadge('1D',d1);
nmEvoHtml+=evoBadge('7D',d7);
nmEvoHtml+=evoBadge('30D',d30);
nmEvoRowEl.innerHTML=nmEvoHtml;
}
}
}
window.cwcrSetNmScope=function(scope){
window._cwcrNmScope=scope;
var d=window._cwcrLastDetailData;
if(d) cwcrFillOverzicht(d,true);
};
var _cwcrChartData=null;
function cwcrFillAnalyse(d){
var T=window.CWPD_I18N||{};
var periodsEl=document.getElementById('cwcr-chart-periods');
var chartEl=document.getElementById('cwcr-detail-chart');
var tableEl=document.getElementById('cwcr-price-table');
if(!periodsEl || !chartEl || !tableEl) return;
var sym=d.sym||'\u20ac';
var isUsd=d.currency==='USD';
/* --- 1. Bouw tijdlijn voor lijn-grafiek --- */
var allPoints=[];
if(d.avg30>0) allPoints.push({ label:(T.thirtyDay||'30D gem'),val:d.avg30,isCurrent:false,period:30 });
if(d.avg7 >0) allPoints.push({ label:(T.sevenDay||'7D gem'), val:d.avg7, isCurrent:false,period:7  });
if(!d.isOp && d.avg1>0) allPoints.push({ label:(T.oneDay||'1D gem'),val:d.avg1,isCurrent:false,period:1 });
if(d.price>0) allPoints.push({ label:(T.now||'Nu'),val:d.price,isCurrent:true,period:0 });
if(!d.isOp && allPoints.length<2 && d.trend>0 && d.price>0){
allPoints=[{ label:(T.trend||'Trend'),val:d.trend,isCurrent:false,period:30 },{ label:(T.now||'Nu'),val:d.price,isCurrent:true,period:0 }];
}
if(allPoints.length===1 && allPoints[0].val>0){
allPoints.unshift({ label:(T.ref||'Ref'),val:allPoints[0].val,isCurrent:false,period:30 });
}
_cwcrChartData=allPoints;
/* --- 2. Price hero boven periode-knoppen --- */
var heroPrice=d.price>0 ? sym+'\u00a0'+d.price.toFixed(2) : (d.nmPrice>0 ? sym+'\u00a0'+d.nmPrice.toFixed(2) : '\u2014');
var existingHero=periodsEl.parentNode.querySelector('.cwcr-analyse-hero');
if(existingHero) existingHero.parentNode.removeChild(existingHero);
var heroDiv=document.createElement('div');
heroDiv.className='cwcr-analyse-hero';
heroDiv.innerHTML='<div class="cwcr-analyse-hero-price">'+heroPrice+'</div><div class="cwcr-analyse-hero-label">'+(T.nearMintPrice||'Near Mint Prijs')+'</div>';
periodsEl.parentNode.insertBefore(heroDiv,periodsEl);
/* --- Periode filter knoppen --- */
var periods=[{ label:'1D',max:2 },{ label:'7D',max:8 },{ label:'30D',max:31 }];
var pHtml='';
periods.forEach(function(p){
pHtml+='<button type="button" class="cwcr-chart-period-btn'+(p.label==='1D'?' is-active':'')+'" data-max="'+p.max+'" onclick="cwcrFilterChart('+p.max+',this)">'+p.label+'</button>';
});
periodsEl.innerHTML=pHtml;
/* --- 3. Lijn-/areagrafiek (standaard 1D filter) --- */
var initFiltered=allPoints.filter(function(p){ return p.period<2 || p.period===0; });
if(initFiltered.length<2 && allPoints.length>=2) initFiltered=allPoints;
_cwcrChartSym=sym;
cwcrRenderChart(initFiltered,chartEl,sym);
if(isUsd && chartEl){ chartEl.insertAdjacentHTML('afterbegin','<div class="cwcr-price-hero-usd" style="margin-bottom:8px">USD via TCGplayer \u2014 geen historische cardmarkt grafiek beschikbaar</div>'); }
/* --- 4. KPI pills: 1D / 7D / 30D --- */
var kpiDefs=[
{ label:'1D', evo: d.evo && d.evo.rawEvo1!=null ? d.evo.rawEvo1 : null, ref:d.avg1, cur:d.price },
{ label:'7D', evo: d.evo && d.evo.rawEvo7!=null ? d.evo.rawEvo7 : null, ref:d.avg7, cur:d.price },
{ label:'30D',evo: d.evo && d.evo.rawEvo30!=null ? d.evo.rawEvo30 : null, ref:d.avg30,cur:d.price }
];
var kpiHtml='<div class="cwcr-detail-chart-title" style="margin-top:8px">'+(T.evoAllConditions||'Evolutie Alle Condities')+'</div>';
// Verse set: er is wel een huidige prijs maar geen historische referentie, waardoor de
// evolutie als -100% berekend wordt. Dat oogt als een crash terwijl het "nog geen data"
// is. Detecteer: alle aanwezige evoluties zijn -100 (en er is geen enkele referentieprijs).
var _evoVals=kpiDefs.map(function(k){return k.evo;}).filter(function(v){return v!=null;});
var _hasRef=kpiDefs.some(function(k){return k.ref>0;});
var _allMinus100=_evoVals.length>0 && _evoVals.every(function(v){return v<=-99.9;}) && !_hasRef;
if(_allMinus100){
kpiHtml+='<div class="cwcr-evo-nodata" style="margin-top:6px;padding:10px 14px;border-radius:12px;background:rgba(123,94,167,0.07);border:1px solid rgba(123,94,167,0.15);color:#6b5a8a;font-size:13px;line-height:1.45;display:flex;align-items:center;gap:8px;"><span style="font-size:15px;">&#8987;</span><span>'+(T.evoNoData||'Nog niet genoeg prijsdata voor deze nieuwe set')+'</span></div>';
} else {
kpiHtml+='<div class="cwcr-kpi-row">';
kpiDefs.forEach(function(k){
var pctStr='—', pctCls='cwcr-val-muted', deltaStr='';
if(k.evo!=null){
pctCls=k.evo>0?'cwcr-val-green':k.evo<0?'cwcr-val-red':'cwcr-val-muted';
pctStr=(k.evo>0?'+':'')+k.evo.toFixed(1)+'%';
}
if(k.ref>0 && k.cur>0){
var delta=k.cur - k.ref;
deltaStr=(delta>=0?'+':'')+sym+Math.abs(delta).toFixed(2);
}
kpiHtml+='<div class="cwcr-kpi-pill">';
kpiHtml+='<div class="cwcr-kpi-label">'+k.label+'</div>';
kpiHtml+='<div class="cwcr-kpi-pct '+pctCls+'">'+pctStr+'</div>';
kpiHtml+='<div class="cwcr-kpi-delta">'+deltaStr+'</div>';
kpiHtml+='</div>';
});
kpiHtml+='</div>';
}
/* --- 4b. NM-specifieke evolutie pills --- */
var nmEvo=d.evo||{};
var nmD1=nmEvo.calculatedDay1Pct!=null?nmEvo.calculatedDay1Pct:null;
var nmD7=nmEvo.calculatedDay7Pct!=null?nmEvo.calculatedDay7Pct:null;
var nmD30=nmEvo.calculatedDay30Pct!=null?nmEvo.calculatedDay30Pct:null;
var _nmHasNonZero=(nmD1!=null&&nmD1!==0)||(nmD7!=null&&nmD7!==0)||(nmD30!=null&&nmD30!==0);
if(_nmHasNonZero){
var nmKpiDefs=[
{ label:'1D', evo:nmD1 },
{ label:'7D', evo:nmD7 },
{ label:'30D',evo:nmD30 }
];
kpiHtml+='<div class="cwcr-detail-chart-title" style="margin-top:10px">'+(T.evoNearMint||'Prijsevolutie Near Mint')+'</div><div class="cwcr-kpi-row">';
nmKpiDefs.forEach(function(k){
var pctStr='—', pctCls='cwcr-val-muted';
if(k.evo!=null){
pctCls=k.evo>0?'cwcr-val-green':k.evo<0?'cwcr-val-red':'cwcr-val-muted';
pctStr=(k.evo>0?'+':'')+k.evo.toFixed(1)+'%';
}
kpiHtml+='<div class="cwcr-kpi-pill">';
kpiHtml+='<div class="cwcr-kpi-label">'+k.label+'</div>';
kpiHtml+='<div class="cwcr-kpi-pct '+pctCls+'">'+pctStr+'</div>';
kpiHtml+='</div>';
});
kpiHtml+='</div>';
}
var barHtml=kpiHtml;
/* --- 5. Gegroepeerde + inklapbare tabel --- */
var _cwcrCountryNames={ DE:'Duitsland',FR:'Frankrijk',ES:'Spanje',IT:'Italië',NL:'Nederland',BE:'België',AT:'Oostenrijk',PL:'Polen',PT:'Portugal',GB:'UK',IE:'Ierland',DK:'Denemarken',SE:'Zweden',FI:'Finland',NO:'Noorwegen',CZ:'Tsjechië',GR:'Griekenland',HU:'Hongarije',RO:'Roemenië' };
function _cwcrFlag2(code){ if(!code||code.length!==2) return ''; var A=0x1F1E6,ASCII_A=65; return String.fromCodePoint(A+(code.charCodeAt(0)-ASCII_A))+String.fromCodePoint(A+(code.charCodeAt(1)-ASCII_A)); }
var nmRows=[];
if(d.nmPrice>0) nmRows.push({ label:'\uD83C\uDF0D '+(T.worldwide||'Wereldwijd'),val:sym+d.nmPrice.toFixed(2),cls:'cwcr-val-gold' });
if(d.nmEU>0)    nmRows.push({ label:'\uD83C\uDDEA\uD83C\uDDFA '+(T.europe||'Europa'),val:sym+d.nmEU.toFixed(2),cls:'' });
if(d.nmByCountry){ Object.keys(d.nmByCountry).sort().forEach(function(cc){ var v=d.nmByCountry[cc]; if(v>0) nmRows.push({ label:_cwcrFlag2(cc)+' '+(_cwcrCountryNames[cc]||cc),val:sym+v.toFixed(2),cls:'' }); }); }
var avgRows=[];
if(d.avgSell>0) avgRows.push({ label:(T.avgSalePrice||'Gem. Verkoopprijs'),val:sym+d.avgSell.toFixed(2) });
if(d.trend>0)   avgRows.push({ label:(T.trendPrice||'Trendprijs'),val:sym+d.trend.toFixed(2) });
if(d.low>0)     avgRows.push({ label:(T.lowestPrice||'Laagste prijs'),val:sym+d.low.toFixed(2) });
if(d.avg1>0)    avgRows.push({ label:(T.average1d||'Gemiddelde 1D'),val:sym+d.avg1.toFixed(2) });
if(d.avg7>0)    avgRows.push({ label:(T.average7d||'Gemiddelde 7D'),val:sym+d.avg7.toFixed(2) });
if(d.avg30>0)   avgRows.push({ label:(T.average30d||'Gemiddelde 30D'),val:sym+d.avg30.toFixed(2) });
var evoRows=[];
// Verse set (alle evo -100% zonder referentieprijs): laat de evolutie-rijen weg, de
// "nog niet genoeg data"-melding bovenaan dekt dit al. Anders oogt het als een -100% crash.
if(d.evo && !_allMinus100){
function _ecls(v){ return v>0?'cwcr-val-green':v<0?'cwcr-val-red':''; }
function _eval(v){ return (v>0?'+':'')+v.toFixed(1)+'%'; }
if(d.evo.rawEvo1 !=null) evoRows.push({ label:(T.evo1d||'Evolutie 1D'), val:_eval(d.evo.rawEvo1), cls:_ecls(d.evo.rawEvo1)  });
if(d.evo.rawEvo7 !=null) evoRows.push({ label:(T.evo7d||'Evolutie 7D'), val:_eval(d.evo.rawEvo7), cls:_ecls(d.evo.rawEvo7)  });
if(d.evo.rawEvo30!=null) evoRows.push({ label:(T.evo30d||'Evolutie 30D'),val:_eval(d.evo.rawEvo30),cls:_ecls(d.evo.rawEvo30) });
}
function renderPtSection(title,rows){
if(!rows.length) return '';
var rowsH=rows.map(function(r){ return '<div class="cwcr-price-compare-row"><span class="cwcr-price-compare-label">'+r.label+'</span><span class="cwcr-price-compare-val '+(r.cls||'')+'">'+r.val+'</span></div>'; }).join('');
var chevSvg='<svg class="cwcr-pt-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13" style="transition:transform 0.2s;transform:rotate(180deg)"><polyline points="6 9 12 15 18 9"/></svg>';
return '<div class="cwcr-pt-section">'+
'<div class="cwcr-pt-section-hdr cwcr-pt-open" onclick="cwcrTogglePtSection(this)">'+
'<span>'+title+'</span>'+chevSvg+
'</div>'+
'<div class="cwcr-pt-section-body">'+rowsH+'</div>'+
'</div>';
}
var sectionsHtml=renderPtSection('\uD83C\uDF0D '+(T.nmPrices||'Near Mint prijzen'),nmRows)+renderPtSection('\uD83D\uDCCA '+(T.priceAverages||'Prijsgemiddelden'),avgRows)+renderPtSection('\uD83D\uDCC8 '+(T.priceEvolution||'Prijsevolutie'),evoRows);
var toggleChevSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13" style="transition:transform 0.2s"><polyline points="6 9 12 15 18 9"/></svg>';
var tableWrap='<div class="cwcr-pt-wrap">'+
'<div class="cwcr-pt-toggle" onclick="cwcrTogglePriceTable(this)">'+toggleChevSvg+'<span>'+(T.showFullTable||'Toon volledige prijstabel')+'</span></div>'+
'<div class="cwcr-pt-inner cwcr-pt-inner-collapsed">'+sectionsHtml+'</div>'+
'</div>';
tableEl.innerHTML=barHtml+tableWrap;
}
var _cwcrChartSym='\u20ac';
function cwcrRenderChart(points,container,sym){
var T=window.CWPD_I18N||{};
sym=sym||'\u20ac';
if(!container) return;
var _chLight=document.documentElement.classList.contains('cwcr-theme-light');
var _chGrid=_chLight?'rgba(29,19,48,0.08)':'rgba(255,255,255,0.05)';
var _chYLabel=_chLight?'rgba(29,19,48,0.45)':'rgba(255,255,255,0.25)';
var _chXLabel=_chLight?'rgba(29,19,48,0.5)':'rgba(255,255,255,0.35)';
var _chNodeStroke=_chLight?'rgba(255,255,255,0.95)':'rgba(17,5,48,0.9)';
var _chEmpty=_chLight?'rgba(29,19,48,0.35)':'rgba(255,255,255,0.2)';
if(!points || points.length<2){
container.innerHTML = '<div style="text-align:center;padding:40px 0;color:'+_chEmpty+';font-size:12px">'+(T.noChartData||'Geen grafiekdata beschikbaar')+'</div>';
return;
}
var W=700,H = 150,PL = 50,PR = 14,PT = 10,PB = 32;
var cw=W - PL - PR,ch = H - PT - PB;
var vals=points.map(function(p){ return p.val; });
var minV=Math.min.apply(null,vals),maxV = Math.max.apply(null,vals);
var range=maxV - minV || 0.01;
var pad=range * 0.08; minV -= pad; maxV += pad; range = maxV - minV;
var pts=points.map(function(p,i){
return{
x: PL + (i / (points.length - 1)) * cw,y: PT + ch - ((p.val - minV) / range) * ch,val: p.val,label: p.label,isCurrent: p.isCurrent
};
});
var nGrid=4;
var gridSvg='';
for(var g=0; g<=nGrid; g++){
var gy=PT + (g / nGrid) * ch;
var gv=maxV - (g / nGrid) * range;
gridSvg += '<line x1="' + PL + '" y1="' + gy.toFixed(1) + '" x2="' + (W - PR) + '" y2="' + gy.toFixed(1) + '" stroke="' + _chGrid + '" stroke-width="1"/>';
gridSvg += '<text x="' + (PL - 6) + '" y="' + (gy + 4).toFixed(1) + '" text-anchor="end" font-size="10" fill="' + _chYLabel + '" font-family="var(--cwcr-font)">' + sym + gv.toFixed(2) + '</text>';
}
var pathD;
if(pts.length>=4){
pathD = 'M' + pts[0].x.toFixed(1) + ',' + pts[0].y.toFixed(1);
for(var i=0; i<pts.length - 1; i++){
var p0=pts[Math.max(0,i - 1)];
var p1=pts[i];
var p2=pts[i + 1];
var p3=pts[Math.min(pts.length - 1,i + 2)];
var t=0.3;
var cp1x=p1.x + (p2.x - p0.x) * t;
var cp1y=p1.y + (p2.y - p0.y) * t;
var cp2x=p2.x - (p3.x - p1.x) * t;
var cp2y=p2.y - (p3.y - p1.y) * t;
pathD += ' C' + cp1x.toFixed(1) + ',' + cp1y.toFixed(1) + ' ' + cp2x.toFixed(1) + ',' + cp2y.toFixed(1) + ' ' + p2.x.toFixed(1) + ',' + p2.y.toFixed(1);
}
}else{
pathD = pts.map(function(p,i){ return (i===0 ? 'M' : 'L') + p.x.toFixed(1) + ',' + p.y.toFixed(1); }).join(' ');
}
var areaD=pathD + ' L' + pts[pts.length-1].x.toFixed(1) + ',' + (H - PB) + ' L' + PL + ',' + (H - PB) + ' Z';
var xLabels=pts.map(function(p){
return '<text x="' + p.x.toFixed(1) + '" y="' + (H - 6) + '" text-anchor="middle" font-size="10" fill="' + _chXLabel + '" font-family="var(--cwcr-font)">' + p.label + '</text>';
}).join('');
var circles=pts.map(function(p,idx){
var col=p.isCurrent ? '#E8C840' : '#a78bfa';
var r=p.isCurrent ? 6 : 4.5;
return '<g class="cwcr-chart-point" data-label="' + esc(p.label) + '" data-val="' + sym + p.val.toFixed(2) + '" data-cx="' + p.x.toFixed(1) + '" style="animation:cwcrPointIn 0.3s ' + (0.3 + idx * 0.08) + 's both">' +
'<circle cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="' + (r + 10) + '" fill="transparent"/>' +
'<circle cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="' + r + '" fill="' + col + '" stroke="' + _chNodeStroke + '" stroke-width="2.5"/>' +
(p.isCurrent ? '<circle cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="10" fill="rgba(232,200,64,0.12)"><animate attributeName="r" values="8;13;8" dur="2.5s" repeatCount="indefinite"/><animate attributeName="opacity" values="0.15;0.04;0.15" dur="2.5s" repeatCount="indefinite"/></circle>' : '') +
'</g>';
}).join('');
var pathLen=0;
for(var k=1; k<pts.length; k++){
pathLen += Math.sqrt(Math.pow(pts[k].x - pts[k-1].x,2) + Math.pow(pts[k].y - pts[k-1].y,2));
}
pathLen = Math.ceil(pathLen * 1.3);
container.innerHTML =
'<div class="cwcr-detail-chart-title">Gemiddeld NM prijsverloop</div>' +
'<div style="position:relative">' +
'<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" style="width:100%;display:block;overflow:visible">' +
'<defs>' +
'<linearGradient id="cwcrAreaGrad2" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="rgba(145,70,255,0.25)"/><stop offset="100%" stop-color="rgba(145,70,255,0)"/></linearGradient>' +
'<style>@keyframes cwcrPointIn{from{opacity:0;transform:scale(0)}to{opacity:1;transform:scale(1)}}@keyframes cwcrPulse{0%,100%{r:10;opacity:0.15}50%{r:14;opacity:0.05}}</style>' +
'</defs>' +
gridSvg +
'<path d="' + areaD + '" fill="url(#cwcrAreaGrad2)" style="animation:cwcrChartAreaFade 0.5s 0.2s both"/>' +
'<path d="' + pathD + '" fill="none" stroke="#9146ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="stroke-dasharray:' + pathLen + ';--cwcr-path-len:' + pathLen + ';animation:cwcrChartDraw 0.8s ease forwards"/>' +
xLabels + circles +
'</svg>' +
'<div class="cwcr-chart-tooltip" id="cwcr-chart-tooltip2"></div>' +
'</div>';
container.querySelectorAll('.cwcr-chart-point').forEach(function(pt){
var tooltip=container.querySelector('#cwcr-chart-tooltip2');
pt.addEventListener('mouseenter',function(){
if(!tooltip) return;
tooltip.textContent = pt.dataset.label + ': ' + pt.dataset.val;
var ptCircle=pt.querySelector('circle:nth-of-type(2)') || pt.querySelector('circle:last-of-type');
if(ptCircle){
var cr=ptCircle.getBoundingClientRect();
var pr=tooltip.parentElement.getBoundingClientRect();
tooltip.style.left = (cr.left - pr.left + cr.width / 2) + 'px';
tooltip.style.top  = (cr.top  - pr.top  + cr.height / 2) + 'px';
}
tooltip.style.display='block';
});
pt.addEventListener('mouseleave',function(){
if(tooltip) tooltip.style.display='none';
});
});
}
function cwcrFilterChart(maxPeriod,btn){
if(!_cwcrChartData) return;
var filtered=_cwcrChartData.filter(function(p){ return p.period<maxPeriod || p.period===0; });
if(filtered.length<2 && _cwcrChartData.length>=2) filtered = _cwcrChartData;
var chartEl=document.getElementById('cwcr-detail-chart');
var _prevIsUsd=_cwcrChartSym==='$';
cwcrRenderChart(filtered,chartEl,_cwcrChartSym);
if(_prevIsUsd && chartEl){ chartEl.insertAdjacentHTML('afterbegin','<div class="cwcr-price-hero-usd" style="margin-bottom:8px">USD via TCGplayer \u2014 geen historische cardmarkt grafiek beschikbaar</div>'); }
document.querySelectorAll('.cwcr-chart-period-btn').forEach(function(b){ b.classList.remove('is-active'); });
if(btn) btn.classList.add('is-active');
}
function cwcrFillSignalen(d){
var T=window.CWPD_I18N||{};
var el=document.getElementById('cwcr-detail-signalen');
if(!el) return;
var sym=d.sym||'\u20ac';
var prices=[d.nmPrice,d.avg1,d.avg7,d.avg30,d.trend].filter(function(v){ return v>0; });
if(prices.length<2){
el.innerHTML='<div class="cwcr-signal-empty">'+(T.notEnoughData||'Niet genoeg data voor prijssignalen.')+'</div>';
return;
}
/* Prijstrend */
var trendDir='stable';
if(d.avg1>0 && d.avg7>0 && d.avg30>0){
if(d.avg1>d.avg7 && d.avg7>d.avg30) trendDir='rising';
else if(d.avg1<d.avg7 && d.avg7<d.avg30) trendDir='falling';
}
/* Volatiliteit */
var pMin=Math.min.apply(null,prices);
var pMax=Math.max.apply(null,prices);
var volPct=pMin>0 ? ((pMax-pMin)/pMin*100) : 0;
var volLabel=volPct<5?(T.low||'Laag'):volPct<15?(T.medium||'Medium'):(T.high||'Hoog');
/* Koopsignaal: NM 10%+ onder trend */
var buySignal=d.nmPrice>0 && d.trend>0 && d.nmPrice<d.trend*0.9;
/* NM vs Trend */
var nmVsTrend=null;
if(d.nmPrice>0 && d.trend>0) nmVsTrend=(d.nmPrice-d.trend)/d.trend*100;
/* Prijsspanning laag - gem */
var spanning=null;
var spanningRef=d.avgSell>0?d.avgSell:(d.trend>0?d.trend:0);
if(d.low>0 && spanningRef>0) spanning=spanningRef-d.low;
/* 1D vs 7D */
var d1vs7=null;
if(d.avg1>0 && d.avg7>0) d1vs7=(d.avg1-d.avg7)/d.avg7*100;
/* 7D vs 30D */
var d7vs30=null;
if(d.avg7>0 && d.avg30>0) d7vs30=(d.avg7-d.avg30)/d.avg30*100;
/* Build HTML */
var badges='';
if(buySignal) badges+='<div class="cwcr-signal-badge cwcr-signal-buy">'+(T.buyOpportunity||'Mogelijke koopkans')+'</div>';
if(trendDir==='rising') badges+='<div class="cwcr-signal-badge cwcr-signal-rising">'+(T.risingTrend||'\u2191 Stijgende trend')+'</div>';
else if(trendDir==='falling') badges+='<div class="cwcr-signal-badge cwcr-signal-falling">'+(T.fallingTrend||'\u2193 Dalende trend')+'</div>';
else badges+='<div class="cwcr-signal-badge cwcr-signal-stable">'+(T.stableTrend||'\u2014 Stabiele trend')+'</div>';
if(volPct>=15) badges+='<div class="cwcr-signal-badge cwcr-signal-volatile">'+(T.highVolatility||'Hoge volatiliteit')+'</div>';
var rows='';
/* Prijstrend */
var trendTxt=trendDir==='rising'?(T.rising||'\u2191 Stijgend'):trendDir==='falling'?(T.falling||'\u2193 Dalend'):(T.stable||'\u2014 Stabiel');
var trendCls=trendDir==='rising'?'cwcr-val-green':trendDir==='falling'?'cwcr-val-red':'cwcr-val-muted';
rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+(T.priceTrend||'Prijstrend')+'</span><span class="cwcr-signal-val '+trendCls+'">'+trendTxt+'</span></div>';
/* Volatiliteit */
rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+(T.volatility||'Volatiliteit')+'</span><span class="cwcr-signal-val">'+esc(volLabel)+' ('+volPct.toFixed(1)+'%)</span></div>';
/* NM vs Trend */
if(nmVsTrend!==null){
var nvtStr=(nmVsTrend>=0?'+':'')+nmVsTrend.toFixed(1)+'% '+(nmVsTrend<0?(T.belowTrend||'onder trend'):(T.aboveTrend||'boven trend'));
var nvtCls=nmVsTrend>0?'cwcr-val-green':nmVsTrend<0?'cwcr-val-red':'';
rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+(T.nmVsTrend||'NM vs Trend')+'</span><span class="cwcr-signal-val '+nvtCls+'">'+esc(nvtStr)+'</span></div>';
}
/* Prijsspanning */
if(spanning!==null){
rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+(T.priceSpan||'Prijsspanning')+'</span><span class="cwcr-signal-val">'+sym+spanning.toFixed(2)+' ('+(T.lowToAvg||'laag \u2013 gem.')+')</span></div>';
}
/* 1D vs 7D */
if(d1vs7!==null){
var d1Str=(d1vs7>=0?'+':'')+d1vs7.toFixed(1)+'%';
var d1Cls=d1vs7>0?'cwcr-val-green':d1vs7<0?'cwcr-val-red':'';
rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">1D vs 7D</span><span class="cwcr-signal-val '+d1Cls+'">'+esc(d1Str)+'</span></div>';
}
/* 7D vs 30D */
if(d7vs30!==null){
var d7Str=(d7vs30>=0?'+':'')+d7vs30.toFixed(1)+'%';
var d7Cls=d7vs30>0?'cwcr-val-green':d7vs30<0?'cwcr-val-red':'';
rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">7D vs 30D</span><span class="cwcr-signal-val '+d7Cls+'">'+esc(d7Str)+'</span></div>';
}
el.innerHTML=(d.currency==='USD'?'<div class="cwcr-price-hero-usd" style="margin-bottom:8px" title="'+(T.historicalNotAvailable||'USD via TCGplayer - historische data niet beschikbaar')+'">'+(T.historicalNotAvailable||'USD via TCGplayer - historische data niet beschikbaar')+'</div>':'')+' <div class="cwcr-signals-wrap"><div class="cwcr-signal-badges">'+badges+'</div><div class="cwcr-signal-title">'+(T.priceAnalysisTitle||'Prijsanalyse')+'</div><div class="cwcr-signal-grid">'+rows+'</div></div>';
}
function cwcrFillMarkt(d){
var T=window.CWPD_I18N||{};
var el=document.getElementById('cwcr-detail-market');
if(!el) return;
var sym=d.sym||'\u20ac';
var isUsd=d.currency==='USD';
var html='';
if(isUsd) html+='<div class="cwcr-price-hero-usd" style="margin-bottom:12px" title="'+(T.usdMarketNotAvailable||'USD via TCGplayer - EU marktdata niet beschikbaar')+'">'+(T.usdMarketNotAvailable||'USD via TCGplayer - EU marktdata niet beschikbaar')+'</div>';
html += '<div class="cwcr-market-section"><div class="cwcr-market-section-title">'+(T.priceOverview||'Prijsoverzicht')+'</div>';
var infoRows=[];
if(d.nmPrice>0)  infoRows.push([isUsd?(T.tcgPrice||'TCGplayer Prijs'):(T.nmWorldwide||'Near Mint (Wereldwijd)'),sym + d.nmPrice.toFixed(2)]);
if(!isUsd && d.nmEU>0) infoRows.push([(T.nmEuOnly||'NM (EU only)'),sym + d.nmEU.toFixed(2)]);
if(d.avgSell>0)  infoRows.push([(T.avgSalePrice||'Gem. Verkoopprijs'),sym + d.avgSell.toFixed(2)]);
if(d.trend>0)    infoRows.push([(T.trendPrice||'Trendprijs'),sym + d.trend.toFixed(2)]);
if(d.low>0)      infoRows.push([(T.lowest||'Laagste'),sym + d.low.toFixed(2)]);
if(isUsd)        infoRows.push([(T.source||'Bron'),'TCGplayer (USD)']);
infoRows.forEach(function(r){
html += '<div class="cwcr-market-row"><span class="cwcr-market-label">' + r[0] + '</span><span class="cwcr-market-val">' + r[1] + '</span></div>';
});
html += '</div>';
html += '<div class="cwcr-market-section"><div class="cwcr-market-section-title">'+(T.cardDetails||'Kaartgegevens')+'</div>';
if(d.cardmarketId) html += '<div class="cwcr-market-row"><span class="cwcr-market-label">'+(T.cardmarketId||'Cardmarket ID')+'</span><span class="cwcr-market-val">' + d.cardmarketId + '</span></div>';
if(d.setName)      html += '<div class="cwcr-market-row"><span class="cwcr-market-label">'+(T.setLabel||'Set')+'</span><span class="cwcr-market-val">' + esc(d.setName) + '</span></div>';
if(d.rarity)       html += '<div class="cwcr-market-row"><span class="cwcr-market-label">'+(T.rarity||'Rariteit')+'</span><span class="cwcr-market-val">' + esc(d.rarityLabel) + '</span></div>';
if(d.isOp && d.color) html += '<div class="cwcr-market-row"><span class="cwcr-market-label">'+(T.color||'Kleur')+'</span><span class="cwcr-market-val">' + esc(d.color) + '</span></div>';
html += '</div>';
el.innerHTML = html;
}
function openCardDetail(card,franchise,cardIdx){
if(!detailOverlay) return;
/* Cancel pending RAFs van eventuele vorige render (kaart-naar-kaart navigatie) */
cwcrCancelAllCountUps();
window._cwcrNmScope='world';
document.body.classList.add('cwcr-overlay-open');
if(cardIdx!==undefined){
if(!window._cwcrPreModalUrl) window._cwcrPreModalUrl=window.location.href;
var isOpU=(franchise==='onepiece');
var frPathU=isOpU?'one-piece':'pokemon';
var nameU=isOpU?(card.name||card.card_name||''):(card.name||'');
var numberU=isOpU?(card.card_id||card.id||''):(card.number||'');
var namePartU=(nameU||'').toLowerCase().replace(/[.\s]+/g,'-').replace(/[^a-z0-9-]/g,'').replace(/-+/g,'-').replace(/^-|-$/g,'');
var numPartU=(numberU||'').toLowerCase().replace(/[^a-z0-9-]/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
var cmPartU=isOpU&&card.cardmarket_id?String(card.cardmarket_id):'';
var slugU=(namePartU+(numPartU?'-'+numPartU:'')+(cmPartU?'-'+cmPartU:'')).slice(0,80)||'kaart';
/* Gebruik altijd card-level set als die beschikbaar is (voorkomt OP02-in-EB03 bug) */
var setIdU=(card && (card._setId || card.set_id))
      || (card && card.set && card.set.id)
      || activeSetId || '';
if(setIdU==='__all__') setIdU='';
if(slugU && setIdU){
window.history.replaceState({cwcrModal:true},'',CWCR_PD_BASE+'/'+frPathU+'/'+encodeURIComponent(setIdU)+'/'+slugU);
} else {
var reopenParam=JSON.stringify({idx:cardIdx,fr:franchise,setId:setIdU,setName:activeSetName});
var curParams=new URLSearchParams(window.location.search);
curParams.set('cwcr_reopen',reopenParam);
window.history.replaceState({},'',window.location.pathname+'?'+curParams.toString());
}
}
// Cache huidige kaartdata voor "Voeg toe aan collectie" knop
cwcrPaywallCardObj = card;
cwcrPaywallFranchise = franchise;
if(!cwcrIsLoggedIn){
showPaywallInModal(card,franchise,cardIdx!==undefined ? cardIdx : -1);
return;
}
var modal=document.getElementById('cwcr-detail-modal');
var gate=document.getElementById('cwcr-paywall-gate');
var loginGate=document.getElementById('cwcr-login-gate');
if(modal) modal.classList.remove('cwcr-paywall-mode');
if(gate) gate.classList.remove('is-active');
if(loginGate) loginGate.classList.remove('is-active');
document.querySelectorAll('.cwcr-tab-btn').forEach(function(btn){if(btn.dataset.pwOrig){btn.textContent=btn.dataset.pwOrig;delete btn.dataset.pwOrig;}});
var isOp=franchise==='onepiece';
var name=isOp ? (card.name || card.card_name || '') : (card.name || '');
var number=isOp ? (card.card_id || card.id || '') : (card.number || '');
var rarity=card.rarity || '';
var price=card._price || 0;
var cardCur2=card._currency||'EUR';
var cardSym2=cardCur2==='USD'?'$':'\u20ac';
cwcrTrack('card_click',{ name: name,franchise: franchise,set: activeSetId || '',price: price });
var cm=(card.cardmarket && card.cardmarket.prices) ? card.cardmarket.prices : null;
var evo=(card.cardmarket && card.cardmarket.evolution) ? card.cardmarket.evolution : null;
var avg1=cm ? (cm.avg1 || 0) : 0;
var avg7=cm ? (cm.avg7 || 0) : (isOp ? (parseFloat(card.inventory_price) || 0) : 0);
var avg30=cm ? (cm.avg30 || 0) : (isOp ? (parseFloat(card.market_price) || 0) : 0);
var trend=cm ? (cm.trendPrice || 0) : 0;
var low=cm ? (cm.lowPrice || 0) : 0;
var nmPrice=cm ? (cm.lowestNearMint || 0) : 0;
var nmEU=cm ? (cm.lowestNearMintEU || 0) : 0;
var nmByCountry=(cm && cm.nmByCountry && typeof cm.nmByCountry==='object') ? cm.nmByCountry : {};
var avgSell=cm ? (cm.averageSellPrice || 0) : 0;
var cmLink=isOp ? opCardmarkUrl(card,number,name) : pkCardmarkUrl(card,name);
var info=isOp ? (opRarity[rarity] || { label: rarity,cls: 'cwcr-badge-other' }) : (pkRarity[rarity] || { label: rarity,cls: 'cwcr-badge-other' });
var imgEl=document.getElementById('cwcr-detail-img');
var nameEl=document.getElementById('cwcr-detail-name');
var numEl=document.getElementById('cwcr-detail-number');
var badgeEl=document.getElementById('cwcr-detail-badge');
var metaEl=document.getElementById('cwcr-detail-meta');
var actEl=document.getElementById('cwcr-detail-actions');
cwcrSetModalImg(imgEl, card, franchise, name);
if(nameEl) nameEl.textContent = name;
if(numEl) numEl.textContent = '';
if(badgeEl){ badgeEl.textContent = info.label; badgeEl.className = 'cwcr-detail-rarity ' + info.cls; badgeEl.style.cssText = ''; }
var imgColEl=document.getElementById('cwcr-detail-img-col');
var rarPri=info.pri || 99;
var glowTier;
if(isOp){glowTier=price>=1000?5:price>=100?4:price>=20?3:price>=4?2:price>0?1:0;}
else{glowTier=rarPri<=1?5:rarPri<=2?4:rarPri<=3?3:rarPri<=5?2:rarPri<=6?1:0;}
if(imgColEl){
imgColEl.className = imgColEl.className.replace(/\bcwcr-glow-\d\b/g,'').trim();
if(glowTier>0) imgColEl.classList.add('cwcr-glow-' + glowTier);
imgColEl.dataset.franchise = isOp ? 'onepiece' : 'pokemon';
}
cwcrUpdateAura(glowTier);
if(badgeEl){
/* header-rarity is platte tekst (concept A) — geen felle badge-glow tier meer */
badgeEl.className = badgeEl.className.replace(/\bcwcr-badge-glow-\d\b/g,'').trim();
}
var backContent=document.getElementById('cwcr-card-back-content');
if(backContent){
var Tb=window.CWPD_I18N||{};
var bh='<div class="cwcr-card-back-title">' + esc(name) + '</div>';
if(rarity) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.rarityLabel||'Rarity')+'</span><span class="cwcr-card-back-val">' + esc(info.label || rarity) + '</span></div>';
if(number) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.numberLabel||'Nummer')+'</span><span class="cwcr-card-back-val">' + esc(number) + '</span></div>';
if(!isOp && card.set && card.set.name) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.setLabelBack||'Set')+'</span><span class="cwcr-card-back-val">' + esc(card.set.name) + '</span></div>';
if(!isOp && card.hp) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">HP</span><span class="cwcr-card-back-val">' + esc(String(card.hp)) + '</span></div>';
var cardTypes=(!isOp && card.types) ? (Array.isArray(card.types) ? card.types : [card.types]) : [];
if(cardTypes.length) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.typeLabel||'Type')+'</span><span class="cwcr-card-back-val">' + cardTypes.map(esc).join(',') + '</span></div>';
if(isOp && card.color)     bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.colorLabel||'Kleur')+'</span><span class="cwcr-card-back-val">' + esc(card.color) + '</span></div>';
if(isOp && card.card_type && card.card_type!=='singles') bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.typeLabel||'Type')+'</span><span class="cwcr-card-back-val">' + esc(card.card_type) + '</span></div>';
if(isOp && card.power)     bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">Power</span><span class="cwcr-card-back-val">' + esc(card.power) + '</span></div>';
if(isOp && card.life)      bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">Life</span><span class="cwcr-card-back-val">' + esc(card.life) + '</span></div>';
if(isOp && card.counter)   bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">Counter</span><span class="cwcr-card-back-val">' + esc(card.counter) + '</span></div>';
if(price>0) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.priceLabel||'Prijs')+'</span><span class="cwcr-card-back-val" style="color:var(--cwcr-gold)">'+cardSym2 + price.toFixed(2) + '</span></div>';
backContent.innerHTML = bh;
}
if(window._cwcrResetFlip) window._cwcrResetFlip();
if(window._cwcrResetZoom) window._cwcrResetZoom();
/* Meta als één rustige tekstregel (concept A): nummer · kleur · set, met · scheidingstekens (geen pills) */
var metaParts=[];
var _setNameForTag = isOp ? (card.set_name || '') : ((card.set && card.set.name) || '');
var _opColorMap={'Red':'#ff5555','Green':'#22c55e','Blue':'#60a5fa','Purple':'#a855f7','Black':'#2b2535','Yellow':'#eab308','Multi':'#e879f9'};
if(number) metaParts.push('<span class="cwcr-meta-num">' + esc('#' + number) + '</span>');
if(isOp && card.color){var _col=_opColorMap[card.color]||'#a78bfa';metaParts.push('<span class="cwcr-meta-color"><span class="cwcr-meta-dot" style="background:'+_col+'"></span>' + esc(card.color) + '</span>');}
if(isOp && card.card_type && card.card_type!=='singles') metaParts.push('<span>' + esc(card.card_type) + '</span>');
if(_setNameForTag) metaParts.push('<span>' + esc(_setNameForTag) + '</span>');
if(metaEl) metaEl.innerHTML = metaParts.join('<span class="cwcr-meta-sep">&middot;</span>');
var d={
isOp: isOp,name: name,number: number,rarity: rarity,rarityLabel: info.label || rarity,price: price,nmPrice: nmPrice,nmEU: nmEU,nmByCountry: nmByCountry,avgSell: avgSell,avg1: avg1,avg7: avg7,avg30: avg30,trend: trend,low: low,evo: evo,cmLink: cmLink,tcggoUrl: card.tcggo_url || '',cardmarketId: card.cardmarket_id || null,setName: isOp ? (card.set_name || '') : ((card.set && card.set.name) || ''),color: card.color || '',currency: cardCur2,sym: cardSym2
};
cwcrFillOverzicht(d);
cwcrFillAnalyse(d);
cwcrFillSignalen(d);
cwcrFillMarkt(d);
cwcrInitTabs();
cwcrSwitchTab('overzicht');
var Ta=window.CWPD_I18N||{};
var ah='';
ah += '<div class="cwcr-detail-btn-row">';
ah += '<button type="button" class="cwcr-detail-btn cwcr-detail-btn-cw" onclick="cwcrOpenShop(event);">' +
'<img src="'+CWCR_LOGO_URL+'" alt="" width="22" height="22" style="flex-shrink:0;filter:drop-shadow(0 0 5px rgba(123,94,167,0.7));" onerror="this.style.display=\'none\'">' +
(Ta.shopAtCw||'Shop bij Cardworld')+'</button>';
// "Kopieer kaartlink" button — kopieert direct naar clipboard (geen OS share-sheet).
// Header share-btn (.cwcr-card-ctrl-btn) is de echte native share via cwcrNativeShareCard.
ah += '<button type="button" class="cwcr-detail-btn cwcr-detail-btn-share" id="cwcr-modal-share-btn" onclick="cwcrCopyCardLink(event);">' +
'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>' +
(Ta.copyCardLink||'Kopieer kaartlink')+'</button>';
ah += '</div>';
// Cardmarket bronlink onder de buttons als subtiele hyperlink
ah += '<a href="' + esc(cmLink) + '" target="_blank" rel="noopener" class="cwcr-detail-source-link" id="cwcr-source-link-btn">' + (cardCur2==='USD' ? (Ta.viewOnTcg||'Bekijk op TCGplayer') : (Ta.viewCmSource||'Bekijk bronprijs op Cardmarket')) + ' <span class="cwcr-ext-arrow">&#8599;</span></a>';
if(actEl) actEl.innerHTML = ah;
/* GA4: track click op externe bronprijs link (Cardmarket / TCGplayer) */
try {
  var _srcLink = document.getElementById('cwcr-source-link-btn');
  if (_srcLink && !_srcLink._cwTrackBound) {
    _srcLink._cwTrackBound = true;
    _srcLink.addEventListener('click', function() {
      try {
        if (window.cwTrack) {
          var _cardObj = (typeof cwcrPaywallCardObj !== 'undefined') ? cwcrPaywallCardObj : null;
          window.cwTrack('click_external_source', {
            source: cardCur2 === 'USD' ? 'tcgplayer' : 'cardmarket',
            content_type: 'pricedex_card',
            item_id: _cardObj ? (_cardObj.name || _cardObj.card_name || '') : '',
            location: 'card_modal',
          });
        }
      } catch (_) {}
    });
  }
} catch (_) {}
detailOverlay.style.display='flex';
document.body.style.overflow = 'hidden';
}
function closeCardDetail(){
if(window._cwcrPaywallChartAnim){cancelAnimationFrame(window._cwcrPaywallChartAnim);window._cwcrPaywallChartAnim=null;}
/* Cancel pending price count-up RAFs — Safari pauzeert RAF bij display:none
   en hervat ze bij re-open, wat stale 0-waardes over nieuwe content schreef. */
cwcrCancelAllCountUps();
if(detailOverlay) detailOverlay.style.display='none';
document.body.style.overflow = '';
document.body.classList.remove('cwcr-overlay-open');
if(window._cwcrPreModalUrl){
window.history.replaceState({},'',window._cwcrPreModalUrl);
window._cwcrPreModalUrl=null;
} else {
var cleanParams=new URLSearchParams(window.location.search);
cleanParams.delete('cwcr_reopen');
var cleanUrl=window.location.pathname+(cleanParams.toString()?'?'+cleanParams.toString():'');
window.history.replaceState({},'',cleanUrl);
}
if(window._cwcrResetFlip)  window._cwcrResetFlip();
if(window._cwcrResetZoom)  window._cwcrResetZoom();
var modalEl2=document.getElementById('cwcr-detail-modal');
if(modalEl2) modalEl2.classList.remove('cwcr-paywall-mode');
var gate2=document.getElementById('cwcr-paywall-gate');
if(gate2) gate2.classList.remove('is-active');
var lg2=document.getElementById('cwcr-login-gate');
if(lg2) lg2.classList.remove('is-active');
var teaser2=document.getElementById('cwcr-paywall-teaser');
if(teaser2) teaser2.style.display='';
/* Herstel tab-labels */
document.querySelectorAll('.cwcr-tab-btn').forEach(function(btn){
if(btn.dataset.pwOrig){btn.textContent=btn.dataset.pwOrig;delete btn.dataset.pwOrig;}
});
}
window.cwcrOpenShop = function(e){
if(e) e.stopPropagation();
try{if(window.cwTrack)window.cwTrack('select_promotion',{promotion_name:'pricedex_shop_cta',location:'card_modal',item_id:(typeof cwcrPaywallCardObj!=='undefined'&&cwcrPaywallCardObj)?(cwcrPaywallCardObj.name||cwcrPaywallCardObj.card_name||''):''});}catch(_){}
window.open('/collections/all','_blank');
};
// Helper: bouw share-payload (url, title, text) voor de huidige paywall-kaart
function _cwcrBuildShareData(){
  var Ta=window.CWPD_I18N||{};
  var url=window.location.href;
  var cardName='';
  try{
    var card=cwcrPaywallCardObj;
    var fr=cwcrPaywallFranchise;
    /* setId-resolutie IDENTIEK aan openCardDetail (card-level eerst, dan activeSetId)
       zodat de gekopieerde link altijd dezelfde set draagt als de adresbalk. Voorheen
       startte deze builder met activeSetId → in "Alle sets" view kon de kopieer-link
       een andere set dragen dan de adresbalk → verkeerde registry → verkeerde kaart. */
    var setId=(card && (card._setId || card.set_id))
         || (card && card.set && card.set.id)
         || activeSetId || '';
    if(setId==='__all__') setId='';
    if(card){
      var isOp=(fr==='onepiece');
      cardName = isOp?(card.name||card.card_name||''):(card.name||'');
      if(fr && setId && setId!=='__all__'){
        var frPath=isOp?'one-piece':'pokemon';
        var number=isOp?(card.card_id||card.id||''):(card.number||'');
        var namePart=(cardName||'').toLowerCase().replace(/[.\s]+/g,'-').replace(/[^a-z0-9-]/g,'').replace(/-+/g,'-').replace(/^-|-$/g,'');
        var numPart=(number||'').toLowerCase().replace(/[^a-z0-9-]/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
        /* cmId-suffix toevoegen zodat varianten met zelfde naam+nummer (bv OP13-118 Manga Rare vs Secret Rare) een unieke link krijgen */
        var cmPart=isOp&&card.cardmarket_id?String(card.cardmarket_id):'';
        var slug=(namePart+(numPart?'-'+numPart:'')+(cmPart?'-'+cmPart:'')).slice(0,80)||'kaart';
        url=window.location.origin+CWCR_PD_BASE+'/'+frPath+'/'+encodeURIComponent(setId)+'/'+slug;
      }
    }
  }catch(_){}
  var title = cardName ? (cardName + ' — CARDWORLD PriceDex') : 'CARDWORLD PriceDex';
  var tmpl = Ta.shareText || '💎 Bekijk {name} op CARDWORLD PriceDex.';
  var text = tmpl.replace('{name}', cardName || 'deze kaart');
  return { url: url, title: title, text: text };
}

function _cwcrCopyToClipboard(url){
  if(navigator.clipboard) return navigator.clipboard.writeText(url);
  return new Promise(function(resolve, reject){
    try {
      var ta=document.createElement('textarea');ta.value=url;ta.style.cssText='position:fixed;opacity:0';
      document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);
      resolve();
    } catch(err){ reject(err); }
  });
}

// Haal card image op + bak caption/url in een footer-strook eronder.
// Zo overleeft de tekst iOS direct-share (waar tekst soms wegvalt).
// Returns null als geen image, CORS-fail, of canShare({files}) niet ondersteund.
function _cwcrBuildShareFile(captionText, shareUrl){
  return new Promise(function(resolve){
    try {
      var card = (typeof cwcrPaywallCardObj !== 'undefined') ? cwcrPaywallCardObj : null;
      var fr   = (typeof cwcrPaywallFranchise !== 'undefined') ? cwcrPaywallFranchise : '';
      if(!card){ resolve(null); return; }
      var isOp = (fr === 'onepiece');
      var imgUrl = isOp
        ? (card.image_url || card.image || card.card_image || card.img || '')
        : (card.images ? (card.images.large || card.images.small || '') : '');
      if(!imgUrl){ resolve(null); return; }
      var nameEl = document.getElementById('cwcr-detail-name');
      var nmRaw  = nameEl ? (nameEl.textContent||'').trim() : '';
      var nm = nmRaw.replace(/[^a-z0-9-]/gi,'-').replace(/-+/g,'-').replace(/^-|-$/g,'').slice(0,40) || 'card';

      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function(){
        try {
          var w  = img.naturalWidth  || 600;
          var h  = img.naturalHeight || 840;
          // Subtiele footer-band: 1 regel caption + URL, dun
          var pad   = Math.round(w * 0.035);
          var capFS = Math.max(18, Math.round(w * 0.034));
          var urlFS = Math.max(14, Math.round(w * 0.026));
          var gap   = Math.round(capFS * 0.25);
          var footH = pad + capFS + gap + urlFS + pad;
          var cw    = w;
          var ch    = h + footH;
          var c     = document.createElement('canvas');
          c.width = cw; c.height = ch;
          var ctx = c.getContext('2d');
          // Donkere achtergrond
          ctx.fillStyle = '#0d0716';
          ctx.fillRect(0, 0, cw, ch);
          ctx.drawImage(img, 0, 0, w, h);
          // Solid donker-paars (rustiger dan gradient)
          ctx.fillStyle = '#15092a';
          ctx.fillRect(0, h, cw, footH);
          // Caption (wit, niet te zwaar)
          ctx.fillStyle = '#ffffff';
          ctx.font = '500 ' + capFS + 'px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
          ctx.textBaseline = 'top';
          ctx.textAlign = 'left';
          var cap = captionText || '';
          var maxW = cw - pad*2;
          while(ctx.measureText(cap).width > maxW && cap.length > 10){
            cap = cap.slice(0, -2);
          }
          if(cap !== (captionText||'')) cap += '…';
          ctx.fillText(cap, pad, h + pad);
          // URL (subtiel paars)
          ctx.fillStyle = '#9d7fd9';
          ctx.font = '400 ' + urlFS + 'px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
          var urlText = (shareUrl || '').replace(/^https?:\/\//, '');
          while(ctx.measureText(urlText).width > maxW && urlText.length > 10){
            urlText = urlText.slice(0, -2);
          }
          ctx.fillText(urlText, pad, h + pad + capFS + gap);
          c.toBlob(function(blob){
            if(!blob){ resolve(null); return; }
            var file = new File([blob], nm + '.jpg', { type: 'image/jpeg' });
            if(navigator.canShare && navigator.canShare({ files:[file] })) resolve(file);
            else resolve(null);
          }, 'image/jpeg', 0.92);
        } catch(_){ resolve(null); }
      };
      img.onerror = function(){
        // CORS fail of network → fallback naar raw blob zonder caption
        fetch(imgUrl, { mode:'cors' })
          .then(function(res){ return res.ok ? res.blob() : null; })
          .then(function(blob){
            if(!blob){ resolve(null); return; }
            var ext = ((blob.type||'image/jpeg').split('/')[1] || 'jpg').replace('jpeg','jpg');
            var file = new File([blob], nm + '.' + ext, { type: blob.type || 'image/jpeg' });
            if(navigator.canShare && navigator.canShare({ files:[file] })) resolve(file);
            else resolve(null);
          })
          .catch(function(){ resolve(null); });
      };
      img.src = imgUrl;
    } catch(_){ resolve(null); }
  });
}

// Native share (Web Share API) — opent OS-share-sheet (WhatsApp/Discord/Mail/...).
// Probeert eerst foto + caption (Web Share Level 2). Fallback: alleen url/text.
window.cwcrNativeShareCard = function(e){
  if(e) e.stopPropagation();
  var btn=(e && e.currentTarget && e.currentTarget.tagName) ? e.currentTarget : document.getElementById('cwcr-share-btn');
  var Ta=window.CWPD_I18N||{};
  function _fb(msg){if(btn){var o=btn.innerHTML;btn.textContent=msg;setTimeout(function(){btn.innerHTML=o;},2000);}}
  var data=_cwcrBuildShareData();
  try{if(window.cwTrack)window.cwTrack('share',{method:navigator.share?'native_share':'copy_link_fallback',content_type:'pricedex_card',item_id:(data&&data.title)||'',location:'card_grid'});}catch(_){}
  var text=data.text;
  if(!navigator.share){
    _cwcrCopyToClipboard(data.url).then(function(){_fb(Ta.copied||'Gekopieerd!');}).catch(function(){_fb(Ta.copyFailed||'Mislukt');});
    return;
  }
  _cwcrBuildShareFile(text, data.url).then(function(file){
    var payload;
    if(file){
      // WhatsApp/Telegram/Signal negeren url+title als files meegaan — plak url in text.
      payload = { text: text + '\n\n' + data.url, files: [file] };
    } else {
      // URL-only: laat url+text apart staan zodat WhatsApp OG link-preview rendert.
      payload = { text: text + '\n', url: data.url };
    }
    navigator.share(payload).catch(function(err){
      if(err && (err.name==='AbortError' || err.message==='AbortError')) return;
      if(file){
        navigator.share({ text: text, url: data.url }).catch(function(err2){
          if(err2 && (err2.name==='AbortError' || err2.message==='AbortError')) return;
          _cwcrCopyToClipboard(data.url).then(function(){_fb(Ta.copied||'Gekopieerd!');}).catch(function(){_fb(Ta.copyFailed||'Mislukt');});
        });
      } else {
        _cwcrCopyToClipboard(data.url).then(function(){_fb(Ta.copied||'Gekopieerd!');}).catch(function(){_fb(Ta.copyFailed||'Mislukt');});
      }
    });
  });
};

// Kopieer kaartlink naar clipboard (modal button "Kopieer kaartlink")
window.cwcrCopyCardLink = function(e){
  if(e) e.stopPropagation();
  var btn=(e && e.currentTarget && e.currentTarget.tagName) ? e.currentTarget : document.getElementById('cwcr-modal-share-btn');
  var Ta=window.CWPD_I18N||{};
  function _fb(msg){if(btn){var o=btn.innerHTML;btn.textContent=msg;setTimeout(function(){btn.innerHTML=o;},2000);}}
  var data=_cwcrBuildShareData();
  try{if(window.cwTrack)window.cwTrack('share',{method:'copy_link',content_type:'pricedex_card',item_id:(data&&data.title)||'',location:'card_modal'});}catch(_){}
  _cwcrCopyToClipboard(data.url).then(function(){_fb(Ta.copied||'Gekopieerd!');}).catch(function(){_fb(Ta.copyFailed||'Mislukt');});
};

// Legacy alias — bestaande callers blijven werken
window.cwcrShareCard = window.cwcrNativeShareCard;
if(detailClose) detailClose.addEventListener('click',closeCardDetail);
if(detailOverlay){
detailOverlay.addEventListener('click',function(e){
if(e.target===detailOverlay) closeCardDetail();
});
}
document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeCardDetail(); });
(function(){
var navEntry=performance.getEntriesByType&&performance.getEntriesByType('navigation')[0];
var navType=navEntry?navEntry.type:(performance.navigation&&performance.navigation.type===2?'back_forward':null);
if(navType==='back_forward') return;
var params=new URLSearchParams(window.location.search);
var reopenRaw=params.get('cwcr_reopen');
if(!reopenRaw) return;
try {
var reopenData=JSON.parse(reopenRaw);
var reopenIdx=reopenData.idx!==undefined?parseInt(reopenData.idx,10):NaN;
var reopenSlug=reopenData.slug||'';
var reopenFr=reopenData.fr || 'pokemon';
var reopenSetId=reopenData.setId || null;
var reopenSetName=reopenData.setName || '';
activeFranchise=reopenFr;
var _rTabs=document.getElementById('cwcr-tabs');
if(_rTabs){_rTabs.querySelectorAll('.cwcr-tab').forEach(function(t){var s=t.dataset.franchise===reopenFr;t.classList.toggle('cwcr-tab-active',s);t.setAttribute('aria-selected',String(s));});}
// Set-rij zichtbaar maken net als bij een normale franchise-keuze (regel ~244). Zonder dit
// blijft #cwcr-set-row gehide bij binnenkomst via een reopen-link, ook al is de franchise actief.
var _rSetRow=document.getElementById('cwcr-set-row');
if(_rSetRow) _rSetRow.classList.add('cwcr-set-row-visible');
// Sets-lijst (dropdown + sidebar-filter) laden voor de gekozen franchise. Zonder dit
// bleef "Sets ophalen..." hangen en "Kies eerst een franchise..." staan bij binnenkomst
// via een set-reopen link (de set-pagina knop), want loadSets werd nooit getriggerd.
if(typeof loadSets==='function') loadSets(reopenFr);
// Ook de shop-producten van de franchise laden (matching-product highlight + sticky bar),
// net als bij een normale franchise-keuze, zodat de reopen-ervaring identiek is.
if(typeof loadFranchiseProducts==='function') loadFranchiseProducts(reopenFr);
if(reopenSetId){
activeSetId=reopenSetId;
activeSetName=reopenSetName;
if(typeof cwcrUpdateDdLabel==='function') cwcrUpdateDdLabel();
// Sectie-titel + sticky bar zetten op de setnaam, net als bij een normale set-keuze
// via cwcrSelectFromDd. Zonder dit blijft de titel op "Alle kaarten" hangen bij
// binnenkomst via een directe SEO-link (/apps/kaarten/pokemon/aquapolis/...).
if(reopenSetName){
if(typeof showStickyBar==='function') showStickyBar(reopenSetName);
else if(typeof setSectionTitle==='function') setSectionTitle(reopenSetName);
}
setTimeout(function(){
if(reopenFr==='onepiece') fetchOnePiece(reopenSetId);
else fetchPokemon(reopenSetId);
},200);
}
var _mkReopenSlug=function(c,fr){
var isOp=(fr==='onepiece');
var n=isOp?(c.name||c.card_name||''):(c.name||'');
var num=isOp?(c.card_id||c.id||''):(c.number||'');
var np=(n||'').toLowerCase().replace(/[.\s]+/g,'-').replace(/[^a-z0-9-]/g,'').replace(/-+/g,'-').replace(/^-|-$/g,'');
var nump=(num||'').toLowerCase().replace(/[^a-z0-9-]/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
var cmp=isOp&&c.cardmarket_id?String(c.cardmarket_id):'';
return (np+(nump?'-'+nump:'')+(cmp?'-'+cmp:'')).slice(0,80)||'kaart';
};
var _mkReopenSlugLegacy=function(c,fr){
var isOp=(fr==='onepiece');
var n=isOp?(c.name||c.card_name||''):(c.name||'');
var num=isOp?(c.card_id||c.id||''):(c.number||'');
var np=(n||'').toLowerCase().replace(/[.\s]+/g,'-').replace(/[^a-z0-9-]/g,'').replace(/-+/g,'-').replace(/^-|-$/g,'');
var nump=(num||'').toLowerCase().replace(/[^a-z0-9-]/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
return (np+(nump?'-'+nump:'')).slice(0,80)||'kaart';
};
// Deterministische winnaar bij meerdere slug-matches: kies de laagste card.id
// (string-vergelijking). IDENTIEK aan de server (_pdFindPkCardIdx) zodat de SPA-reopen
// dezelfde Pokemon-variant opent als de server-render bij een naam+nummer collisie.
// Voor One Piece is de cmId-suffix al uniek, dus daar is er nooit meer dan 1 match.
var _pickDeterministic=function(reg,slug,fr,mkSlug){
var bestIdx=-1,bestId=null;
for(var i=0;i<reg.length;i++){
if(mkSlug(reg[i],fr)!==slug) continue;
var id=String(reg[i].id||reg[i].card_id||'');
if(bestIdx<0 || id<bestId){bestIdx=i;bestId=id;}
}
return bestIdx<0?null:{card:reg[bestIdx],idx:bestIdx};
};
var _searchRegistry=function(reg,slug,fr){
if(!reg || !reg.length) return null;
var hit=_pickDeterministic(reg,slug,fr,_mkReopenSlug);
if(hit) return hit;
// Backwards compat: probeer zonder cmId suffix (voor oude gedeelde URLs)
hit=_pickDeterministic(reg,slug,fr,_mkReopenSlugLegacy);
if(hit) return hit;
// Name+cmId fallback — server's TCG cache heeft soms lege card_number maar wel
// cardmarket_id, dus server emits "name-cmId" terwijl client met volledige card_id
// "name-id-cmId" zou maken. Voor One Piece dus altijd ook deze variant proberen.
for(var m=0;m<reg.length;m++){
var cm=reg[m];
var isOpM=(fr==='onepiece');
if(!isOpM || !cm.cardmarket_id) continue;
var nm=cm.name||cm.card_name||'';
var npm=nm.toLowerCase().replace(/[.\s]+/g,'-').replace(/[^a-z0-9-]/g,'').replace(/-+/g,'-').replace(/^-|-$/g,'');
if((npm+'-'+String(cm.cardmarket_id)).slice(0,80)===slug) return {card:reg[m],idx:m};
}
// Name-only fallback — server's slug kan zonder nummer zijn (data-discrepantie:
// server's TCG cache heeft soms lege card_number, client's data wel) → match
// uitsluitend op slugified name als laatste redmiddel. ALLEEN als de naam UNIEK is
// in de registry: anders zou findIndex stil de eerste (price-sorted = duurste) kaart
// met die naam openen i.p.v. de bedoelde variant. Bij 2+ matches → null (geen gok).
var _nameOnlyHit=null,_nameOnlyCount=0;
for(var k=0;k<reg.length;k++){
var c=reg[k];
var isOp=(fr==='onepiece');
var n=isOp?(c.name||c.card_name||''):(c.name||'');
var np=(n||'').toLowerCase().replace(/[.\s]+/g,'-').replace(/[^a-z0-9-]/g,'').replace(/-+/g,'-').replace(/^-|-$/g,'');
if(np===slug){ _nameOnlyCount++; if(!_nameOnlyHit) _nameOnlyHit={card:reg[k],idx:k}; }
}
if(_nameOnlyCount===1) return _nameOnlyHit;
return null;
};
// Alleen een kaart proberen te openen als de reopen-data daadwerkelijk een kaart
// aanwijst (slug of idx). De set-pagina knop stuurt enkel {fr,setId} → dan is de set
// hierboven al geladen en hoeven we GEEN tryOpen-loop te draaien (die bleef anders 60x
// draaien = 15s "Kaart laden" loader voor niets).
var _wantsCard=!!reopenSlug || !isNaN(reopenIdx);
var attempts=0;
var tryOpen=_wantsCard?setInterval(function(){
attempts++;
var registry=cwcrCardRegistry[reopenFr];
var bulkReg=cwcrCardRegistry[reopenFr+'-bulk'];
// Wacht tot OF chase registry OF bulk registry geladen is — client splitst de
// volledige set namelijk in 2 arrays (chase + bulk), en server's idx wijst naar
// de volle set die client niet heeft.
if((registry && registry.length>0) || (bulkReg && bulkReg.length>0)){
var found=null,foundIdx=-1;
// Slug krijgt voorrang op idx — idx is onbetrouwbaar omdat client's registry
// (chase only) en bulkReg ≠ server's volle cards array. Slug is intrinsiek uniek.
if(reopenSlug){
// Zoek over chase + bulk GECOMBINEERD zodat de deterministische tie-break (laagste id)
// de GLOBALE winnaar kiest, identiek aan de server die de volle set doorzoekt. Zou je
// chase eerst en dan pas bulk doorzoeken (short-circuit), dan kon een collisie-variant
// in de andere bucket een andere kaart opleveren dan de server-render. openCardDetail
// gebruikt het card-object zelf; de idx wijst naar de registry waar de kaart in zit.
var _combined=[];
if(registry) for(var _ci=0;_ci<registry.length;_ci++) _combined.push({c:registry[_ci],reg:registry,idx:_ci});
if(bulkReg) for(var _bi=0;_bi<bulkReg.length;_bi++) _combined.push({c:bulkReg[_bi],reg:bulkReg,idx:_bi});
var _flat=_combined.map(function(e){return e.c;});
var hit=_searchRegistry(_flat,reopenSlug,reopenFr);
if(hit){var _entry=_combined[hit.idx];found=_entry.c;foundIdx=_entry.idx;}
}
// Idx fallback ALLEEN voor oude URLs zonder slug (backwards compat). Bij nieuwe
// URLs met slug NIET meer fallback op idx, anders krijg je verkeerde kaart als
// slug niet matched (registry[idx] wijst naar andere card dan server bedoelde).
if(!found && !reopenSlug && !isNaN(reopenIdx) && registry && registry[reopenIdx]!==undefined){
found=registry[reopenIdx];foundIdx=reopenIdx;
}
if(found){
clearInterval(tryOpen);
if(window._cwcrHideCardLoader) window._cwcrHideCardLoader();
if(!window._cwcrPreModalUrl) window._cwcrPreModalUrl=window.location.pathname;
openCardDetail(found,reopenFr,foundIdx);
}
}
if(attempts>60){clearInterval(tryOpen);if(window._cwcrHideCardLoader) window._cwcrHideCardLoader();window.history.replaceState({},'',window.location.pathname);}
},250):null;
// Set-only reopen (geen kaart): loader sowieso verbergen + URL opschonen, set is al aan het laden.
if(!_wantsCard){ if(window._cwcrHideCardLoader) window._cwcrHideCardLoader(); window.history.replaceState({},'',window.location.pathname); }
} catch(e){}
})();
if(grid){
grid.addEventListener('click',function(e){
var detailBtn=e.target.closest('.cwcr-card-detail-btn');
var card=e.target.closest('.cwcr-chase-img-card');
if(!card) return;
e.preventDefault();
var idx=parseInt(card.dataset.cardIdx,10);
var franchise=(detailBtn ? detailBtn.dataset.franchise : card.dataset.franchise) || activeFranchise;
var registry=cwcrCardRegistry[franchise];
if(!isNaN(idx) && registry && registry[idx]!==undefined){
openCardDetail(registry[idx],franchise,idx);
}
});
}
function _bulkCardHTML(c, idx, franchise){
var name,price,number,link,rarLabel,rarInfo;
if(franchise==='pokemon'){
name = c.name || '';
price = c._price || 0;
number = c.number || '';
rarLabel = c.rarity || '';
link = pkCardmarkUrl(c,name);
rarInfo = pkRarity[rarLabel] || { label: rarLabel,cls: 'cwcr-badge-other' };
}else{
name = c.name || c.card_name || '';
price = c._price || parseFloat(c.price || c.market_price || 0) || 0;
number = c.card_id || c.id || '';
rarLabel = c.rarity || '';
link = c.cardmarket_url || '';
rarInfo = opRarity[rarLabel] || { label: rarLabel,cls: 'cwcr-badge-other' };
}
var avg7b=c.cardmarket && c.cardmarket.prices ? (c.cardmarket.prices.avg7 || 0) : 0;
var h='';
h += '<div class="cwcr-chase-img-card cwcr-bulk-card" data-card-idx="' + idx + '" data-franchise="' + esc(franchise + '-bulk') + '"' + (link ? ' data-href="' + esc(link) + '"' : '') + '>';
h += '<div class="cwcr-chase-img-topbar">' + (rarLabel ? '<span class="cwcr-chase-img-badge ' + rarInfo.cls + '" title="' + esc(rarInfo.label) + '">' + cwcrBadgeInner(rarInfo) + '</span>' : '<span></span>') + (number ? '<span class="cwcr-chase-img-topnum">#' + esc(number) + '</span>' : '') + '</div>';
h += '<div class="cwcr-chase-img-wrap cwcr-img-loading">';
h += cwcrCardImgHtml(c, franchise, name);
h += '</div><div class="cwcr-chase-img-info">';
h += '<div class="cwcr-chase-img-name">' + esc(name) + '</div>';
if(price && price>0){
h += '<div class="cwcr-chase-img-pricerow"><div class="cwcr-chase-img-price">\u20ac' + parseFloat(price).toFixed(2) + '</div></div>';
if(avg7b>0 && Math.abs(price - avg7b)>0.01){
var bdelta=price - avg7b;
var bcls=bdelta>0.01 ? 'cwcr-avg7-up' : 'cwcr-avg7-down';
var barrow=bdelta>0.01 ? '\u2191' : '\u2193';
var bpct=Math.round(bdelta / avg7b * 100);
h += '<div class="cwcr-chase-img-avg7 ' + bcls + '">' + barrow + ' \u20ac' + Math.abs(bdelta).toFixed(2) + ' (' + (bpct>0?'+':'') + bpct + '%)</div>';
}
}
h += '<button class="cwcr-card-detail-btn" data-card-idx="' + idx + '" data-franchise="' + esc(franchise + '-bulk') + '">' + ((window.CWPD_I18N && window.CWPD_I18N.viewAnalysis) || 'Bekijk analyse') + '</button>';
h += '</div></div>';
return h;
}
function buildBulkHtml(bulkCards,franchise){
var html='';
for(var i=0; i<bulkCards.length; i++) html += _bulkCardHTML(bulkCards[i], i, franchise);
return html;
}
function updateBulkGrid(filteredBulk,franchise){
var bulkGrid=document.getElementById('cwcr-bulk-grid');
var bulkCountEl=document.getElementById('cwcr-bulk-count');
if(!bulkGrid) return;
cwcrCardRegistry[franchise + '-bulk'] = filteredBulk;
if(bulkCountEl) bulkCountEl.textContent = filteredBulk.length + ' kaarten';
cwcrRenderChunked(bulkGrid, filteredBulk, function(c, idx){ return _bulkCardHTML(c, idx, franchise); });
}
function renderBulkSection(bulkCards,franchise){
var bulkGrid=document.getElementById('cwcr-bulk-grid');
var bulkCountEl=document.getElementById('cwcr-bulk-count');
var bulkSubheader=document.getElementById('cwcr-bulk-sub-toggle');
var sidebarBulkEl=document.getElementById('cwcr-sidebar-bulk-num');
var sidebarBulkWrap=document.getElementById('cwcr-sidebar-bulk-count');
if(!bulkCards || !bulkCards.length){
if(bulkSubheader) bulkSubheader.style.display='none';
if(bulkGrid) bulkGrid.style.display='none';
return;
}
if(bulkSubheader) bulkSubheader.style.display='';
bulkSortByPrice=true;
chaseSortByPrice=true;
var _bsb=document.getElementById('cwcr-bulk-sort-btn');
if(_bsb){_bsb.textContent='\u2195 Prijs';_bsb.classList.add('cwcr-sort-price');}
var _csb=document.getElementById('cwcr-chase-sort-btn');
if(_csb){_csb.textContent='\u2195 Prijs';_csb.classList.add('cwcr-sort-price');}
if(bulkCountEl) bulkCountEl.textContent = bulkCards.length + ' kaarten';
if(sidebarBulkEl) sidebarBulkEl.textContent = bulkCards.length;
if(sidebarBulkWrap) sidebarBulkWrap.style.display=bulkCards.length ? '' : 'none';
if(!bulkGrid) return;
cwcrCardRegistry[franchise + '-bulk'] = bulkCards;
cwcrRenderChunked(bulkGrid, bulkCards, function(c, idx){ return _bulkCardHTML(c, idx, franchise); });
if(!bulkGrid._cwcrBound){
bulkGrid._cwcrBound=true;
bulkGrid.addEventListener('click',function(e){
var card=e.target.closest('.cwcr-chase-img-card');
if(!card) return;
e.preventDefault();
var idx=parseInt(card.dataset.cardIdx,10);
var fr=card.dataset.franchise || (franchise + '-bulk');
var registry=cwcrCardRegistry[fr];
if(!isNaN(idx) && registry && registry[idx]){
openCardDetail(registry[idx],activeFranchise);
}
});
}
}
function renderOnePiece(cards,counts,skipCache){
hideChaseLoading();
if(gridSection){ gridSection.style.display=''; gridSection.classList.add('cwcr-visible'); }
if(counts) renderRarityCounts(counts);
var chaseSubToggle=document.getElementById('cwcr-chase-sub-toggle');
if(!cards.length){
if(skipCache){
if(grid){ grid.innerHTML = ''; grid.style.display='none'; }
if(countEl) countEl.style.display='none';
if(chaseSubToggle) chaseSubToggle.style.display='none';
}else{
if(grid){ grid.innerHTML = '<div class="cwcr-chase-empty">Geen kaarten met prijsdata gevonden voor deze set.</div>'; grid.style.display=''; }
}
return;
}
var activeRarOP=Object.keys(sidebarRarities).find(function(k){ return sidebarRarities[k]; });
var rarLabelOP=activeRarOP ? ((opRarity[activeRarOP] || {label: activeRarOP}).label + ' ') : '';
// In search-mode tonen we ALLE matches, anders top 10
var _isSearchOP=(typeof unifiedSearch!=='undefined' && unifiedSearch && unifiedSearch.value && unifiedSearch.value.trim().length>=2);
var top10op=_isSearchOP ? cards : cards.slice(0,10);
if(countEl){ countEl.textContent = ((window.CWPD_I18N && window.CWPD_I18N.topOfCards) || 'top {top} van {total} {rarLabel}kaarten').replace('{top}', top10op.length).replace('{total}', cards.length).replace('{rarLabel}', rarLabelOP); countEl.style.display=''; }
if(chaseSubToggle) chaseSubToggle.style.display='';
var html='';
top10op.forEach(function(c,idx){
var info=opRarity[c.rarity] || { label: c.rarity || '?',cls: 'cwcr-badge-other' };
var name=c.name || c.card_name || '';
var price=c._price || parseFloat(c.price || c.market_price || c.value || 0) || null;
var avg7op=c.cardmarket && c.cardmarket.prices ? (c.cardmarket.prices.avg7 || 0) : 0;
var apiImg=c.image_url || c.image || c.card_image || c.img || c.picture ||
 (c.images && (c.images.en || c.images.ja || c.images.url)) || '';
var cardId=c.card_id || c.id || '';
if(!cardId && apiImg){
var m=apiImg.match(/\/([A-Z]{2,4}\d+-\d+)(?:_|\.)/i);
if(m) cardId = m[1].toUpperCase();
}
if(cardId && !c.card_id) c.card_id = cardId;
// Image-resolutie + fallback-cascade gebeurt nu centraal in cwcrCardImgHtml (zie cwcrResolveCardImg).
var cmLink=opCardmarkUrl(c,cardId,name);
var min5=filterMin5 && filterMin5.checked;
var hidden=(min5 && (!price || price<5)) ? ' cwcr-hidden' : '';
var tierCls=info.tier ? ' cwcr-op-tier-' + info.tier : '';
html += '<div class="cwcr-chase-img-card' + tierCls + hidden + '" data-card-idx="' + idx + '" data-franchise="onepiece"' + (cmLink ? ' data-href="' + esc(cmLink) + '"' : '') + '>';
html += '<div class="cwcr-chase-img-topbar"><span class="cwcr-chase-img-badge ' + info.cls + '" title="' + esc(info.label) + '">' + cwcrBadgeInner(info) + '</span>' + (cardId ? '<span class="cwcr-chase-img-topnum">#' + esc(cardId) + '</span>' : '') + '</div>';
html += '<div class="cwcr-chase-img-wrap cwcr-img-loading">';
html += cwcrCardImgHtml(c, 'onepiece', name);
html += '</div><div class="cwcr-chase-img-info">';
html += '<div class="cwcr-chase-img-name">' + esc(name) + '</div>';
if(price && price>0){
html += '<div class="cwcr-chase-img-pricerow"><div class="cwcr-chase-img-price">\u20ac' + price.toFixed(2) + '</div></div>';
if(avg7op>0 && Math.abs(price - avg7op)>0.01){
var delta=price - avg7op;
var cls=delta>0.01 ? 'cwcr-avg7-up' : 'cwcr-avg7-down';
var arrow=delta>0.01 ? '\u2191' : '\u2193';
var pct=Math.round(delta / avg7op * 100);
html += '<div class="cwcr-chase-img-avg7 ' + cls + '">' + arrow + ' \u20ac' + Math.abs(delta).toFixed(2) + ' (' + (pct>0?'+':'') + pct + '%)</div>';
}
}
html += '<button class="cwcr-card-detail-btn" data-card-idx="' + idx + '" data-franchise="onepiece">' + ((window.CWPD_I18N && window.CWPD_I18N.viewAnalysis) || 'Bekijk analyse') + '</button>';
html += '</div></div>';
});
if(grid){ grid.innerHTML = html; grid.style.display=''; }
cwcrCardRegistry['onepiece'] = cards;
}
// geen pre-selectie op pageload

// ── Mobile filter panel (bottom sheet) ─────────────────────────────────────
(function(){
  var mobileBtn=document.getElementById('cwcr-mobile-filter-btn');
  var panel=document.getElementById('cwcr-mobile-filter-panel');
  var overlay=document.getElementById('cwcr-mobile-filter-overlay');
  var closeBtn=document.getElementById('cwcr-mobile-filter-close');
  var content=document.getElementById('cwcr-mobile-filter-content');
  var applyBtn=document.getElementById('cwcr-mobile-filter-apply-btn');
  var resetBtn2=document.getElementById('cwcr-mobile-filter-reset-btn');
  var badge=document.getElementById('cwcr-mobile-filter-badge');
  if(!mobileBtn||!panel) return;

  var filterHierarchy=document.querySelector('.cwcr-filter-hierarchy');
  var sidebarInner=document.getElementById('cwcr-sidebar-inner');
  var setRow=document.getElementById('cwcr-set-row');
  var fhPlaceholder=document.createComment('cwcr-fh-ph');
  var siPlaceholder=document.createComment('cwcr-si-ph');
  var srPlaceholder=document.createComment('cwcr-sr-ph');
  var panelPlaceholder=document.createComment('cwcr-panel-ph');
  var isOpen=false;
  var mobileAllMode=false;

  // Track collapsed state per franchise — standaard ingeklapt
  var mobileFrCollapsed={pokemon:true,onepiece:true};

  function buildMobileMultiFr(){
    if(!cwcrDdMenu) return;
    var se=cwcrDdMenu.querySelector('.cwcr-set-dd-search');
    Array.from(cwcrDdMenu.children).forEach(function(c){if(c!==se)cwcrDdMenu.removeChild(c);});
    var q=((se&&se.value)||'').toLowerCase().trim();
    var franchises=[
      {fr:'pokemon',name:'\uD83D\uDD34 Pok\u00E9mon',sets:cwcrSetsCache['pokemon']||[]},
      {fr:'onepiece',name:'\u2715 One Piece',sets:cwcrSetsCache['onepiece']||[]}
    ];
    var hasContent=false;
    franchises.forEach(function(fd){
      var sets=fd.sets;
      var filteredSets=q?sets.filter(function(s){return(s.label||'').toLowerCase().includes(q);}):sets;
      var collapsed=q?false:mobileFrCollapsed[fd.fr];
      var hdr=document.createElement('div');
      hdr.className='cwcr-set-dd-fr-header cwcr-fr-collapsible'+(collapsed?' cwcr-fr-collapsed':'');
      hdr.innerHTML='<span class="cwcr-fr-hdr-left"><span class="cwcr-fr-hdr-name">'+fd.name+'</span>'+(sets.length?'<span class="cwcr-fr-hdr-count">'+filteredSets.length+' sets</span>':'')+'</span><svg class="cwcr-fr-hdr-chev" viewBox="0 0 12 12" fill="none"><polyline points="2 4 6 8 10 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      cwcrDdMenu.appendChild(hdr);
      var body=document.createElement('div');
      body.className='cwcr-fr-dd-body';
      if(collapsed) body.style.display='none';
      (function(fr,h,b){
        h.addEventListener('click',function(){
          var isNowCollapsed=!mobileFrCollapsed[fr];
          mobileFrCollapsed[fr]=isNowCollapsed;
          h.classList.toggle('cwcr-fr-collapsed',isNowCollapsed);
          b.style.display=isNowCollapsed?'none':'';
        });
      })(fd.fr,hdr,body);
      if(!filteredSets.length&&sets.length){
        var noMatch=document.createElement('div');
        noMatch.className='cwcr-set-dd-empty';
        noMatch.textContent=(window.CWPD_I18N&&window.CWPD_I18N.noSets)||'Geen sets gevonden';
        body.appendChild(noMatch);
      } else {
        // Lege sets (count===0) naar onderaan
        var normalSets=filteredSets.filter(function(s){return s.count!==0;});
        var emptySets=filteredSets.filter(function(s){return s.count===0;});
        var withCode=normalSets.filter(function(s){return s.label.indexOf(' - ')>0;});
        var noCode=normalSets.filter(function(s){return s.label.indexOf(' - ')<=0;});
        var sorted=withCode.concat(noCode).concat(emptySets);
        var addedDivider=false;
        var emptyDividerAdded=false;
        sorted.forEach(function(s){
          var item=document.createElement('div');
          var isEmpty=s.count===0;
          var code='',name=s.label,di=s.label.indexOf(' - ');
          if(di>0){code=s.label.substring(0,di).trim();name=s.label.substring(di+3).trim();}
          // Scheidingslijn voor de eerste nocode entry
          if(!code&&!isEmpty&&!addedDivider&&withCode.length>0){
            addedDivider=true;
            var div=document.createElement('div');
            div.className='cwcr-set-dd-divider';
            body.appendChild(div);
          }
          // Scheidingslijn voor lege sets
          if(isEmpty&&!emptyDividerAdded&&(normalSets.length>0)){
            emptyDividerAdded=true;
            var divE=document.createElement('div');
            divE.className='cwcr-set-dd-divider';
            body.appendChild(divE);
          }
          item.className='cwcr-set-dd-item'+(!code?' cwcr-set-dd-item--nocode':'')+(s.id===activeSetId?' cwcr-dd-active':'')+(isEmpty?' cwcr-set-dd-item--empty':'');
          item.innerHTML=(code?'<span class="cwcr-set-dd-icode">'+esc(code)+'</span>':'')+'<span class="cwcr-set-dd-iname">'+esc(name)+'</span>';
          if(!isEmpty){
            (function(fr,sid,slabel){
              item.addEventListener('click',function(){cwcrSelectFromDd(fr,sid,slabel);});
            })(fd.fr,s.id,s.label);
          }
          body.appendChild(item);
          hasContent=true;
        });
      }
      cwcrDdMenu.appendChild(body);
    });
    if(!hasContent&&!q){
      var empty=document.createElement('div');
      empty.className='cwcr-set-dd-empty';
      empty.textContent=(window.CWPD_I18N&&window.CWPD_I18N.setsLoading)||'Sets laden...';
      cwcrDdMenu.appendChild(empty);
    }
    var anyLoaded=(cwcrSetsCache['pokemon']||[]).length>0||(cwcrSetsCache['onepiece']||[]).length>0;
    if(setsLoading) setsLoading.style.display=anyLoaded?'none':'';
  }

  var _origBuild=cwcrBuildDdMenu;
  cwcrBuildDdMenu=function(){
    if(mobileAllMode){ buildMobileMultiFr(); return; }
    _origBuild();
  };
  var _origOpenDd=cwcrOpenSetDd;
  cwcrOpenSetDd=function(){
    if(mobileAllMode){
      if(!cwcrDdMenu||!cwcrDdTrigger) return;
      cwcrDdMenu.classList.add('open');
      cwcrDdTrigger.classList.add('open');
      ['pokemon','onepiece'].forEach(function(fr){
        if(!(cwcrSetsCache[fr]||[]).length) cwcrLoadSetsLazy(fr);
      });
      cwcrBuildDdMenu();
      if(cwcrDdSearch) setTimeout(function(){cwcrDdSearch.focus();},40);
      return;
    }
    _origOpenDd();
  };

  function openPanel(){
    if(isOpen) return;
    isOpen=true;
    mobileAllMode=true;
    // setRow + sidebarInner zijn display:none op mobiel → verplaatsen vóór display:block geeft geen flash
    if(setRow&&setRow.parentNode){
      setRow.parentNode.insertBefore(srPlaceholder,setRow);
      content.appendChild(setRow);
    }
    if(sidebarInner&&sidebarInner.parentNode){
      sidebarInner.parentNode.insertBefore(siPlaceholder,sidebarInner);
      content.appendChild(sidebarInner);
      sidebarInner.classList.add('cwcr-open');
    }
    // Verplaats panel naar body zodat geen ancestor stacking context de z-index breekt
    if(panel.parentNode&&panel.parentNode!==document.body){
      panel.parentNode.insertBefore(panelPlaceholder,panel);
      document.body.appendChild(panel);
    }
    panel.classList.remove('is-closing');
    panel.style.display='block';
    document.body.style.overflow='hidden';
    // Double rAF: browser schildert eerst de begintoestand (translateY 100%), dan start de transitie
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        panel.classList.add('is-open');
      });
    });
    // Lazy loads NA animatiestart zodat cwcrBuildDdMenu (sync bij sessionStorage cache) geen reflow triggert
    setTimeout(function(){
      ['pokemon','onepiece'].forEach(function(fr){
        if(!(cwcrSetsCache[fr]||[]).length) cwcrLoadSetsLazy(fr);
      });
    },60);
  }

  function closePanel(){
    if(!isOpen) return;
    isOpen=false;
    mobileAllMode=false;
    cwcrCloseSetDd();
    // Animatie eerst, DOM-moves terug NA animatie zodat de sheet dichtglijdt mét inhoud
    panel.classList.add('is-closing');
    panel.classList.remove('is-open');
    document.body.style.overflow='';
    setTimeout(function(){
      panel.classList.remove('is-closing');
      panel.style.display='';
      // Panel terug naar originele positie
      if(panelPlaceholder.parentNode){
        panelPlaceholder.parentNode.insertBefore(panel,panelPlaceholder);
        panelPlaceholder.parentNode.removeChild(panelPlaceholder);
      }
      if(setRow&&srPlaceholder.parentNode){
        srPlaceholder.parentNode.insertBefore(setRow,srPlaceholder);
        srPlaceholder.parentNode.removeChild(srPlaceholder);
      }
      if(sidebarInner&&siPlaceholder.parentNode){
        siPlaceholder.parentNode.insertBefore(sidebarInner,siPlaceholder);
        siPlaceholder.parentNode.removeChild(siPlaceholder);
        sidebarInner.classList.remove('cwcr-open');
      }
    },400);
  }

  mobileBtn.addEventListener('click',openPanel);
  if(overlay) overlay.addEventListener('click',closePanel);
  if(closeBtn) closeBtn.addEventListener('click',closePanel);
  if(applyBtn) applyBtn.addEventListener('click',closePanel);
  if(resetBtn2) resetBtn2.addEventListener('click',function(){
    var r=document.getElementById('cwcr-sidebar-reset');
    if(r) r.click();
  });

  // Toepassen knop: toon resultaat-aantal
  function updateApplyCount(){
    if(!applyBtn) return;
    var n=cwcrLastFilteredCount||allCards.length;
    if(n>0){
      applyBtn.innerHTML=(((window.CWPD_I18N&&window.CWPD_I18N.apply)||'Toepassen'))+' <span class="cwcr-apply-count">'+n+' '+((window.CWPD_I18N&&window.CWPD_I18N.applyCards)||'kaarten')+'</span>';
    } else {
      applyBtn.textContent='Toepassen';
    }
  }
  // Patch applyFilters
  var _origApplyF=applyFilters;
  applyFilters=function(){
    _origApplyF.apply(this,arguments);
    updateApplyCount();
  };
  // MutationObserver voor initiële card-load
  var cardGrid=document.getElementById('cwcr-chase-img-grid');
  if(cardGrid){
    new MutationObserver(function(muts){
      var hasCards=muts.some(function(m){return m.addedNodes.length>0;});
      if(hasCards) updateApplyCount();
    }).observe(cardGrid,{childList:true});
  }

  // Badge: sync met actief filter-count
  var countEl=document.getElementById('cwcr-sidebar-active-count');
  if(countEl&&badge){
    function syncBadge(){
      var n=countEl.textContent.trim();
      var vis=countEl.style.display!=='none'&&n&&parseInt(n)>0;
      if(vis){badge.textContent=n;badge.style.display='';}
      else badge.style.display='none';
    }
    new MutationObserver(syncBadge).observe(countEl,{childList:true,characterData:true,subtree:true,attributes:true});
  }
})();

// ── Voeg toe aan collectie via gedeelde detail modal ─────────────────────────
var CWCR_COLL_API = CWCR_BASE_URL;

function cwcrShowCollToast(msg, type) {
  var t = document.getElementById('cwcr-coll-toast');
  var _cwcrLight = document.documentElement.classList.contains('cwcr-theme-light');
  var _toastInfoBg = _cwcrLight ? '#1d1330' : '#1a063e';
  if (!t) {
    t = document.createElement('div');
    t.id = 'cwcr-coll-toast';
    t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(80px);background:' + _toastInfoBg + ';color:#fff;padding:12px 20px;border-radius:10px;font-size:14px;font-weight:500;z-index:99999;box-shadow:0 4px 20px rgba(0,0,0,.3);transition:transform .3s ease;pointer-events:none;white-space:nowrap;font-family:Outfit,sans-serif;';
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.style.background = type === 'error' ? '#dc2626' : type === 'success' ? '#16a34a' : _toastInfoBg;
  t.style.transform = 'translateX(-50%) translateY(80px)';
  t.offsetHeight; // eslint-disable-line no-unused-expressions
  t.style.transform = 'translateX(-50%) translateY(0)';
  clearTimeout(t._timer);
  t._timer = setTimeout(function () {
    t.style.transform = 'translateX(-50%) translateY(80px)';
  }, 3500);
}

function cwcrOpenCollectionModal(evt) {
  if (evt) evt.stopPropagation();

  var _Tco=window.CWPD_I18N||{};
  if (!cwcrIsLoggedIn || !cwcrCustomer) {
    cwcrShowCollToast((_Tco.enterForInventory||'Log eerst in om kaarten toe te voegen'), 'error');
    return;
  }
  if (!cwcrHmacToken) {
    cwcrShowCollToast((_Tco.sessionExpired||'Sessie verlopen, herlaad de pagina'), 'error');
    return;
  }

  var card     = typeof cwcrPaywallCardObj    !== 'undefined' ? cwcrPaywallCardObj    : null;
  var franchise = typeof cwcrPaywallFranchise !== 'undefined' ? cwcrPaywallFranchise : null;
  var isOp     = franchise === 'onepiece';
  /* set_id fallback: activeSetId is leeg als kaart via search is geopend.
     Val dan terug op card-level velden. */
  var setId    = activeSetId
                 || (card && (card._setId || card.set_id))
                 || (card && card.set && card.set.id)
                 || '';

  if (!card) {
    cwcrShowCollToast((_Tco.noCardSelected||'Geen kaart geselecteerd'), 'error');
    return;
  }

  var cardName    = isOp ? (card.name || card.card_name || '') : (card.name || '');
  var cardNumber  = isOp
    ? (card.card_id || card.card_number || card.number || card.id || '')
    : (card.number || card.card_number || '');
  /* Zelfde resolver als de grids/modal zodat collection-thumbnails ook de
     deterministische fallback krijgen (PK pokemontcg.io / OP limitless). */
  var imageUrl    = cwcrResolveCardImg(card, isOp ? 'onepiece' : 'pokemon').src
    || (isOp ? (card.image_url || card.image || card.card_image || card.img || '')
             : (card.images ? (card.images.large || card.images.small || '') : ''));
  var cardmarketId = card.cardmarket_id || (card.cardmarket && card.cardmarket.productId ? String(card.cardmarket.productId) : null) || null;
  /* Prijzen meegeven zodat cwcdm-modal het prijsblok kan vullen (was --/--/--) */
  var cmPrices = (card.cardmarket && card.cardmarket.prices) ? card.cardmarket.prices : {};
  var cardmarketUrl = (card.cardmarket && card.cardmarket.url) || card.cardmarket_url || '';

  // Bouw genormaliseerde kaartdata
  var normalizedCard = {
    card_name:     cardName,
    card_number:   String(cardNumber),
    set_id:        setId,
    franchise:     franchise,
    image_url:     imageUrl || null,
    cardmarket_id: cardmarketId,
    cardmarket_url: cardmarketUrl,
    price_nm:      cmPrices.lowestNearMint || 0,
    price_trend:   cmPrices.trendPrice || 0,
    price_avg:     cmPrices.averageSellPrice || cmPrices.avg7 || cmPrices.avg30 || 0
  };

  // Laad lijsten als CWCardDetail beschikbaar is
  if (!window.CWCardDetail) {
    cwcrShowCollToast((_Tco.collectionModuleMissing||'Collectie module niet geladen'), 'error');
    return;
  }

  // Haal lijsten op
  var apiBase = (typeof cwcrApiUrl !== 'undefined' && cwcrApiUrl) ? cwcrApiUrl.replace(/\/$/, '') : CWCR_COLL_API;
  var authQS = 'cid=' + encodeURIComponent(cwcrCustomer.id) +
               '&email=' + encodeURIComponent(cwcrCustomer.email) +
               '&token=' + encodeURIComponent(cwcrHmacToken);

  fetch(apiBase + '/api/cw/collection/lists?' + authQS)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var lists        = data.lists || [];
      var defaultListId = data.default_list_id || (lists[0] ? lists[0].id : null);

      window.CWCardDetail.open({
        card:    normalizedCard,
        mode:    'pricedex',
        listId:  defaultListId,
        lists:   lists,
        onSave:  function (result) {
          if (result.action === 'add') {
            var payload = {
              cid:           String(cwcrCustomer.id),
              email:         cwcrCustomer.email,
              token:         cwcrHmacToken,
              franchise:     franchise,
              set_id:        setId,
              card_number:   String(cardNumber),
              card_name:     cardName,
              image_url:     imageUrl || null,
              cardmarket_id: cardmarketId,
              qty:           result.fields.qty || 1,
              condition:     result.fields.condition || 'NM',
              purchase_price: result.fields.purchase_price || null,
              list_id:        result.fields.list_id || defaultListId
            };
            fetch(apiBase + '/api/cw/collection/items', {
              method:  'POST',
              headers: { 'Content-Type': 'application/json' },
              body:    JSON.stringify(payload)
            })
              .then(function (r) { return r.json(); })
              .then(function (d) {
                if (typeof result.done === 'function') result.done();
                if (d.item) {
                  cwcrShowCollToast(cardName + ' ' + (_Tco.cardAdded||'toegevoegd aan je collectie!'), 'success');
                  if (typeof cwcrTrack === 'function') {
                    cwcrTrack('collection_add', { name: cardName, franchise: franchise, set: setId, card_number: String(cardNumber) });
                  }
                  window.CWCardDetail.close();
                } else {
                  cwcrShowCollToast(d.error || (_Tco.couldNotAdd||'Kon kaart niet toevoegen'), 'error');
                }
              })
              .catch(function () {
                if (typeof result.done === 'function') result.done();
                cwcrShowCollToast((_Tco.networkError||'Netwerkfout, probeer opnieuw'), 'error');
              });
          } else if (result.action === 'new_list') {
            cwcrShowCollToast((_Tco.goToCollectionTracker||'Ga naar Collection Tracker om een nieuwe lijst aan te maken'), 'success');
          }
        }
      });
    })
    .catch(function () {
      // Geen lijsten geladen: toch modal openen zonder lijst picker
      window.CWCardDetail.open({
        card:   normalizedCard,
        mode:   'pricedex',
        listId: null,
        lists:  [],
        onSave: function (result) {
          if (result.action === 'add') {
            var payload = {
              cid:           String(cwcrCustomer.id),
              email:         cwcrCustomer.email,
              token:         cwcrHmacToken,
              franchise:     franchise,
              set_id:        setId,
              card_number:   String(cardNumber),
              card_name:     cardName,
              image_url:     imageUrl || null,
              cardmarket_id: cardmarketId,
              qty:           result.fields.qty || 1,
              condition:     result.fields.condition || 'NM',
              purchase_price: result.fields.purchase_price || null
            };
            fetch(apiBase + '/api/cw/collection/items', {
              method:  'POST',
              headers: { 'Content-Type': 'application/json' },
              body:    JSON.stringify(payload)
            })
              .then(function (r) { return r.json(); })
              .then(function (d) {
                if (typeof result.done === 'function') result.done();
                if (d.item) {
                  cwcrShowCollToast(cardName + ' ' + (_Tco.cardAddedShort||'toegevoegd!'), 'success');
                  window.CWCardDetail.close();
                } else {
                  cwcrShowCollToast(d.error || (_Tco.couldNotAdd||'Kon kaart niet toevoegen'), 'error');
                }
              })
              .catch(function () {
                if (typeof result.done === 'function') result.done();
                cwcrShowCollToast((_Tco.networkError||'Netwerkfout'), 'error');
              });
          }
        }
      });
    });
}

// Expose inline-onclick handlers naar globale scope
window.cwcrOpenCollectionModal = cwcrOpenCollectionModal;
window.cwcrShowCollToast       = cwcrShowCollToast;
window.cwcrFilterChart         = cwcrFilterChart;
window.cwcrTogglePtSection = function(hdr){
  var body=hdr.nextElementSibling;
  if(!body) return;
  var isOpen=hdr.classList.toggle('cwcr-pt-open');
  body.classList.toggle('cwcr-pt-collapsed',!isOpen);
  var svg=hdr.querySelector('svg');
  if(svg) svg.style.transform=isOpen ? 'rotate(180deg)' : '';
};
window.cwcrTogglePriceTable = function(toggle){
  var inner=toggle.nextElementSibling;
  if(!inner) return;
  var nowCollapsed=inner.classList.toggle('cwcr-pt-inner-collapsed');
  var svg=toggle.querySelector('svg');
  if(svg) svg.style.transform=nowCollapsed ? '' : 'rotate(180deg)';
  var span=toggle.querySelector('span');
  var T=window.CWPD_I18N||{};
  if(span) span.textContent=nowCollapsed ? (T.showFullTable||'Toon volledige prijstabel') : (T.hideTable||'Verberg prijstabel');
};

})();
